const Br = {};
function jr() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this || Br;
}
const E = jr(), qr = "@YZ/";
function yt(t, e = qr) {
  return t.startsWith(e) ? t : `${e}${t}`;
}
function Mt(t) {
  return typeof t == "string" && t.startsWith("Symbol(") && t.endsWith(")");
}
function It(t) {
  return Mt(t) && (t = t.slice(7, -1)), t;
}
function Lt(t) {
  return t = It(t), t = yt(t), typeof Symbol == "function" ? Symbol(t) : `Symbol(${t})`;
}
const ge = Lt("TIMESTAMP"), ae = Lt("META");
function zr(t, e) {
  const n = e.toString();
  if (!Mt(n))
    return !1;
  if (t && typeof t == "object") {
    if (It(n) == "")
      return e in t;
    for (const r of Reflect.ownKeys(t))
      if (r.toString() == n)
        return !0;
    return !1;
  }
  return !1;
}
function rn(t) {
  if (!Mt(t))
    return t;
  switch (t = It(t), t) {
    case yt("TIMESTAMP"):
      return ge;
    case yt("META"):
      return ae;
    default:
      return Lt(t);
  }
}
function wt(t) {
  if (Array.isArray(t))
    return t.map(wt);
  if (t && typeof t == "object") {
    const e = {};
    for (const n of Reflect.ownKeys(t)) {
      const r = t[n];
      e[typeof n == "symbol" ? n.toString() : n] = typeof r == "symbol" ? r.toString() : wt(r);
    }
    return e;
  }
  return typeof t == "symbol" ? t.toString() : t;
}
function bt(t) {
  if (Array.isArray(t))
    return t.map(bt);
  if (t && typeof t == "object") {
    const e = {};
    for (const n of Object.keys(t))
      e[rn(n)] = bt(t[n]);
    return e;
  }
  return rn(t);
}
function Hr(t) {
  return JSON.stringify(wt(t));
}
const $t = Hr;
function Vr(t) {
  return bt(JSON.parse(t));
}
const a1 = Vr;
class Wr {
}
function Qe(t) {
  t || (t = E), Object.hasOwnProperty.call(t, ae) === !1 && Object.defineProperty(t, ae, {
    value: new Wr()
  });
  const e = {
    set: (n, r) => t[ae][n] = r,
    get: (n, r) => {
      const s = t[ae][n];
      return s === void 0 && r !== void 0 ? (e.set(n, r), r) : s;
    },
    delete: (n) => {
      delete t[ae][n];
    }
  };
  return e;
}
var W = /* @__PURE__ */ ((t) => (t.UNKNOWN = "", t.TEXT = "text/plain", t.MD = "text/plain", t.HTML = "text/html", t.XML_TEXT = "text/xml", t.CSS = "text/css", t.JPEG = "image/jpeg", t.PNG = "image/png", t.GIF = "image/gif", t.BMP = "image/bmp", t.WEBP = "image/webp", t.SVG = "image/svg+xml", t.ICON = "image/x-icon", t.MICROSOFT_ICON = "image/vnd.microsoft.icon", t.MPEG = "audio/mpeg", t.MP3 = "audio/mpeg", t.MP4 = "video/mp4", t.OGG = "audio/ogg", t.WAV = "audio/wav", t.MIDI = "audio/midi", t.WEBM = "video/webm", t.VIDEO_OGG = "video/ogg", t.OCTET_STREAM = "application/octet-stream", t.JAVASCRIPT = "application/javascript", t.ECMASCRIPT = "application/ecmascript", t.JSON = "application/json", t.XML = "application/xml", t.XHTML = "application/xhtml+xml", t.XWWW = "application/x-www-form-urlencoded", t.DOC = "application/msword", t.CSV = "application/x-csv", t.EXCEL = "application/vnb.ms-excel", t.PPT = "application/vnb.mspowerpoint", t.PDF = "application/pdf", t.ZIP = "application/zip", t.TGZ = "application/x-gtar", t.TAR_GZ = "application/x-gzip", t.EOT = "appliaction/vnd.ms-fontobject", t.TTF = "aplication/font-sfnt", t.PKCS12 = "aplication/pkcs12", t))(W || {}), Ue = /* @__PURE__ */ ((t) => (t.ascii = "ascii", t.utf8 = "utf8", t.utf16le = "utf16le", t.ucs2 = "ucs2", t.base64 = "base64", t.base64url = "base64url", t.latin1 = "latin1", t.binary = "binary", t.hex = "hex", t))(Ue || {}), Gr = /* @__PURE__ */ ((t) => (t.text = "text", t.dataURL = "dataURL", t.binaryString = "binaryString", t.arraybuffer = "arraybuffer", t))(Gr || {}), Xr = /* @__PURE__ */ ((t) => (t.md5 = "md5", t.sha1 = "sha1", t.sha256 = "sha256", t.SHA256 = "SHA-256", t.sha512 = "sha512", t.SHA512 = "SHA-512", t.AESGCM = "AES-GCM", t.ECDSA = "ECDSA", t))(Xr || {}), Jr = /* @__PURE__ */ ((t) => (t.aes_128_cbc = "aes-128-cbc", t.aes_128_ecb = "aes-128-ecb", t.aes_192_cbc = "aes-192-cbc", t.ae_192_ecb = "aes-192-ecb", t.aes_256_cbc = "aes-256-cbc", t.aes_256_ecb = "aes-256-ecb", t.base64 = "base64", t))(Jr || {});
const c1 = [
  "jelly",
  "bounce",
  "flash",
  "pulse",
  "rubberBand",
  "shakeX",
  "shakeY",
  "headShake",
  "swing",
  "tada",
  "wobble",
  "jello",
  "heartBeat",
  "backInLeft",
  "backInRight",
  "backInUp",
  "backInDown",
  "backOutLeft",
  "backOutRight",
  "backOutUp",
  "backOutDown",
  "bounceIn",
  "bounceInLeft",
  "bounceInRight",
  "bounceInUp",
  "bounceInDown",
  "bounceOut",
  "bounceOutLeft",
  "bounceOutRight",
  "bounceOutUp",
  "bounceOutDown",
  "fadeIn",
  "fadeInLeft",
  "fadeInLeftBig",
  "fadeInRight",
  "fadeInRightBig",
  "fadeInUp",
  "fadeInUpBig",
  "fadeInDown",
  "fadeInDownBig",
  "fadeInTopLeft",
  "fadeInTopRight",
  "fadeInBottomLeft",
  "fadeInBottomRight",
  "fadeOut",
  "fadeOutLeft",
  "fadeOutLeftBig",
  "fadeOutRight",
  "fadeOutRightBig",
  "fadeOutUp",
  "fadeOutUpBig",
  "fadeOutDown",
  "fadeOutDownBig",
  "fadeOutTopLeft",
  "fadeOutTopRight",
  "fadeOutBottomRight",
  "fadeOutBottomLeft",
  "flip",
  "flipInX",
  "flipInY",
  "flipOutX",
  "flipOutY",
  "flipOutRight",
  "flipInLeft",
  "flipOutLeft",
  "flipInRight",
  "flipOutTop",
  "flipInBottom",
  "flipOutBottom",
  "flipInTop",
  "lightSpeedInLeft",
  "lightSpeedInRight",
  "lightSpeedOutLeft",
  "lightSpeedOutRight",
  "rotateIn",
  "rotateInUpLeft",
  "rotateInUpRight",
  "rotateInDownLeft",
  "rotateInDownRight",
  "rotateOut",
  "rotateOutUpLeft",
  "rotateOutUpRight",
  "rotateOutDownLeft",
  "rotateOutDownRight",
  "hinge",
  "rotateFall",
  "rotateOutNewspaper",
  "rotateInNewspaper",
  "jackInTheBox",
  "rollIn",
  "rollOut",
  "zoomIn",
  "zoomInLeft",
  "zoomInRight",
  "zoomInUp",
  "zoomInDown",
  "zoomOut",
  "zoomOutLeft",
  "zoomOutRight",
  "zoomOutUp",
  "zoomOutDown",
  "fade",
  "moveFromLeft",
  "moveToLeft",
  "moveFromRight",
  "moveToRight",
  "moveFromTop",
  "moveToTop",
  "moveFromBottom",
  "moveToBottom",
  "moveFromLeftFade",
  "moveToLeftFade",
  "moveFromRightFade",
  "moveToRightFade",
  "moveFromTopFade",
  "moveToTopFade",
  "moveFromBottomFade",
  "moveToBottomFade",
  "scaleFromSmall",
  "scaleToSmall",
  "scaleFromLarge",
  "scaleToLarge",
  "scaleFromSmallCenter",
  "scaleToSmallCenter",
  "slideInLeft",
  "slideInRight",
  "slideInUp",
  "slideInDown",
  "slideOutLeft",
  "slideOutRight",
  "slideOutUp",
  "slideOutDown",
  "rotateRightSideFirst",
  "rotateLeftSideFirst",
  "rotateTopSideFirst",
  "rotateBottomSideFirst",
  "rotatePushLeft",
  "rotatePushRight",
  "rotatePushTop",
  "rotatePushBottom",
  "rotatePullRight",
  "rotatePullLeft",
  "rotatePullTop",
  "rotatePullBottom",
  "rotateFoldRight",
  "rotateFoldLeft",
  "rotateFoldTop",
  "rotateFoldBottom",
  "rotateUnfoldLeft",
  "rotateUnfoldRight",
  "rotateUnfoldTop",
  "rotateUnfoldBottom",
  "rotateRoomLeftOut",
  "rotateRoomLeftIn",
  "rotateRoomRightOut",
  "rotateRoomRightIn",
  "rotateRoomTopOut",
  "rotateRoomTopIn",
  "rotateRoomBottomOut",
  "rotateRoomBottomIn",
  "rotateCubeLeftOut",
  "rotateCubeLeftIn",
  "rotateCubeRightOut",
  "rotateCubeRightIn",
  "rotateCubeTopOut",
  "rotateCubeTopIn",
  "rotateCubeBottomOut",
  "rotateCubeBottomIn",
  "rotateCarouselLeftOut",
  "rotateCarouselLeftIn",
  "rotateCarouselRightOut",
  "rotateCarouselRightIn",
  "rotateCarouselTopOut",
  "rotateCarouselTopIn",
  "rotateCarouselBottomOut",
  "rotateCarouselBottomIn",
  "rotateSidesOut",
  "rotateSidesIn",
  "rotateSlideOut",
  "rotateSlideIn",
  "superRainbow",
  "statusProcessing"
], ie = (t) => {
  let e = null;
  switch (t) {
    case "any-character":
      e = /[^]/;
      break;
    case "bin":
      e = /^(0b)?[0-1]+$/i;
      break;
    case "oct":
      e = /^(0o)?[0-7]+$/i;
      break;
    case "hex":
      e = /^(0x)?[0-9a-fA-F]+$/i;
      break;
    case "ascii":
      e = /^[\x00-\xFF]+$/i;
      break;
    case "int":
      e = /^[-+]?[0-9]+$/;
      break;
    case "number":
      e = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
      break;
    case "number-single":
      e = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/i;
      break;
    case "split":
      e = /\s*,\s*/gi;
      break;
    case "trim":
      e = /^\s+|\s+$/g;
      break;
    case "regexp":
      e = /[\\^$.*+?()[\]{}|]/g;
      break;
    case "regexp-flags":
      e = /\w*$/;
      break;
    case "native-method":
      e = RegExp(
        "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(ie("regexp"), "\\$&").replace(
          /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
          "$1.*?"
        ) + "$"
      );
      break;
    case "svg-segment":
      e = /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi;
      break;
    case "mobile-china":
      e = /^[1]{1}[0-9]{10}$/;
      break;
    case "email":
      e = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+\@[A-Za-z0-9._-]+\.[A-Za-z0-9]+$/gm;
      break;
    case "ip":
      e = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      break;
    case "url":
      e = /^http[s]?:\/\/([\w-]+\.)+[\w-]+([\w-./?%&=]*)?$/;
      break;
    case "element-url":
      e = /^url\(['"]?(.+?)['"]?\)$/i;
      break;
    case "date":
      e = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})$/;
      break;
    case "time":
      e = /^(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "datetime":
      e = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})\s+(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "base64-data":
      e = /^\s*data:(?:[a-z]+\/[a-z0-9-+.]+(?:;[a-z-]+=[a-z0-9-]+)?)?(?:;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*?)\s*$/i;
      break;
    case "hex-color":
      e = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
      break;
    case "color":
      e = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i;
      break;
    case "whitespace":
      e = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]/g;
      break;
    case "commaSpaces":
      e = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/;
      break;
    case "var-name":
      e = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
      break;
    case "bezier":
      e = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/;
      break;
    case "chinese-name":
      e = /^(?:[\u4e00-\u9fa5·]{2,16})$/;
      break;
    case "chinese":
      e = new RegExp(
        String.raw`
          [\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}]
          |[\u{4E00}-\u{9FCC}]
          |[\u{3400}-\u{4DB5}]
          |[\u{20000}-\u{2A6D6}]
          |[\u{2A700}-\u{2B734}]
          |[\u{2B740}-\u{2B81D}]
          |[\u{2B820}-\u{2CEAF}]
          |[\u{2CEB0}-\u{2EBEF}]
        `.replace(/\s+/g, ""),
        "u"
      );
      break;
    case "mime-image":
      e = /^image\//;
      break;
    case "mime-video":
      e = /^video\//;
      break;
    case "mime-audio":
      e = /^audio\//;
      break;
    case "mime-document-word":
      e = /^application\/(?:vnd\.openxmlformats-officedocument\.wordprocessingml\.document|msword|vnd\.ms-word\.document\.macroenabled\.12|vnd\.openxmlformats-officedocument\.wordprocessingml\.template|vnd\.ms-word\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-excel":
      e = /^application\/(?:vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|vnd\.ms-excel|vnd\.ms-excel\.sheet\.macroenabled\.12|vnd\.openxmlformats-officedocument\.spreadsheetml\.template|vnd\.ms-excel\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-ppt":
      e = /^application\/(?:vnd\.ms-powerpoint|vnd\.openxmlformats-officedocument\.presentationml\.presentation|vnd\.ms-powerpoint\.presentation\.macroenabled\.12|vnd\.openxmlformats-officedocument\.presentationml\.template|vnd\.ms-powerpoint\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-json":
      e = /^application\/json$/;
      break;
    case "mime-document-xml":
      e = /^(?:application|text)\/(?:xml|xhtml\+xml)$/;
      break;
  }
  return e;
};
function Yr(t) {
  if (t.flags)
    return t.flags;
  const e = [];
  return t.global && e.push("g"), t.ignoreCase && e.push("i"), t.multiline && e.push("m"), t.sticky && e.push("y"), t.unicode && e.push("u"), e.join("");
}
function Zr(t) {
  const e = new RegExp(t.source, Yr(t));
  return e.lastIndex = t.lastIndex, e;
}
const xe = (t, e) => (typeof t == "string" && (t = ie(t) || new RegExp(t)), t.test(e)), u1 = (t, e) => (typeof t == "string" && (t = ie(t) || new RegExp(t)), e.search(t)), l1 = (t, e) => (typeof t == "string" && (t = ie(t) || new RegExp(t)), e.split(t)), Ft = (t, e) => {
  typeof t == "string" && (t = ie(t) || new RegExp(t));
  const n = e.match(t);
  return n ? t.flags.toLowerCase().indexOf("g") >= 0 ? n.map(
    (r) => ({
      matchIndex: -1,
      fullMatch: r,
      groupMatchs: []
    })
  ) : {
    matchIndex: typeof n.index == "number" ? n.index : -1,
    fullMatch: n[0],
    groupMatchs: n.slice(1)
  } : null;
}, f1 = (t, e) => {
  typeof t == "string" && (t = ie(t) || new RegExp(t));
  const n = [], r = e.matchAll(t);
  for (const s of r)
    n.push({
      matchIndex: typeof s.index == "number" ? s.index : -1,
      fullMatch: s[0],
      groupMatchs: s.slice(1)
    });
  return n;
}, h1 = (t, e) => {
  if (typeof t == "string" && (t = ie(t) || new RegExp(t)), t.flags.toLowerCase().indexOf("g") < 0)
    return Ft(t, e);
  const n = [];
  let r;
  for (; r = t.exec(e); )
    n.push({
      matchIndex: typeof r.index == "number" ? r.index : -1,
      fullMatch: r[0],
      groupMatchs: r.slice(1)
    });
  return n;
};
function Q(t) {
  const e = t.match(/[\s\S]/gu);
  return e ? e.length : 0;
}
function d1(t) {
  return [...t].length;
}
function p1(t) {
  return Array.from(t).length;
}
function m1(t) {
  const e = t.length;
  let n = 0, r = 0;
  for (; n < e; ) {
    const s = t.charCodeAt(n);
    if (s >= 55296 && s <= 56319) {
      const i = t.charCodeAt(n + 1);
      i >= 56320 && i <= 57343 && n++;
    }
    r++, n++;
  }
  return r;
}
function g1(t, e) {
  return Array.from(t).slice(0, e).join("");
}
function y1(t, e) {
  const n = t.codePointAt(e);
  return n ? String.fromCodePoint(n) : void 0;
}
function w1(t) {
  if (!/^\s*[0-9A-Z]+\s*$/i.test(t))
    throw new Error("纳税人识别号只能由数字和大写字母组成");
  const e = t.trim().toUpperCase(), n = Q(e);
  if (n !== 15 && n !== 17 && n !== 18 && n !== 20)
    throw new Error("税号应为15/17/18/20位数字或大写字母组合，请检查。");
  return e;
}
function b1(t) {
  if (!/^\s*[0-9A-Z（）\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}\u{4E00}-\u{9FCC}\u{3400}-\u{4DB5}\u{20000}-\u{2A6D6}\u{2A700}-\u{2B734}\u{2B740}-\u{2B81D}\u{2B820}-\u{2CEAF}\u{2CEB0}-\u{2EBEF}]+\s*$/iu.test(
    t
  ))
    throw new Error("名称只能包含：中文+英文+数字+全角括号");
  const e = t.trim(), n = Q(e);
  if (n == 0)
    throw new Error("请输入名称");
  if (n > 100)
    throw new Error("名称过长，请修改 (不超过100个字符)");
  return e;
}
function S1(t) {
  if (!/^\s*([a-z0-9A-Z]+[-|_|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}\s*$/i.test(
    t
  ))
    throw new Error("请输入正确的邮箱");
  return t.trim();
}
function x1(t = 12, e = "all") {
  let n = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz0123456789";
  e == "number" && (n = "0123456789");
  const r = n.length;
  let s = "";
  for (let i = 0; i < t; i++)
    s += n[Math.floor(Math.random() * r)];
  return s;
}
const In = () => Math.random().toString(36).slice(2), A1 = () => String.fromCharCode(
  Math.random() * ("z".charCodeAt(0) - "a".charCodeAt(0)) + "a".charCodeAt(0)
);
function O1(t, e) {
  const n = Object.keys(e);
  for (let r = 0, s = n.length; r < s; r++)
    t = t.replace(new RegExp("{" + n[r] + "}", "gi"), e[n[r]]);
  return t;
}
function v1(t, ...e) {
  let n = "", r;
  for (r = 0; r < e.length; r++)
    n += t.raw[r] + e[r];
  return n += t.raw[r] || "", n;
}
function R1(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function Kr(t) {
  return t.replace(/(^\w)/g, (e) => e.toLowerCase());
}
const _1 = (t, e = "-") => {
  let n = t.replace(new RegExp("[_-]?([A-Z])", "g"), e + "$1").toLowerCase();
  const r = new RegExp(`^${e}`);
  return r.test(t) || (n = n.replace(r, "")), n;
};
function Qr(t) {
  return t.replace(/(^\w|[_-]\w)/g, (e) => e.slice(-1).toUpperCase());
}
function T1(t) {
  return Kr(Qr(t));
}
function E1(t) {
  return t ? t.replaceAll(/^\s+|\s+$/g, "").replaceAll(/\r?\n/g, "") : "";
}
function k1(t = "") {
  const e = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
  return t.replaceAll(e, "");
}
function C1(t, e = "", n = /\[data-v-[0-9a-zA-Z]*\]/g) {
  return t = t.replaceAll(n, e), t;
}
function P1(t, e, n = "0", r = "left") {
  const s = Q(t);
  if (e > s) {
    const i = e - s;
    let o, a;
    switch (r) {
      case "left":
        t = Array(i + 1).join(n) + t;
        break;
      case "right":
        t = t + Array(i + 1).join(n);
        break;
      default:
        o = Math.ceil(i / 2), a = i - o, t = Array(a + 1).join(n) + t + Array(o + 1).join(n);
        break;
    }
  }
  return t;
}
const D1 = (t, e) => t.repeat(e), M1 = (t, e, n = "...") => Q(t) < e ? t : `${t.slice(0, e - 3)}${n}`, I1 = (t, e, n, r = "...") => {
  const s = Q(t);
  return s < e || n - e >= s ? t : `${t.slice(0, e)}${r}${t.slice(s - n)}`;
}, L1 = (t) => t.split("").reverse().join("");
function $1(t) {
  const e = t.codePointAt(0);
  return typeof e < "u" && e > 65535;
}
function F1(t) {
  let e = "";
  for (let n = 0, r = t.length; n < r; n++) {
    const s = t.charCodeAt(n);
    s >= 1 && s <= 127 ? e += t.charAt(n) : s > 2047 ? (e += String.fromCharCode(224 | s >> 12 & 15), e += String.fromCharCode(128 | s >> 6 & 63), e += String.fromCharCode(128 | s >> 0 & 63)) : (e += String.fromCharCode(192 | s >> 6 & 31), e += String.fromCharCode(128 | s >> 0 & 63));
  }
  return e;
}
function N1(t) {
  const e = t.length;
  let n = "", r = 0, s, i;
  for (; r < e; ) {
    const o = t.charCodeAt(r++);
    switch (o >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        n += t.charAt(r - 1);
        break;
      case 12:
      case 13:
        s = t.charCodeAt(r++), n += String.fromCharCode((o & 31) << 6 | s & 63);
        break;
      case 14:
        s = t.charCodeAt(r++), i = t.charCodeAt(r++), n += String.fromCharCode(
          (o & 15) << 12 | (s & 63) << 6 | (i & 63) << 0
        );
        break;
    }
  }
  return n;
}
function U1(t, e = "utf-8") {
  e = e.toLowerCase();
  let n = 0;
  if (e === "utf-16" || e === "utf16")
    for (let r = 0, s = t.length; r < s; r++)
      t.charCodeAt(r) <= 65535 ? n += 2 : n += 4;
  else
    for (let r = 0, s = t.length; r < s; r++) {
      const i = t.charCodeAt(r);
      i <= 127 ? n += 1 : i <= 2047 ? n += 2 : i <= 65535 ? n += 3 : n += 4;
    }
  return n;
}
function et(t) {
  const e = new ArrayBuffer(t.length), n = new Uint8Array(e);
  for (let r = 0, s = t.length; r < s; r++)
    n[r] = t[r];
  return e;
}
function es(t) {
  return ArrayBuffer.isView(t);
}
function ts(t) {
  return es(t) && !(t instanceof DataView);
}
function B1(t) {
  return ts(t) && t.constructor.name;
}
function j1(t) {
  return new DataView(t);
}
function q1(t, e) {
  return new t(e);
}
function z1(t, ...e) {
  let n = 0;
  for (const i of e)
    n += i.length;
  const r = new t(n);
  let s = 0;
  for (const i of e)
    r.set(i, s), s += i.length;
  return r;
}
function Nt(t) {
  return t.slice(0);
}
function H1(t, e = !0) {
  const n = e ? Nt(t.buffer) : t.buffer;
  return new DataView(n, t.byteOffset, t.byteLength);
}
function V1(t, e = !0) {
  const n = e ? Nt(t.buffer) : t.buffer;
  return new t.constructor(
    n,
    t.byteOffset,
    t.length
  );
}
const Ln = "[object Undefined]", $n = "[object Null]", Fn = "[object Boolean]", ns = "[object Number]", rs = "[object BigInt]", Nn = "[object String]", Un = "[object Symbol]", ss = "[object Function]", is = "[object Array]", os = "[object GeneratorFunction]";
function Y(t) {
  return Object.prototype.toString.call(t);
}
function W1(t, e) {
  return e != null && t instanceof e;
}
function G1(t) {
  const e = typeof t;
  return e !== "object" ? e : Y(t).replace(/^\[object (\S+)\]$/, "$1").toLowerCase();
}
function X1(t) {
  return Y(t) === Ln;
}
function J1(t) {
  return Y(t) === $n;
}
function as(t) {
  return t != null;
}
function Y1(t) {
  return t === null && t === void 0;
}
function Z1(t) {
  return Y(t) === Fn;
}
function cs(t) {
  return Y(t) === Nn;
}
function K1(t) {
  return t === t + 0;
}
function Q1(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function us(t) {
  return Y(t) === Un;
}
function ea(t) {
  const e = t ? Symbol.prototype : void 0, n = e ? e.valueOf : void 0;
  return n ? Object(n.call(t)) : {};
}
function Ut(t) {
  const e = Y(t);
  return e === Ln || e === $n || e === Fn || e === ns || e === Nn || e === Un || e === rs;
}
function re(t) {
  const e = Y(t);
  return e == ss || e == os;
}
function ta(t) {
  return re(t) && Object.prototype.hasOwnProperty.call(t, "toString");
}
function ls(t) {
  return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(
    Bn(t)
  ) != null;
}
function ft(t) {
  return Ae(t) ? ls(t) || /^\[object .+?Constructor\]$/.test(Bn(t)) : !1;
}
function $(t) {
  return Y(t) === is;
}
function na(t) {
  return t != null && typeof t.length == "number" && t.length > -1 && t.length % 1 == 0 && t.length <= Number.MAX_SAFE_INTEGER && !re(t);
}
function Ae(t) {
  const e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function J(t) {
  return !!t && typeof t == "object";
}
function D(t) {
  return J(t) && !$(t);
}
function ra(t) {
  return J(t) ? Object == t.constructor : !1;
}
function fs(t) {
  const e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function sa(t) {
  const e = t && t.constructor, n = typeof e == "function" && e.prototype || Object.prototype;
  return t === n;
}
function ia(t) {
  if (!t || !t.hasOwnProperty)
    return !1;
  const e = ["value", "initializer", "get", "set"];
  for (let n = 0, r = e.length; n < r; n++)
    if (Object.hasOwnProperty.call(t, e[n]))
      return !0;
  return !1;
}
const oa = (t) => {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e))
      return !1;
  return !0;
};
function aa(t) {
  return typeof Promise < "u" && t instanceof Promise || Ae(t) && typeof t.then == "function" && typeof t.catch == "function";
}
function hs(t) {
  return Ae(t) && typeof t.next == "function";
}
function ca(t) {
  const e = t.constructor;
  return e ? (e.name || e.displayName) === "GeneratorFunction" : !1;
}
function ua(t) {
  return t && re(Symbol) ? re(t[Symbol.iterator]) : $(t);
}
function Oe(t) {
  const e = [];
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.push(n);
  return e;
}
function la(t) {
  const e = [];
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.push(t[n]);
  return e;
}
function fa(t) {
  const e = [];
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.push([n, t[n]]);
  return e;
}
function ha(t) {
  const e = {};
  return Oe(t).forEach(
    (n) => e[n] = Object.getOwnPropertyDescriptor(t, n)
  ), e;
}
function da(t, e) {
  if (us(t)) {
    do {
      if (e === Object.prototype)
        return typeof e[t] < "u";
      if (Object.prototype.hasOwnProperty.call(e, t))
        return !0;
    } while (e = Object.getPrototypeOf(e));
    return !1;
  } else
    return t in e;
}
function De(t, e, n = !0) {
  if (D(t) && D(e))
    for (const r of Oe(e))
      (n || typeof t[r] > "u") && (t[r] = e[r]);
  return t;
}
function ds(t, e, n = !0) {
  if (D(t) && D(e))
    for (const r of Oe(e))
      (n || typeof t[r] > "u") && (D(t[r]) && D(e[r]) ? ds(t[r], e[r], n) : t[r] = e[r]);
  return t;
}
function ps(t) {
  Object.freeze(t), Object.keys(t).forEach((e) => {
    Ae(t[e]) && ps(t[e]);
  });
}
function pa(t) {
  const e = Object.entries(t).slice(0), n = e.length;
  let r = -1;
  const s = n - 1;
  for (; ++r < n; ) {
    const i = r + Math.floor(Math.random() * (s - r + 1)), o = e[i];
    e[i] = e[r], e[r] = o;
  }
  return Object.fromEntries(e);
}
function ma(t, e = {}) {
  const n = Symbol("isa");
  function r(s) {
    for (const i of Reflect.ownKeys(t))
      Object.defineProperty(s.prototype, i, {
        value: t[i],
        writable: !0
      });
    return Object.defineProperty(s.prototype, n, { value: !0 }), s;
  }
  for (const s of Reflect.ownKeys(e))
    Object.defineProperty(r, s, {
      value: e[s],
      enumerable: Object.propertyIsEnumerable.call(e, s)
    });
  return Object.defineProperty(r, Symbol.hasInstance, {
    value: (s) => !!s[n]
  }), r;
}
function ga(...t) {
  class e {
    constructor() {
      for (const r of t)
        De(this, new r(), !0);
    }
  }
  for (const n of t)
    De(e, n, !0), De(e.prototype, n.prototype, !0);
  return e;
}
function ya(t) {
  try {
    postMessage(t, "*");
  } catch (e) {
    if (e?.code === 25)
      return !1;
  }
  return !0;
}
function wa(t, e) {
  return Ut(t) || re(t) ? e = t : $(t) ? e = [...t] : e ? (Object.setPrototypeOf(e, t), De(e, t, !0)) : e = Object.create(
    Object.getPrototypeOf(t),
    Object.getOwnPropertyDescriptors(t)
  ), e;
}
function ba(t, ...e) {
  return new t.constructor(...e);
}
function te(t, e = /* @__PURE__ */ new WeakMap()) {
  if (!Ae(t))
    return t;
  if (e.has(t))
    return e.get(t);
  let n;
  const r = t.constructor;
  if (re(t) ? n = t : r === Array ? n = [] : r === Map ? n = /* @__PURE__ */ new Map() : r === Set ? n = /* @__PURE__ */ new Set() : r === RegExp ? n = Zr(t) : r === Date ? n = new Date(t.getTime()) : typeof ArrayBuffer < "u" && r === ArrayBuffer ? n = Nt(t) : r === Promise ? n = new Promise((s, i) => {
    t.then(
      (o) => {
        s(te(o, e));
      },
      (o) => {
        i(te(o, e));
      }
    );
  }) : r === Error ? n = Object.create(t) : n = Object.create(
    Object.getPrototypeOf(t)
    // Object.getOwnPropertyDescriptors(from)
  ), t instanceof Map)
    t.forEach((s, i) => {
      n.set(te(i, e), te(s, e));
    });
  else if (t instanceof Set)
    t.forEach((s) => {
      n.add(te(s, e));
    });
  else
    for (const s in t)
      try {
        Object.getOwnPropertyDescriptor(t, s) && (n[s] = te(t[s], e));
      } catch (i) {
        if (i instanceof TypeError)
          continue;
        if (i instanceof ReferenceError)
          continue;
      }
  if (Object.getOwnPropertySymbols) {
    const s = Object.getOwnPropertySymbols(t);
    for (let i = 0, o = s.length; i < o; i++) {
      const a = s[i], c = Object.getOwnPropertyDescriptor(t, a);
      c && (n[a] = te(t[a], e), Object.defineProperty(n, a, c));
    }
  }
  return e.set(t, n), n;
}
function Sa(t) {
  if (t === null)
    return null;
  class e {
  }
  return e.prototype = t, new e();
}
function xa(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}
function Aa(t, e) {
  return t.__proto__ = e, t;
}
function ms(t, e) {
  return t === e || t !== t && e !== e;
}
function gs(t, e) {
  if (t === e)
    return !0;
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length)
    return !1;
  for (const s of n) {
    const i = t[s], o = e[s], a = D(i) && D(o);
    if (a && !gs(i, o) || !a && i !== o)
      return !1;
  }
  return !0;
}
function Oa(t, e) {
  return t.bind ? t.bind(e) : function(...r) {
    return t.apply(e, r);
  };
}
function va(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return new Proxy(t, {
    get(n, r) {
      const s = Reflect.get(n, r);
      return typeof s != "function" ? s : (e.has(s) || e.set(s, s.bind(n)), e.get(s));
    }
  });
}
function Ra(t, e) {
  if (!D(t))
    return t;
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && delete t[n];
  return t;
}
function _a(t, e) {
  if (!D(t))
    return t;
  for (const n in t)
    Object.prototype.hasOwnProperty.call(t, n) && !e(n, t[n]) && delete t[n];
  return t;
}
function Ta(t, e) {
  const n = {};
  return D(t) && e.forEach((r) => {
    Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
  }), n;
}
function Ea(t) {
  return D(t) && Oe(t).forEach((e) => {
    delete t[e];
  }), t;
}
function L(t, e = `\r
`, n = 6, r = 1) {
  if (cs(t))
    return `"${t}"`;
  if (Ut(t))
    return "" + t;
  if (re(t))
    return "[Fn]";
  if (r > n)
    return $(t) ? "[...]" : "{...}";
  let s = "", i = "";
  for (let o = 0; o < r; o++)
    s += "  ", o > 0 && (i += "  ");
  return $(t) ? `[${t.map(
    (o) => e + s + L(o, e, n, r + 1)
  ).join(", ")}${e}${i}]` : `{${Oe(t).map(
    (o) => `${e}${s}${o}: ${L(
      t[o],
      e,
      n,
      r + 1
    )}`
  ).join(", ")}${e}${i}}`;
}
function Bn(t) {
  if (t != null)
    try {
      return Function.prototype.toString.call(t);
    } catch {
      try {
        return "" + t;
      } catch {
      }
    }
  return "";
}
function ka(t, e = "", n = ["", "sign", "key"]) {
  return D(t) ? Object.keys(t).filter((r) => {
    for (let s = 0, i = n.length; s < i; s++)
      if (t[r] == n[s])
        return !1;
    return !0;
  }).sort().map((r) => `${r}=${t[r]}`).join("&") + e : String(t);
}
function jn(t, e, n = "") {
  let r = [];
  return t === e ? r : typeof t != "object" || typeof e != "object" || !t || !e ? (r.push({
    path: n,
    newValue: e,
    oldValue: t
  }), r) : ((/* @__PURE__ */ new Set([...Object.keys(t), ...Object.keys(e)])).forEach((i) => {
    const o = n ? `${n}.${i}` : i;
    r = r.concat(jn(t[i], e[i], o));
  }), r);
}
function Ca(t, e) {
  try {
    return e.split(".").reduce((n, r) => n?.[r], t);
  } catch {
    return;
  }
}
function Pa(t, e, n) {
  if (!t || !e)
    return t;
  const r = e.split(".");
  let s = t;
  for (let i = 0, o = r.length - 1; i < o; i++) {
    const a = r[i];
    (!(a in s) || typeof s[a] != "object" || s[a] === null) && (s[a] = {}), s = s[a];
  }
  return s[r[r.length - 1]] = n, t;
}
const Da = 9007199254740991, Ma = -9007199254740991, Ia = Math.pow(2, -52);
function qn(t) {
  return Number.isNaN(t);
}
function La(t) {
  return typeof t == "number" && qn(t);
}
const $a = (t) => t % 2 === 0;
function ys(t) {
  if (t <= 1)
    return !1;
  for (let e = 2; e <= Math.sqrt(t); e++)
    if (t % e === 0)
      return !1;
  return !0;
}
function ws(t) {
  for (; !ys(t); )
    t++;
  return t;
}
const Fa = (...t) => t.reduce((e, n) => e + n) / t.length;
function G(t, e) {
  const n = parseFloat(t);
  return Number.isNaN(n) ? typeof e == "number" ? e : NaN : n;
}
function Na(t, e, n) {
  return typeof t == "string" ? (t = t.trim().toLowerCase(), t.indexOf("%") > 0 ? G(t, e) / 100 * n : t.indexOf("vw") > 0 ? G(t, e) / 100 * window.innerWidth : t.indexOf("vh") > 0 ? G(t, e) / 100 * window.innerHeight : t.indexOf("vm") > 0 ? G(t, e) / 100 * Math.min(window.innerWidth, window.innerHeight) : t == "top" || t == "left" ? 0 : t == "center" || t == "middle" ? n * 0.5 : t == "bottom" || t == "right" ? n : G(t, e)) : G(t, e);
}
function bs(t = 1e-6) {
  return function(e, n) {
    return Math.abs(e - n) < t;
  };
}
function Ua(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = Math.pow(10, Math.max(n, r));
  return (t * s + e * s) / s;
}
function ce(t, e, n) {
  const r = Math.min(e, n), s = Math.max(e, n);
  return t < r ? r : t > s ? s : t;
}
function Ba(t, e = 0) {
  const n = Math.pow(10, e);
  return Math.round(n * t) / n;
}
function ja(t, e) {
  return (t % e + e) % e;
}
function Ss(t, e, n) {
  return typeof t == "number" && typeof e == "number" ? (1 - n) * t + n * e : typeof t == "number" ? t : typeof e == "number" ? e : 0;
}
function qa(t, e, n) {
  const r = Math.max(t.length, e.length), s = new Array(r);
  for (let i = 0; i < r; i++)
    s[i] = Ss(t[i], e[i], n);
  return s;
}
function za(t, e, n, r) {
  return (s) => n + (r - n) * ((s - t) / (e - t));
}
function Ha(t, e, n) {
  return (r) => {
    const s = ce(r, t, e);
    return n == 0 ? s : e - s < n ? e : Math.round(s / n) * n;
  };
}
function Va(t, e = 12) {
  return G(t, 0).toPrecision(e);
}
function zn(t, e = 12) {
  return G(t, 0).toFixed(e);
}
function K(t, e = 12) {
  return +zn(t, e);
}
function Wa(t) {
  return K(t, 0);
}
function Ga(t, e = 4, n = ",") {
  const r = new RegExp(`\\d{1,${e}}(?=(\\d{${e}})+$)`, "g");
  return String(t).replace(r, `$&${n}`);
}
function Xa(t, e) {
  const n = Ft("number-single", String(t));
  return {
    hasNumber: !!n,
    number: n && !Array.isArray(n) && n.fullMatch ? parseFloat(n.fullMatch) : as(e) ? e : NaN,
    prefix: n && !Array.isArray(n) && n.fullMatch ? t.substring(0, n.matchIndex) : "",
    suffix: n && !Array.isArray(n) && n.fullMatch ? t.substring(n.matchIndex + n.fullMatch.length) : ""
  };
}
function xs(t) {
  const e = Ft("number", t);
  return e ? Array.isArray(e) ? e.map((n) => Number(n.fullMatch)) : [Number(e.fullMatch)] : [];
}
function Ja() {
  return Math.random() > 0.5 ? 1 : -1;
}
function As(t = 0, e = 100) {
  return Math.random() * (e - t) + t;
}
function Ya(t = 0, e = 100) {
  return Math.floor(As(t, e));
}
function Za(t = 0) {
  return () => ++t;
}
function Ka(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return Math.round(t * 4294967295);
    case Uint16Array:
      return Math.round(t * 65535);
    case Uint8Array:
      return Math.round(t * 255);
    case Int32Array:
      return Math.round(t * 2147483647);
    case Int16Array:
      return Math.round(t * 32767);
    case Int8Array:
      return Math.round(t * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
function Qa(t, e) {
  switch (e.constructor) {
    case Float32Array:
      return t;
    case Uint32Array:
      return t / 4294967295;
    case Uint16Array:
      return t / 65535;
    case Uint8Array:
      return t / 255;
    case Int32Array:
      return Math.max(t / 2147483647, -1);
    case Int16Array:
      return Math.max(t / 32767, -1);
    case Int8Array:
      return Math.max(t / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
const ec = (t) => new Array(t).fill(void 0), tc = (t) => Array.isArray(t) && t.length > 0;
function nc(t, e) {
  const n = new Array(t);
  let r = -1;
  for (; ++r < t; )
    n[r] = e(r);
  return n;
}
function rc(t, e) {
  return Array.from({ length: t }, (n, r) => e);
}
function Os(t, e, n) {
  return Array.from(
    { length: t },
    () => new Array(e).fill(n)
  );
}
function sc(t, e) {
  return t[0].length ? Os(
    t.map((n) => n.filter((r, s) => s === 0)[0]).length,
    t[0].length,
    e
  ) : new Error("Illegal, Array must be any[][]!");
}
function vs(t, e) {
  return [...t[e]];
}
function Rs(t, e) {
  return t.map((n) => n.filter((r, s) => s === e)[0]);
}
function ic(t, e, n) {
  return {
    row: vs(t, e),
    column: Rs(t, n)
  };
}
function oc(t, e) {
  const n = t.length || 0;
  let r = -1;
  for (; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
function _s(t, e, n) {
  [t[e], t[n]] = [t[n], t[e]];
}
function ac(t, e) {
  return _s(t, 0, e);
}
function cc(t) {
  t.sort((n, r) => n - r);
  const e = Math.floor(t.length / 2);
  return t[e];
}
function uc(t) {
  if (t.length)
    return t[0];
}
function lc(t) {
  if (t.length)
    return t[t.length - 1];
}
function fc(t, e) {
  for (let n = 0, r = t.length; n < r; n++)
    if (t[n] == e)
      return !0;
  return !1;
}
function Ts(t = [], e = []) {
  const n = t.length, r = e.length;
  for (let i = 0; i < r; i++)
    t[i] = e[i];
  let s = Math.max(0, n - r);
  for (; s > 0; )
    t.pop(), s--;
  return t;
}
function hc(t) {
  for (; t.length; )
    t.pop();
}
function dc(t, e, n) {
  return t.splice(ce(e, 0, t.length - 1), 0, n), t;
}
function pc(t, e) {
  const n = t.findIndex((r) => r === e);
  return n >= 0 && t.splice(n, 1), t;
}
const mc = (t) => $(t) && Object.keys(t).length > 0, gc = (t, e) => t.length === e.length && t.every((n, r) => n === e[r]);
function* Hn(t) {
  for (const e of t)
    $(e) ? yield* Hn(e) : yield e;
}
function yc(t) {
  if ($(t))
    return [...Hn(t)];
}
function Es(t) {
  let e = [];
  return t.forEach((n) => {
    $(n) ? e = e.concat(Es(n)) : e.push(n);
  }), e;
}
function ks(t) {
  return t.reduce((e, n) => e.concat($(n) ? ks(n) : n), []);
}
function wc(t) {
  for (; t.some((e) => $(e)); )
    t = [].concat(...t);
  return t;
}
function bc(t) {
  return t.toString().split(",");
}
function Sc(t) {
  return t.flat(1 / 0);
}
function xc(t) {
  let e = JSON.stringify(t);
  return e = e.replace(/(\[|\])/g, ""), e = "[" + e + "]", JSON.parse(e);
}
const Ac = (t) => t.sort(() => 0.5 - Math.random());
function Oc(t) {
  return [...new Set(t)];
}
function Cs(t, e) {
  return t.findIndex((n) => n == e) >= 0;
}
function vc(t, ...e) {
  return e.forEach((n) => {
    Cs(t, n) || t.push(n);
  }), t;
}
function Rc(t, e) {
  return [.../* @__PURE__ */ new Set([...t, ...e])];
}
function _c(t, e) {
  return /* @__PURE__ */ new Set([...t, ...e]);
}
function Tc(t, e) {
  return [...new Set(t.filter((n) => e.includes(n)))];
}
function Ec(t, e) {
  return new Set([...t].filter((n) => e.has(n)));
}
function kc(t, e) {
  const n = /* @__PURE__ */ new Map();
  t.forEach((s) => {
    n.set(s, !0);
  });
  const r = [];
  return e.forEach((s) => {
    n.has(s) && (r.push(s), n.delete(s));
  }), r;
}
function Cc(t, e) {
  return [...new Set(t.filter((n) => !e.includes(n)))];
}
function Pc(t, e) {
  return new Set([...t].filter((n) => !e.has(n)));
}
function Dc(t) {
  for (let e = t.length - 1; e >= 0; --e)
    if (t[e] >= 65535)
      return !0;
  return !1;
}
function Mc(t, e = "Asia/Shanghai") {
  const n = (/* @__PURE__ */ new Date()).getTimezoneOffset() * 60 * 1e3;
  return new Date(t.getTime() - n);
}
function Be() {
  return (performance || Date).now();
}
function X(t = /* @__PURE__ */ new Date()) {
  return t.getTime();
}
function Ic(t = /* @__PURE__ */ new Date(), e = "yyyy-mm-dd hh:ii:ss.SSS") {
  return ve(t, e);
}
function N(t) {
  return !qn(t.valueOf());
}
const Bt = 864e5;
function Vn(t) {
  return t > 1e12;
}
function Lc(t) {
  return t > 1e9 && !Vn(t);
}
function tt(t) {
  if (t == null)
    return /* @__PURE__ */ new Date(NaN);
  if (t instanceof Date)
    return new Date(t);
  if (typeof t == "string") {
    const n = t.match(
      /^(\d{4})[-/.]?(\d{1,2})?[-/.]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?[zZ]?$/
    );
    if (n && n[1] && n[2]) {
      const r = parseInt(n[1]), s = n[2] ? Math.max(parseInt(n[2]) - 1, 0) : 0, i = n[3] ? parseInt(n[3]) : 1, o = n[4] ? parseInt(n[4]) : 0, a = n[5] ? parseInt(n[5]) : 0, c = n[6] ? parseInt(n[6]) : 0, u = n[7] ? parseInt(n[7].substring(0, 3)) : 0;
      return /Z$/i.test(t) ? new Date(Date.UTC(r, s, i, o, a, c, u)) : new Date(r, s, i, o, a, c, u);
    } else
      return /* @__PURE__ */ new Date(NaN);
  }
  if (Array.isArray(t))
    return new Date(
      t[0],
      Math.max(t[1] - 1, 0),
      t[2] || 1,
      t[3] || 0,
      t[4] || 0,
      t[5] || 0,
      t[6] || 0
    );
  const e = Vn(t);
  return new Date(e ? t : t * 1e3);
}
function $c(t, e = 3) {
  const n = Math.max(t.length, 6);
  let r = "";
  for (let i = 0; i < n - 4; i++)
    r += t[i] || "0";
  const s = [
    r,
    "" + (t[n - 4] || "0") + (t[n - 3] || "0"),
    "" + (t[n - 2] || "0") + (t[n - 1] || "0")
  ];
  switch (e) {
    case 1:
      return s[0];
    case 2:
      return s[0] + ":" + s[1];
    case 3:
      return s[0] + ":" + s[1] + ":" + s[2];
  }
}
function Fc(t, e = 3) {
  const n = Math.max(t.length, 6);
  let r = 0;
  for (let o = 0; o < n - 4; o++)
    r = r * 10 + (t[o] || 0);
  const s = [
    Math.floor(r),
    Math.floor((t[n - 4] || 0) * 10 + (t[n - 3] || 0)),
    Math.floor((t[n - 2] || 0) * 10 + (t[n - 1] || 0))
  ];
  let i = "";
  switch (e) {
    case 1:
      s[0] ? i += s[0] + "小时" : (s[1] || s[2]) && (i += "1小时");
      break;
    case 2:
      s[0] && (i += s[0] + "小时"), s[1] ? i += s[1] + "分钟" : s[2] && (i += "1分钟");
      break;
    case 3:
    default:
      s[0] && (i += s[0] + "小时"), (s[1] || s[2]) && (i += s[1] + "分钟"), s[2] && (i += s[2] + "秒");
      break;
  }
  return i || "0秒";
}
function Me(t) {
  const e = Math.max(t.length, 6);
  let n = 0;
  n += (t[e - 2] || 0) * 10 + (t[e - 1] || 0), n += ((t[e - 4] || 0) * 10 + (t[e - 3] || 0)) * 60;
  let r = 0;
  for (let s = 0; s < e - 4; s++)
    r = r * 10 + (t[s] || 0);
  return n += r * 60 * 60, Math.floor(Math.max(0, n));
}
function le(t, e = !1) {
  let n = 0;
  typeof t == "number" ? n = t : n = Me(t);
  const r = [], s = n % 60;
  r.unshift(s % 10), r.unshift(Math.floor(s / 10)), n = Math.floor(n / 60);
  const i = n % 60;
  if (r.unshift(i % 10), r.unshift(Math.floor(i / 10)), n = Math.floor(n / 60), e) {
    const o = n % 100;
    for (r.unshift(o % 10), r.unshift(Math.floor(o / 10)), n = Math.floor(n / 100); n; )
      r.unshift(n % 10), n = Math.floor(n / 10);
  } else {
    const o = n % 24;
    r.unshift(o % 10), r.unshift(Math.floor(o / 10));
  }
  return r;
}
function Nc(t, e = !1) {
  const n = xs(t);
  let r = 0, s = 0, i = 0;
  for (let o = 0, a = Math.max(n.length, 3); o < a; o++) {
    const c = Math.floor(Math.abs(n[o] || 0));
    o == 0 ? e ? r = c : r = c % 24 : o == 1 ? s = c : o == 2 && (i = c);
  }
  return le(r * 60 * 60 + s * 60 + i, e);
}
function Uc(t) {
  const e = t.getHours(), n = t.getMinutes(), r = t.getSeconds();
  return le(e * 60 * 60 + n * 60 + r);
}
function Bc(t, e = !1) {
  const n = t[0] || 0, r = t[1] || 0, s = t[2] || 0;
  return le(n * 60 * 60 + r * 60 + s, e);
}
function jc(t, e, n = !1) {
  const r = (N(t) && N(e) ? Math.abs(e.getTime() - t.getTime()) : 0) / 1e3;
  return le(r, n);
}
function qc(t, e = 1, n = !1) {
  return t[t.length - 1] += e, le(t, n);
}
function zc(t, e = 1, n = !1) {
  return t[t.length - 1] -= e, le(t, n);
}
function Hc(t, e) {
  Ts(e, t);
}
function Vc(t, e, n) {
  const r = Me(t), s = Me(e), i = Me(n);
  return s >= r ? i >= r && i <= s : i >= r || i <= s;
}
function sn(t, e) {
  if (!N(t))
    throw new Error(`Date(${t}) is Invalid !`);
  if (!N(e))
    throw new Error(`Date(${e}) is Invalid !`);
  return Math.ceil((e.getTime() - t.getTime()) / Bt);
}
function Wc(t, e, n) {
  return !(!N(t) || !N(e) || !N(n) || sn(t, n) < 0 || sn(n, e) < 0);
}
function ve(t, e = "yyyy-mm-dd hh:ii:ss") {
  if (!N(t))
    return "";
  const n = /(y+)/.exec(e);
  if (n && n[1]) {
    const s = n[1];
    e = e.replace(
      s,
      // (date.getFullYear() + "").substring(Math.max(4 - year.length, 0))
      (t.getFullYear() + "").substring(4 - s.length)
    );
  }
  const r = {
    "m+": t.getMonth() + 1,
    //月份
    "d+": t.getDate(),
    //日
    "h+": t.getHours(),
    //小时
    "i+": t.getMinutes(),
    //分
    "s+": t.getSeconds(),
    //秒
    "q+": Math.floor((t.getMonth() + 3) / 3),
    // 季度
    "S+": t.getMilliseconds()
    //毫秒
  };
  for (const s in r) {
    const i = new RegExp("(" + s + ")").exec(e);
    if (i && i[1]) {
      const o = i[1];
      e = e.replace(
        o,
        // d.length == 1 ? "" + o[k] : ("00" + o[k]).substring(("" + o[k]).length)
        // d.length == 1
        //   ? "" + o[k]
        //   : ("00" + o[k]).substring(("" + o[k]).length - d.length + 2)
        o.length === 1 ? "" + r[s] : ("00" + r[s]).slice(-o.length)
      );
    }
  }
  return e;
}
function Gc(t = "yyyy-mm-dd hh:ii:ss") {
  return (e) => ve(e, t);
}
function Xc(t, e = "-") {
  return ve(t, `yyyy${e}mm${e}dd`);
}
function Jc(t, e = ":") {
  return ve(t, `hh${e}ii${e}ss`);
}
function Yc(t) {
  return N(t) ? t.toTimeString().slice(0, 8) : "";
}
function Zc(t, e = "-", n = ":") {
  return ve(
    t,
    `yyyy${e}mm${e}dd hh${n}ii${n}ss`
  );
}
function Kc(t) {
  return N(t) ? [0, 6].indexOf(t.getDay()) !== -1 : !1;
}
function Qc(t) {
  return N(t) ? Math.floor(
    (t.getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / Bt
  ) : -1;
}
function Ps(t, e) {
  return new Date(t, e, 0).getDate();
}
function Ds(t, e) {
  const n = new Date(t, e, 1);
  return n.setHours(0, 0, 0, 0), n.getTime() - 1;
}
function e2(t, e) {
  return Ds(t, e) + 1;
}
function Ms(t, e) {
  const n = new Date(t, e - 1, 1);
  return n.setHours(0, 0, 0, 0), n.getTime();
}
function t2(t, e) {
  return Ms(t, e) - 1;
}
function n2(t, e = 1) {
  const n = typeof t == "string" ? tt(t) : new Date(t);
  n.setHours(0, 0, 0, 0);
  const r = new Date(n);
  return n.setMonth(n.getMonth() + e), n.getDate() < r.getDate() && n.setDate(0), new Date(n.getTime() - 1);
}
function r2(t, e = 1, n = !1) {
  const r = typeof t == "string" ? tt(t) : new Date(t);
  r.setHours(0, 0, 0, 0);
  const s = new Date(r);
  return r.setMonth(r.getMonth() + e), r.getDate() < s.getDate() ? (r.setDate(0), r) : n ? r : new Date(r.getTime() - 1);
}
function Ee(t, e = 1) {
  const n = typeof t == "string" ? tt(t) : t;
  return new Date(n.getTime() + e * Bt);
}
function pe(t) {
  const e = t.getFullYear(), n = t.getMonth() + 1, r = t.getDate();
  let s = t.getDay();
  return s == 0 && (s = 7), {
    year: e,
    month: n,
    day: r,
    weekday: s,
    monthDays: Ps(e, n),
    date: new Date(t)
  };
}
function s2(t = "") {
  const e = [], n = pe(
    typeof t == "string" ? t != "" ? tt(t) : /* @__PURE__ */ new Date() : t
  );
  function r(s, i) {
    if (s.month !== n.month)
      return;
    const o = [];
    i == "forward" ? e.unshift(o) : e.push(o), o.push(s);
    let a = s;
    for (let c = s.weekday - 1; c >= 1; c--)
      a = pe(Ee(a.date, -1)), o.unshift(a);
    a = s;
    for (let c = s.weekday + 1; c <= 7; c++)
      a = pe(Ee(a.date, 1)), o.push(a);
    o[0].day > 1 && (i == "both" || i == "forward") && r(pe(Ee(o[0].date, -1)), "forward"), o[6].day < n.monthDays && (i == "both" || i == "backward") && r(pe(Ee(o[6].date, 1)), "backward");
  }
  return r(n, "both"), e;
}
function i2(t, e) {
  const n = typeof e?.aliveInSeconds == "number" ? Math.max(e.aliveInSeconds, 0) : -1, r = typeof e?.aliveUntilTimestamp == "number" ? Math.max(e.aliveUntilTimestamp, 0) : -1;
  function s(c, u = !1) {
    return Ut(c) || $(c) ? { v: c, [ge]: X() } : u && zr(c, ge) ? c : {
      ...c,
      [ge]: X()
    };
  }
  let i = s(t, !0);
  return {
    get: () => {
      let c = !1;
      return (n >= 0 && X() > i[ge] + n * 1e3 || // 时间戳
      r >= 0 && X() > r) && (c = !0), c && (i.v = void 0), i;
    },
    set: (c) => i = s(c)
  };
}
const Is = () => typeof window == "object" && typeof document == "object", o2 = () => !Is(), a2 = typeof BigInt < "u", c2 = typeof Symbol < "u", u2 = typeof document < "u", l2 = typeof window < "u", f2 = typeof history < "u";
function h2(t, e) {
  const n = t.split("."), r = e.split(".");
  for (let s = 0, i = n.length; s < i; s++) {
    if (r.length == s)
      return 1;
    if (n[s] != r[s])
      return n[s] > r[s] ? 1 : -1;
  }
  return n.length != r.length ? -1 : 0;
}
const Ls = (() => !!(E.Worker && E.Blob && E.Promise && E.OffscreenCanvas && E.OffscreenCanvasRenderingContext2D && E.HTMLCanvasElement && E.HTMLCanvasElement.prototype.transferControlToOffscreen && E.URL && E.URL.createObjectURL))(), d2 = (() => {
  if (!E.OffscreenCanvas)
    return !1;
  const t = new OffscreenCanvas(1, 1), e = t.getContext("2d");
  if (!e)
    return !1;
  e.fillRect(0, 0, 1, 1);
  const n = t.transferToImageBitmap();
  try {
    e.createPattern(n, "no-repeat");
  } catch {
    return !1;
  }
  return !0;
})();
function ke(t, e) {
  let n = t.length;
  for (; n--; )
    if (ms(t[n][0], e))
      return n;
  return -1;
}
class on {
  __data__ = {};
  constructor(e = []) {
    this.clear();
    const n = e.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = e[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    this.__data__ = {};
  }
  has(e) {
    return Object.prototype.hasOwnProperty.call(this.__data__, e);
  }
  set(e, n) {
    return this.__data__[e] = n, this;
  }
  get(e) {
    return this.has(e) ? this.__data__[e] : void 0;
  }
  delete(e) {
    return this.has(e) && delete this.__data__[e];
  }
}
class St {
  __data__ = [];
  constructor(e = []) {
    this.clear();
    const n = e.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = e[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    this.__data__ = [];
  }
  has(e) {
    return ke(this.__data__, e) > -1;
  }
  set(e, n) {
    const r = ke(this.__data__, e);
    return r < 0 ? this.__data__.push([e, n]) : this.__data__[r][1] = n, this;
  }
  get(e) {
    const n = ke(this.__data__, e);
    return n < 0 ? void 0 : this.__data__[n][1];
  }
  delete(e) {
    const n = ke(this.__data__, e);
    return n < 0 ? !1 : (n == this.__data__.length - 1 ? this.__data__.pop() : Array.prototype.splice.call(this.__data__, n, 1), !0);
  }
}
class p2 {
  __data__ = this.clear();
  constructor(e = []) {
    this.clear();
    const n = e.length;
    let r = -1;
    for (; ++r < n; ) {
      const s = e[r];
      this.set(s[0], s[1]);
    }
  }
  clear() {
    const e = {
      string: new on(),
      hash: new on(),
      map: new (Map || St)()
    };
    return this.__data__ = e, e;
  }
  getData(e) {
    return fs(e) ? this.__data__[typeof e == "string" ? "string" : "hash"] : this.__data__.map;
  }
  has(e) {
    return this.getData(e).has(e);
  }
  set(e, n) {
    return this.getData(e).set(e, n), this;
  }
  get(e) {
    return this.getData(e).get(e);
  }
  delete(e) {
    return this.getData(e).delete(e);
  }
}
class m2 {
  __data__;
  constructor(e = []) {
    this.__data__ = new St(e);
  }
  clear() {
    this.__data__ = new St();
  }
  has(e) {
    return this.__data__.has(e);
  }
  set(e, n) {
    return this.__data__.set(e, n), this;
  }
  get(e) {
    return this.__data__.get(e);
  }
  delete(e) {
    return this.__data__.delete(e);
  }
}
let xt;
try {
  xt = Map;
} catch {
  xt = function() {
  };
}
const g2 = xt;
function an(t) {
  const e = Array(t.size);
  return t.forEach(function(n, r) {
    e.push([r, n]);
  }), e;
}
function $s(t, e) {
  return t.set(e[0], e[1]), t;
}
function y2(t, e) {
  return (e ? e(an(t), !0) : an(t)).reduce($s, /* @__PURE__ */ new Map());
}
let At;
try {
  At = Set;
} catch {
  At = function() {
  };
}
const w2 = At;
function cn(t) {
  const e = Array(t.size);
  return t.forEach((n, r) => {
    e[r] = n;
  }), e;
}
function Fs(t, e) {
  return t.add(e), t;
}
function b2(t, e) {
  return (e ? e(cn(t), !0) : cn(t)).reduce(Fs, /* @__PURE__ */ new Set());
}
const Ns = (t, e = 16) => t.toString(e), Us = (t, e = 16) => {
  let n = t.toLowerCase();
  const r = n.indexOf("0b") == 0, s = n.indexOf("0o") == 0, i = n.indexOf("0x") == 0;
  (r || s || i) && (n = n.slice(2)), r && (e = 2), s && (e = 8), i && (e = 16);
  const o = parseInt(n, e);
  if (isNaN(o))
    throw new Error(`radixStringToNumber(${t}, ${e}) 无法解析！`);
  return o;
};
function Bs(t) {
  return Array.from(new Uint8Array(t));
}
function js(t) {
  const e = [];
  for (; t > 0; ) {
    const n = t & 255;
    e.unshift(n), t = (t - n) / 256;
  }
  return e;
}
function qs(t) {
  t.toLowerCase().indexOf("0x") == 0 && (t = t.slice(2));
  const e = [];
  for (let n = 0, r = t.length; n < r; n += 2)
    e.push(Us(t.slice(n, n + 2), 16));
  return e;
}
function zs(t) {
  const e = [];
  for (let n = 0, r = t.length; n < r; n++) {
    const s = t.charCodeAt(n);
    s && e.push(s);
  }
  return e;
}
function S2(t) {
  return new TextEncoder().encode(t);
}
function x2(t) {
  const e = [];
  for (const n of t) {
    const r = n.codePointAt(0);
    r && e.push(r);
  }
  return e;
}
function A2(t) {
  return et(t);
}
function O2(t) {
  return et(js(t));
}
function v2(t) {
  return et(qs(t));
}
function Hs(t) {
  return et(zs(t));
}
function Vs(t) {
  return Xs(encodeURIComponent(t)).replaceAll("+", "*").replaceAll("/", "-").replaceAll("=", "");
}
function Ws(t) {
  let e = t.replaceAll("*", "+").replaceAll("-", "/");
  const n = e.length % 4;
  return n && (e = e.padEnd(e.length + (4 - n), "=")), decodeURIComponent(Xn(e));
}
function R2(t) {
  return Vs(Gs(Bs(t)));
}
function _2(t) {
  return Hs(Ws(t));
}
function T2(t) {
  let e = 0;
  for (let n = 0, r = t.length; n < r; n++)
    e = e * 256 + t[n];
  return e;
}
function E2(t) {
  let e = "";
  for (let n = 0, r = t.length; n < r; n++)
    e += Ns(t[n], 16).padStart(2, "0");
  return e;
}
function Gs(t) {
  return String.fromCodePoint.apply(null, t);
}
function k2(t) {
  return String.fromCharCode.apply(
    null,
    new Uint16Array(t)
  );
}
function C2(t, e = Ue.utf8) {
  return new TextDecoder(e).decode(t);
}
function P2(t) {
  return Xn(t);
}
function D2(t, e) {
  const n = e?.mime, r = e?.encode, s = e?.type;
  return s ? new Blob([t], {
    type: s
  }) : n ? r === Ue.base64 ? new Blob([t], { type: `${n};${r}` }) : r === Ue.utf8 ? new Blob([t], {
    type: `${n};charset=${r}`
  }) : new Blob([t], {
    type: `${n}`
  }) : new Blob([t]);
}
const M2 = (t) => {
  let e = W.UNKNOWN;
  switch (new DataView(t).getUint32(0, jt()).toString(16).toUpperCase()) {
    case "FFD8FFDB":
      e = W.JPEG;
      break;
    case "FFD8FFE0":
    case "FFD8FFE1":
    case "FFD8FFE2":
    case "FFD8FFE3":
      e = W.JPEG;
      break;
    case "89504E47":
      e = W.PNG;
      break;
    case "47494638":
      e = W.GIF;
      break;
    case "52494646":
      e = W.WEBP;
      break;
    case "25504446":
      e = W.PDF;
      break;
    case "504B0304":
      e = W.ZIP;
      break;
  }
  return e;
};
class Wn extends Error {
  constructor(e) {
    super(e);
  }
}
const Gn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function Xs(t) {
  const e = String(t);
  let n = "";
  for (
    let r = 0, s, i = 0, o = Gn;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    e.charAt(i | 0) || (o = "=", i % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    n += o.charAt(63 & r >> 8 - i % 1 * 8)
  ) {
    if (s = e.charCodeAt(i += 3 / 4), s > 255)
      throw new Wn(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range."
      );
    r = r << 8 | s;
  }
  return n;
}
function Xn(t) {
  const e = String(t).replace(/[=]+$/, "");
  if (e.length % 4 === 1)
    throw new Wn(
      "'atob' failed: The string to be decoded is not correctly encoded."
    );
  let n = "";
  for (
    let r = 0, s = 0, i, o = 0;
    // get next character
    i = e.charAt(o++);
    // eslint-disable-line no-cond-assign
    // character found in table? initialize bit storage and add its ascii value;
    ~i && (s = r % 4 ? s * 64 + i : i, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    r++ % 4) ? n += String.fromCharCode(255 & s >> (-2 * r & 6)) : 0
  )
    i = Gn.indexOf(i);
  return n;
}
function jt() {
  const t = Uint32Array.of(305419896), e = new Uint8Array(t.buffer);
  switch (e[0] * 16777216 + e[1] * 65536 + e[2] * 256 + e[3]) {
    case 305419896:
      return !1;
    case 2018915346:
      return !0;
  }
}
function I2(t, e, n = jt()) {
  const r = t.getUint32(e, n), s = t.getUint32(e + 4, n), i = n ? r + 2 ** 32 * s : 2 ** 32 * r + s;
  return Number.isSafeInteger(i) || console.warn(i, "exceeds MAX_SAFE_INTEGER. Precision may be lost"), i;
}
function L2(t, e, n = jt()) {
  const r = BigInt(32);
  BigInt(0);
  const s = BigInt(t.getUint32(e | 0, !!n) >>> 0), i = BigInt(
    t.getUint32((e | 0) + 4 | 0, !!n) >>> 0
  );
  return n ? i << r | s : s << r | i;
}
function oe(t) {
  let e = "";
  return {
    match: (n) => (e = `"${String(n)}"不能为空`, n != null && n !== ""),
    error: t || e
  };
}
function Js(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"不能小于"${t}"`, r >= t),
    error: e || n
  };
}
function Ys(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"不能大于"${t}"`, r <= t),
    error: e || n
  };
}
function $2(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度不能小于"${t}"`, Q(r) >= t),
    error: e || n
  };
}
function F2(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度不能大于"${t}"`, Q(r) <= t),
    error: e || n
  };
}
function Zs(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}"的长度必须为"${t}"`, Q(r) == t),
    error: e || n
  };
}
function Ks(t) {
  return {
    match: (e) => xe("email", e),
    error: t || "邮箱格式不正确"
  };
}
function Qs(t) {
  return {
    match: (e) => xe("mobile-china", e),
    error: t || "手机格式不正确"
  };
}
function ei(t) {
  return {
    match: (e) => xe("date", e),
    error: t || "日期格式不正确"
  };
}
function ti(t) {
  return {
    match: (e) => xe("time", e),
    error: t || "时间格式不正确"
  };
}
function ni(t) {
  return {
    match: (e) => xe("datetime", e),
    error: t || "时间格式不正确"
  };
}
function ri(t, e) {
  let n = "";
  return {
    match: (r) => (n = `"${r}" 不在 "${t}" 范围内`, t.some((s) => s === r)),
    error: e || n
  };
}
function Z(t, e) {
  const n = e.reduce((r, s) => {
    const { match: i, error: o } = s;
    return i(t) || r.push(o), r;
  }, []);
  return {
    valid: n.length === 0,
    errors: n
  };
}
class N2 {
  criterias = [];
  constructor(e = []) {
    e.forEach((n) => this.add(n));
  }
  add(...e) {
    this.criterias.push(...e);
  }
  clear() {
    this.criterias = [];
  }
  get() {
    return (e) => Z(e, this.criterias);
  }
  run(e) {
    return this.get()(e);
  }
}
function U2(t) {
  return (e) => {
    const n = Z(e, [
      oe(t?.emptyError || "邮箱不能为空"),
      Ks(t?.error || "邮箱格式不正确")
    ]);
    if (!n.valid && t?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function B2(t) {
  return (e) => {
    const n = Z(e, [
      oe(t?.emptyError || "手机号不能为空"),
      Qs(t?.error || "手机格式不正确")
    ]);
    if (!n.valid && t?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function j2(t) {
  return (e) => {
    const n = Z(e, [
      oe(t?.emptyError || "日期不能为空"),
      ei(t?.error || "日期格式不正确")
    ]);
    if (!n.valid && t?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function q2(t) {
  return (e) => {
    const n = Z(e, [
      oe(t?.emptyError || "时间不能为空"),
      ti(t?.error || "时间格式不正确")
    ]);
    if (!n.valid && t?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function z2(t) {
  return (e) => {
    const n = Z(e, [
      oe(t?.emptyError || "时间不能为空"),
      ni(t?.error || "时间格式不正确")
    ]);
    if (!n.valid && t?.throw)
      throw new Error(n.errors[0]);
    return n;
  };
}
function H2(t) {
  return (e) => {
    const n = [oe(t?.emptyError)];
    typeof t?.min == "number" && n.push(Js(t.min, t?.minError)), typeof t?.max == "number" && n.push(Ys(t.max, t?.maxError));
    const r = Z(e, n);
    if (!r.valid && t?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function V2(t, e) {
  return (n) => {
    const r = [
      oe(e?.emptyError || e?.error),
      Zs(t, e?.error)
    ], s = Z(n, r);
    if (!s.valid && e?.throw)
      throw new Error(s.errors[0]);
    return s;
  };
}
function W2(t, e) {
  return (n) => {
    const r = Z(n, [ri(t, e?.error)]);
    if (!r.valid && e?.throw)
      throw new Error(r.errors[0]);
    return r;
  };
}
function G2(t) {
  const e = String(t).toLowerCase();
  if (e.indexOf("km") >= 0 || e.indexOf("m") >= 0)
    return e;
  const n = parseFloat(e);
  return n < 0 ? "" : n >= 1e3 ? Math.ceil(n / 1e3 * 10) / 10 + "km" : Math.ceil(n) + "m";
}
function X2(t, e = 2) {
  return zn(t / 100, e);
}
function J2(t, e) {
  const n = t.getReader();
  n.read().then(function r({ done: s, value: i }) {
    return e(i), s ? Promise.resolve(s) : n.read().then(r);
  });
}
class ye {
  value;
  left;
  right;
  constructor(e, n) {
    this.value = e, this.left = n?.left, this.right = n?.right;
  }
  clone() {
    return new ye(this.value, {
      left: this.left,
      right: this.right
    });
  }
}
class Y2 {
  root;
  constructor() {
  }
  add(e) {
    if (!this.root)
      this.root = new ye(e);
    else {
      let n = this.root;
      for (; n; )
        if (e === n.value) {
          console.log("Duplicates cannot be added");
          break;
        } else if (e < n.value)
          if (n.left)
            n = n.left;
          else {
            n.left = new ye(e);
            break;
          }
        else if (e > n.value)
          if (n.right)
            n = n.right;
          else {
            n.right = new ye(e);
            break;
          }
    }
  }
  remove(e) {
    let n = this.root, r, s;
    for (; n; )
      if (e < n.value)
        r = n, n = n.left;
      else if (e > n.value)
        r = n, n = n.right;
      else {
        s = n;
        break;
      }
    if (!s) {
      console.log("The node was not found");
      return;
    }
    if (r) {
      const i = r.left === s;
      if (!s.left && !s.right)
        i ? r.left = void 0 : r.right = void 0;
      else if (s.left && !s.right)
        i ? r.left = s.left : r.right = s.left;
      else if (s.right && !s.left)
        i ? r.left = s.right : r.right = s.right;
      else {
        const o = s.right, a = s.left;
        i ? r.left = o : r.right = o;
        let c = o, u;
        for (; c; )
          u = c, c = c.left;
        u && (u.left = a), console.log("The node was successfully deleted");
      }
    } else if (!s.left && !s.right)
      this.root = void 0;
    else if (s.left && !s.right)
      this.root = s.left;
    else if (s.right && !s.left)
      this.root = s.right;
    else {
      const i = s.right, o = s.left;
      this.root = i;
      let a = i, c;
      for (; a; )
        c = a, a = a.left;
      c && (c.left = o), console.log("The node was successfully deleted");
    }
    return s;
  }
  // 树的高度
  // 最大深度： root 到 叶子节点
  maxDepth(e = this.root) {
    let n = 0;
    const r = (s, i = 1) => {
      s && (!s.left && !s.right && (n = Math.max(n, i)), r(s.left, i + 1), r(s.right, i + 1));
    };
    return r(e), n;
  }
  // 最小深度： root 到 叶子节点
  minDepth(e = this.root) {
    if (!e)
      return 0;
    const n = [[e, 1]];
    for (; n.length; ) {
      const [r, s] = n.shift();
      if (!r.left && !r.right)
        return s;
      r.left && n.push([r.left, s + 1]), r.right && n.push([r.right, s + 1]);
    }
  }
  // 如果某二叉树中任意节点的左右子树的深度相差不超过 1，那么它就是一棵平衡二叉树
  // 该方法最坏的情况是每个父节点都只有一个子节点，这样树的高度时间复杂度为 O(n)，即“链表”的长度。而第 d 层调用 height 函数的时间复杂度是 O(d)，所以整体的时间复杂度为 高度时间复杂度 * 调用height函数的时间复杂度，即 O(n^2)。
  isBalance(e = this.root) {
    return e ? Math.abs(this.maxDepth(e.left) - this.maxDepth(e.right)) <= 1 && this.isBalance(e.left) && this.isBalance(e.right) : !0;
  }
  // 广度优先遍历
  bfs(e = this.root, n) {
    if (!e)
      return;
    const r = [e];
    for (; r.length; ) {
      const s = r.shift();
      if (!n?.(s))
        break;
      s.left && r.push(s.left), s.right && r.push(s.right);
    }
  }
  // 深度优先遍历
  dfs(e = this.root, n) {
    e && n?.(e) && (this.dfs(e.left, n), this.dfs(e.right, n));
  }
  // 递归遍历 - 先序遍历 current, left, right
  preOrderRecursive(e = this.root, n) {
    e && n?.(e) && (this.preOrderRecursive(e.left, n), this.preOrderRecursive(e.right, n));
  }
  // 递归遍历 - 中序遍历 left, current, right
  // 中序遍历：递增序列
  // 中序遍历倒序：递减序列
  inOrderRecursive(e = this.root, n) {
    e && (this.inOrderRecursive(e.left, n), n?.(e) && this.inOrderRecursive(e.right, n));
  }
  // 递归遍历 - 后序遍历 left, right, current
  postOrderRecursive(e = this.root, n) {
    e && (this.postOrderRecursive(e.left, n), this.postOrderRecursive(e.right, n), n?.(e));
  }
  // 非递归遍历 - 先序遍历 current, left, right
  preOrder(e = this.root, n) {
    const r = [];
    for (e && r.push(e); r.length && (e = r.pop(), !!n?.(e)); )
      e.right && r.push(e.right), e.left && r.push(e.left);
  }
  // 中序遍历：递增序列
  // 非递归遍历 - 中序遍历 left, current, right
  inOrder(e = this.root, n) {
    const r = [];
    for (; r.length || e; ) {
      for (; e; )
        r.push(e), e = e.left;
      if (e = r.pop(), !n?.(e))
        break;
      e = e.right;
    }
  }
  // 中序遍历倒序：递减序列 right, current, left
  inOrderReverse(e = this.root, n) {
    const r = [];
    for (; r.length || e; ) {
      for (; e; )
        r.push(e), e = e.right;
      if (e = r.pop(), !n?.(e))
        break;
      e = e.left;
    }
  }
  // 非递归遍历 - 后序遍历 left, right, current
  postOrder(e = this.root, n) {
    const r = [], s = [];
    for (e && r.push(e); r.length; )
      e = r.pop(), s.push(e), e.left && r.push(e.left), e.right && r.push(e.right);
    n && s.reverse().map(n);
  }
  // 获得第K大的节点, K从1开始
  kthLargest(e) {
    let n = 0, r;
    return this.inOrderReverse(this.root, (s) => (n++, n == e ? (r = s.value, !1) : !0)), r;
  }
  // 反转二叉树
  // 寻找递归公式
  // 解题要采用自上而下的思考方式，那我们取前面的 1， 2，3 结点来看，对于根节点 1 来说，假设 2, 3 结点下的节点都已经翻转，那么只要翻转 2， 3 节点即满足需求
  // 对于 2， 3 结点来说，也是翻转其左右节点即可,依此类推,对每一个根节点，依次翻转其左右节点，
  // 所以我们可知问题与子问题的关系是 翻转(根节点) = 翻转(根节点的左节点) + 翻转(根节点的右节点)
  // 即 invert(root) = invert(root->left) + invert(root->right),
  // 而显然递归的终止条件是当结点为叶子结点时终止（因为叶子节点没有左右结点）
  // 时间复杂度分析: 由于会对每一个节点都去做翻转，所以时间复杂度是 O(n)
  // 空间复杂度分析: 由于每次调用 invertTree 函数都相当于一次压栈操作，
  //   那最多压了几次栈呢，从根节点出发不断对左结果调用翻转函数, 直到叶子节点，每调用一次都会压栈，左节点调用完后，出栈，再对右节点压栈 ...,
  //   可知栈的大小为3， 即树的高度，如果是完全二叉树 ，则树的高度为logn, 即空间复杂度为O(logn)
  //   最坏情况，如果此二叉树是只有左节点，没有右节点，则树的高度即结点的个数 n，此时空间复杂度为 O(n)
  //   总的来看，空间复杂度为O(n)
  invertTree(e = this.root) {
    if (!e)
      return;
    const n = this.invertTree(e.left), r = this.invertTree(e.right);
    return e.right = n, e.left = r, e;
  }
}
class qt {
  value;
  toEdges;
  constructor(e, n = []) {
    this.value = e, this.toEdges = n;
  }
  clone() {
    return new qt(this.value, this.toEdges);
  }
}
class je {
  fromNode;
  toNode;
  // 权重
  weight;
  constructor(e, n, r = 1) {
    this.fromNode = e, this.toNode = n, this.weight = r;
  }
  clone() {
    return new je(this.fromNode, this.toNode, this.weight);
  }
}
class Z2 {
  // 有无方向
  isdirected;
  nodes = [];
  visitFn;
  constructor(e = !1, n) {
    this.isdirected = e, this.visitFn = n || ((r) => console.log(r.value + ","));
  }
  addNode(e) {
    this.nodes.push(new qt(e));
  }
  removeNode(e) {
    this.nodes = this.nodes.filter((n) => n.value !== e), this.nodes.forEach((n) => {
      n.toEdges = n.toEdges.filter((r) => r.toNode.value !== e);
    });
  }
  findNode(e) {
    return this.nodes.find((n) => n.value === e);
  }
  addEdge(e, n, r = 1) {
    const s = this.findNode(e), i = this.findNode(n);
    s && i && (s.toEdges.push(new je(s, i, r)), this.isdirected && i.toEdges.push(new je(i, s, r)));
  }
  // 邻接矩阵
  toMatrixArray() {
    const e = this.nodes.length, n = Array.from(
      { length: e },
      () => Array(e).fill(0)
    );
    return this.nodes.forEach((r, s) => {
      r.toEdges.forEach((i) => {
        const o = this.nodes.indexOf(i.toNode);
        n[s][o] = 1;
      });
    }), n;
  }
  // 邻接表
  toLinkedArrayObject() {
    const e = this.nodes.length, n = {};
    for (let r = 0; r < e; r++) {
      const s = [];
      this.nodes[r].toEdges.forEach((i) => {
        s.push(this.nodes.indexOf(i.toNode));
      }), n[String(this.nodes[r].value)] = s;
    }
    return n;
  }
  // 深度优先遍历
  dfs(e, n = /* @__PURE__ */ new Set()) {
    this.visitFn(e), n.add(e), e.toEdges.forEach((r) => {
      n.has(r.toNode) || this.dfs(r.toNode, n);
    });
  }
  // 广度优先遍历
  wfs(e) {
    const n = /* @__PURE__ */ new Set(), r = [e];
    for (; r.length; ) {
      const s = r.shift();
      this.visitFn(s), n.add(s), s.toEdges.forEach((i) => {
        n.has(i.toNode) || r.push(i.toNode);
      });
    }
  }
}
class nt {
  heap = [];
  compareFn;
  constructor(e, n) {
    if (this.compareFn = e, n) {
      this.heap = n;
      const r = this.size() - 1, s = this.getParentIndex(r);
      for (let i = s; i >= 0; i--)
        this.shiftDown(i);
    }
  }
  size() {
    return this.heap.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  // 获取父元素坐标
  getParentIndex(e) {
    return e - 1 >> 1;
  }
  // 获取左子节点元素坐标
  getLeftChildIndex(e) {
    const n = e * 2 + 1;
    return n < this.size() ? n : null;
  }
  // 获取右子节点元素坐标
  getRightChildIndex(e) {
    const n = e * 2 + 2;
    return n < this.size() ? n : null;
  }
  // 交换元素
  swap(e, n) {
    e >= 0 && e < this.size() && n >= 0 && n < this.size() && ([this.heap[e], this.heap[n]] = [this.heap[n], this.heap[e]]);
  }
  // 查看堆顶元素
  peek() {
    return this.heap[0];
  }
  // 尾部插入元素
  // 时间复杂度O(logN)
  push(e) {
    this.heap.push(e), this.shiftUp(this.size() - 1);
  }
  // 上移操作
  shiftUp(e) {
    if (e === 0)
      return;
    const n = this.getParentIndex(e);
    this.compareFn(this.heap[n], this.heap[e]) || (this.swap(n, e), this.shiftUp(n));
  }
  // 堆顶删除元素
  // 时间复杂度O(logN)
  pop() {
    if (this.isEmpty())
      return null;
    {
      const e = this.heap[0], n = this.heap.pop();
      return n !== void 0 && !this.isEmpty() && (this.heap[0] = n, this.shiftDown(0)), e;
    }
  }
  // 下移操作
  shiftDown(e) {
    if (e >= this.size() - 1)
      return;
    const n = this.getLeftChildIndex(e), r = this.getRightChildIndex(e);
    n && !this.compareFn(this.heap[e], this.heap[n]) && (this.swap(n, e), this.shiftDown(n)), r && !this.compareFn(this.heap[e], this.heap[r]) && (this.swap(r, e), this.shiftDown(r));
  }
}
const K2 = nt;
class Q2 extends nt {
  constructor(e, n) {
    const r = (s, i) => s > i;
    super(e ?? r, n);
  }
}
class eu extends nt {
  constructor(e, n) {
    const r = (s, i) => s < i;
    super(e ?? r, n);
  }
}
class zt {
  value;
  next;
  constructor(e, n) {
    this.value = e, this.next = n;
  }
  clone() {
    return new zt(this.value, this.next);
  }
}
class si {
  head;
  tail;
  length = 0;
  constructor() {
  }
  size() {
    return this.length;
  }
  isEmpty() {
    return this.size() === 0;
  }
  insert(e, n) {
    const r = new zt(n);
    if (e == 0)
      return r.next = this.head, this.head = r, this.isEmpty() && (this.tail = this.head), this.length++, !0;
    {
      let s = this.head, i = this.head?.next, o = 1;
      for (; o++ < e; )
        s = i, i = i?.next;
      return s ? (s.next = r, r.next = i, i || (this.tail = r), this.length++, !0) : !1;
    }
  }
  delete(e) {
    if (!this.isEmpty())
      if (e == 0) {
        const n = this.head;
        return this.size() == 1 ? this.head = this.tail = void 0 : this.head = this.head?.next, this.length--, n;
      } else {
        let n = this.head, r = this.head?.next, s = 1;
        for (; s++ < e && r; )
          n = r, r = r?.next;
        return n ? (n.next = r?.next, (!r || !r.next) && (this.tail = n), r && this.length--, r) : void 0;
      }
  }
  deleteNode(e) {
    e.next ? (e.value = e.next.value, e.next = e.next.next, e.next || (this.tail = e), this.length--) : this.pop();
  }
  // 尾部加入
  push(e) {
    return this.insert(this.size(), e);
  }
  // 尾部删除
  pop() {
    return this.delete(this.size() - 1);
  }
  // 头部加入
  unshift(e) {
    return this.insert(0, e);
  }
  // 头部删除
  shift() {
    return this.delete(0);
  }
  // 遍历
  // visitFn 返回 true 继续遍历， 返回 false 中断遍历
  traverse(e) {
    let n = this.head, r = 0;
    for (; n && e?.(n, r++); )
      n = n.next;
  }
  at(e) {
    if (e < 0 || e >= this.size() || this.isEmpty())
      return;
    if (e === 0)
      return this.head;
    if (e === this.size() - 1)
      return this.tail;
    let n = this.head;
    for (; --e >= 0 && n; )
      n = n.next;
    return n;
  }
  getIndex(e) {
    let n = -1;
    return this.traverse((r, s) => (r.value == e && (n = s), n == -1)), n;
  }
  toArray() {
    const e = [];
    return this.traverse((n) => (e.push(n.value), !0)), e;
  }
  // 列表反转
  // 时间复杂度 O(N)
  reverse() {
    this.tail = this.head;
    let e, n;
    for (; this.head && this.head.next; )
      e = n, n = this.head, this.head = this.head.next, n.next = e;
    return this.head && (this.head.next = n), this;
  }
  // 快慢指针: 判断链表中是否有环
  hasCycle(e = this.head) {
    if (!e || !e.next)
      return !1;
    let n = e, r = e.next;
    for (; n !== r; ) {
      if (!n || !r || !r.next)
        return !1;
      n = n.next, r = r.next.next;
    }
    return !0;
  }
}
const H = {
  THROW: 1,
  DROP: 2,
  SLIDE: 3,
  EXPAND: 4
};
class Re {
  queue;
  limit;
  overflow;
  constructor(e = 10, n = H.EXPAND) {
    this.queue = [], this.limit = e, this.overflow = n;
  }
  length() {
    return this.queue.length;
  }
  isEmpty() {
    return this.length() === 0;
  }
  findIndex(e) {
    return this.queue.findIndex(e);
  }
  deleteIndex(e) {
    return !!this.queue.splice(e, 1).length;
  }
  delete(e) {
    const n = this.findIndex(e);
    return n > -1 ? this.deleteIndex(n) : !1;
  }
  // 入队
  enqueue(e) {
    if (this.length() < this.limit) {
      this.queue.push(e);
      return;
    }
    switch (this.overflow) {
      case H.EXPAND:
        this.limit *= 2, this.queue.push(e);
        break;
      case H.SLIDE:
        this.deleteIndex(0), this.queue.push(e);
        break;
      case H.THROW:
        throw new Error(`Queue limit(${this.limit}) overflow!`);
      case H.DROP:
    }
  }
  push(e) {
    this.enqueue(e);
  }
  put(e) {
    this.enqueue(e);
  }
  // 出队
  dequeue() {
    return this.queue.shift();
  }
  pop() {
    return this.dequeue();
  }
  take() {
    return this.dequeue();
  }
  // 获取队顶对象
  peek() {
    return this.queue[0];
  }
  // 获取对象
  index(e) {
    return this.queue[e];
  }
  // 全部出队
  clear() {
    this.queue = [];
  }
  // 全部出队
  flush() {
    const e = [];
    let n;
    for (; n = this.dequeue(); )
      e.push(n);
    return e;
  }
}
const tu = () => new Re(0, H.DROP), nu = (t) => new Re(t, H.THROW), ru = (t) => new Re(t, H.DROP), su = (t) => new Re(t, H.SLIDE), ii = (t) => new Re(t, H.EXPAND);
class iu {
  stack;
  constructor() {
    this.stack = [];
  }
  get length() {
    return this.stack.length;
  }
  isEmpty() {
    return this.length === 0;
  }
  push(e) {
    return this.stack.push(e);
  }
  pop() {
    return this.stack.pop();
  }
  peek() {
    return this.stack[this.length - 1];
  }
  clear() {
    this.stack = [];
  }
}
const un = {
  SLIDE: 1,
  EXPAND: 2
};
class ou {
  size;
  table;
  objectSignature;
  overflow;
  ttl;
  constructor(e) {
    this.table = new Array(e?.size || 137), this.size = this.table.length, this.objectSignature = e?.objectSignature || ((n) => String(n)), this.overflow = e?.overflow || un.EXPAND, this.ttl = e?.ttl || 6e4;
  }
  // 散列函数，纯函数
  hash(e) {
    if (e == null || e == null)
      throw new Error("HashTable can't put undefined or null");
    const n = this.objectSignature(e), r = 31;
    let s = 0;
    for (let i = 0, o = n.length; i < o; i++)
      s += r * s + n.charCodeAt(i);
    return s % this.size;
  }
  // 扩展散列表大小至一个更大的质数
  resize() {
    const e = this.size, n = ws(this.size * 2), r = new Array(n), s = this.table;
    this.table = r, this.size = n;
    for (let i = 0, o = e; i < o; i++)
      if (s[i] !== void 0 && !this.isOutdated(s[i])) {
        let a = this.hash(s[i].value);
        for (; r[a] !== void 0; )
          a = (a + 1) % n;
        r[a] = s[i];
      }
    s.length = 0;
  }
  put(e) {
    this.size > 200 && Math.random() < 0.1 && this.clean();
    let n = this.hash(e);
    const r = n;
    for (; this.table[n] !== void 0 && !this.isOutdated(this.table[n]); )
      if (n = (n + 1) % this.size, r == n) {
        if (this.overflow == un.EXPAND)
          return this.resize(), this.put(e);
        break;
      }
    return this.table[n] = { value: e, timestamp: Date.now() }, n;
  }
  // 性能瓶颈
  // visitFn : return false to break loop
  traverse(e) {
    for (let n = 0, r = this.size; n < r; n++)
      if (this.table[n] !== void 0 && !e(this.table[n].value, n))
        return n;
    return -1;
  }
  // filter : return false 删除
  update(e) {
    this.traverse((n, r) => (e(n) === !1 && this.deleteIndex(r), !0));
  }
  getIndex(e) {
    let n = this.hash(e);
    const r = n;
    for (; this.table[n]?.value !== e; )
      if (this.table[n] === void 0 || (this.isOutdated(this.table[n]) && (this.table[n] = void 0), n = (n + 1) % this.size, r == n))
        return -1;
    return this.isOutdated(this.table[n]) ? (this.table[n] = void 0, -1) : n;
  }
  has(e) {
    return this.getIndex(e) >= 0;
  }
  // 性能瓶颈
  find(e) {
    const n = this.traverse((r) => !e(r));
    return n >= 0 ? this.table[n]?.value : void 0;
  }
  deleteIndex(e) {
    return e >= 0 && e < this.size && this.table[e] !== void 0 ? (this.table[e] = void 0, !0) : !1;
  }
  delete(e) {
    return this.deleteIndex(this.getIndex(e));
  }
  clear() {
    this.table = [];
  }
  // 数据是否过期
  isOutdated(e) {
    return Date.now() - e.timestamp > this.ttl;
  }
  // 性能瓶颈
  // 供外部使用：主动清理过期数据
  clean() {
    for (let e = 0, n = this.size; e < n; e++)
      this.table[e] !== void 0 && this.isOutdated(this.table[e]) && (this.table[e] = void 0);
  }
}
class au {
  obj = {};
  constructor() {
  }
  put(e, n) {
    this.obj[e] = this.obj[e] || [], this.obj[e].push(n);
  }
  get(e) {
    return this.obj[e] || [];
  }
  has(e) {
    let n = !1;
    return this.traverse((r) => r == e ? (n = !0, !1) : !0), n;
  }
  keys() {
    const e = [];
    for (const n in this.obj)
      e.push(n);
    return e;
  }
  // visitFn : return false to break loop
  traverse(e) {
    for (const n in this.obj)
      for (let r = 0, s = this.obj[n].length; r < s && e(this.obj[n][r]); r++)
        ;
  }
}
class rt {
  maps = /* @__PURE__ */ new Map();
  constructor() {
  }
  // Object.entries(...);
  // Object.fromEntries(...);
  entries() {
    return [...this.maps.entries()];
  }
  // Object.keys(...);
  keys() {
    return [...this.maps.keys()];
  }
  // Object.values(...);
  values() {
    return [...this.maps.values()];
  }
  json() {
    const e = {};
    for (const n of this.maps)
      e[n[0]] = n[1];
    return e;
  }
  get length() {
    return this.maps.size;
  }
  set(e, n) {
    this.maps.set(e, n);
  }
  get(e) {
    return this.maps.get(e);
  }
  has(e) {
    return this.maps.has(e);
  }
  // Map 对象是按插入的顺序返回键值
  getEntryFromIndex(e) {
    let n = -1;
    for (const r of this.maps)
      if (++n == e)
        return r;
  }
  // 性能瓶颈
  getEntry(e) {
    for (const n of this.maps)
      if (e(n[0], n[1]))
        return n;
  }
  firstEntry() {
    return this.getEntryFromIndex(0);
  }
  // 从头部删除
  shift() {
    const e = this.firstEntry();
    if (e) {
      const [n] = e;
      this.delete(n);
    }
    return e;
  }
  delete(e) {
    return this.maps.delete(e);
  }
  clear() {
    this.maps.clear();
  }
  // filter : return false 删除
  update(e) {
    const n = this.entries();
    for (let r = 0, s = n.length; r < s; r++) {
      const [i, o] = n[r];
      e(i, o) === !1 && this.delete(i);
    }
  }
}
class Jn extends rt {
  constructor(e) {
    super();
    for (const n in e)
      super.set(n, e[n]), this[n] = e[n].serverValue;
  }
  clone() {
    return new Jn(this.json());
  }
  // types(): readonly string[] {
  //   const types = [...super.keys()] as const;
  //   type Types = (typeof types)[number];
  //   return types;
  // }
  isExist(e) {
    return !!super.values().find((n) => n.serverValue === e);
  }
  getName(e) {
    const n = super.values().find((r) => r.serverValue === e);
    return n ? n.name || n.serverDescription : "";
  }
  setName(e, n) {
    const r = super.values().find((s) => s.serverValue === e);
    r && (r.name = n);
  }
}
function cu() {
  E.OPEN_LOG = !0;
}
function uu() {
  E.OPEN_LOG = !1;
}
function lu(t) {
  E.LOG_UPLOAD_FN = t;
}
function fe() {
  return !!E.OPEN_LOG;
}
function Ht(t) {
  E.LOG_UPLOAD_FN && E.LOG_UPLOAD_FN(t);
}
function R(t) {
  Ht({ level: "info", msg: t }), fe() && (!console || typeof console != "object" || typeof console.log != "function" || console.log(t));
}
function oi(t) {
  Ht({ level: "warn", msg: t }), fe() && (!console || typeof console != "object" || typeof console.warn != "function" || console.warn(t));
}
function fu(t) {
  Ht({ level: "error", msg: t }), fe() && (!console || typeof console != "object" || typeof console.error != "function" || console.error(t));
}
const Ce = {}, ln = {
  start: (t) => {
    fe() && (!console || typeof console != "object" || // typeof console.group !== "function"
    typeof console.groupCollapsed != "function" || console.groupCollapsed(t));
  },
  end: () => {
    !console || typeof console != "object" || typeof console.groupEnd != "function" || console.groupEnd();
  }
}, qe = {
  start: (t) => {
    fe() && (Ce[t] = Be());
  },
  end: (t) => {
    Ce[t] && (R(`${t}: ${Be() - Ce[t]} ms`), delete Ce[t]);
  }
}, fn = {
  start: (t) => {
    fe() && (!console || typeof console != "object" || typeof console.profile != "function" || console.profile(t));
  },
  end: (t) => {
    !console || typeof console != "object" || typeof console.profileEnd != "function" || console.profileEnd(t);
  }
}, ai = () => {
}, hu = (t) => t, Yn = (t) => () => t, du = Yn(!0), pu = Yn(!1), mu = (t) => ({ value: t, done: !0 });
function gu(t, e, n) {
  return Object.assign({}, n, { [t]: e });
}
const Zn = 300;
function ci(t, e = Zn, n) {
  const r = typeof n?.leading == "boolean" ? n.leading : !0, s = typeof n?.trailing == "boolean" ? n.trailing : !1;
  let i = !0, o;
  return function(...c) {
    if (!i) {
      o = c;
      return;
    }
    i = !1, r && t.apply(n?.thisArg || this, c), s && (o = c), setTimeout(() => {
      s && t.apply(n?.thisArg || this, o), o = void 0, i = !0;
    }, e);
  };
}
function ui(t, e = Zn, n) {
  let r, s = 0;
  return function(...o) {
    let a = !!n?.immediate && !r;
    !a && n?.throttle && (a = !!s && Be() - s >= e), r && clearTimeout(r);
    const c = () => {
      t.apply(n?.thisArg || this, o), n?.throttle && (s = Be());
    };
    r = setTimeout(() => {
      a || c(), r = void 0;
    }, e), a && c();
  };
}
function li(t, ...e) {
  const n = t.length;
  return e = e || [], function(...r) {
    const s = e.concat(Array.prototype.slice.call(r));
    return s.length < n ? li.call(this, t, ...s) : t.apply(this, s);
  };
}
function fi(...t) {
  return t.length === 0 ? (...e) => e : t.length === 1 ? t[0] : t.reduce(
    (e, n) => (...r) => e(n(...r))
  );
}
const yu = (...t) => t.length === 0 ? (...e) => e : t.length === 1 ? t[0] : t.reduceRight(
  (e, n) => (...r) => e(n(...r))
), wu = (...t) => t.length === 0 ? (...e) => e : t.length === 1 ? t[0] : t.reduceRight(
  (e, n) => (...r) => n(...r, e),
  ai
);
function bu(t) {
  for (; t && t instanceof Function; )
    t = t();
  return t;
}
function Su(t) {
  let e, n = !1;
  const r = [];
  return function(...i) {
    if (r.push(i), !n) {
      for (n = !0; r.length; )
        e = t.apply(this, r.shift());
      return n = !1, e;
    }
  };
}
function xu(t, e) {
  return function(...n) {
    return t.apply(e || this, n.reverse());
  };
}
function Au(t, e) {
  let n = !1, r;
  return async function(...s) {
    return n || (n = !0, r = await t.apply(e || this, s)), r;
  };
}
function hi(t = 0, e) {
  const n = e?.min || 300, r = e?.max || 6e4, s = e?.exponent || 2, i = e?.factor || 0.5;
  let o = n * Math.pow(s, t);
  if (i) {
    const a = Math.random(), c = Math.floor(a * i * o);
    o = Math.floor(a * 10) & 1 ? o + c : o - c;
  }
  return Math.min(o, r) | 0;
}
function Kn(t, e = 3, n, r) {
  return async function(...s) {
    const i = `retry(${t.name})(${s.map((a) => L(a))})`;
    let o;
    for (let a = 0; a < e; a++)
      try {
        return await t.call(r || this, ...s);
      } catch (c) {
        R(`(${i}) 第 ${a + 1} 次尝试失败, retrying...`), o = c, await new Promise(
          (u) => setTimeout(
            u,
            typeof n == "number" ? n : hi(a)
            // : 300 * Math.pow(2, attempt)
          )
        );
      }
    throw R(
      `(${i}) 已 ${e} 次失败，不再重试。 Last error: ${L(
        o
      )}`
    ), o;
  };
}
function Qn(t, e = 60, n = new rt(), r) {
  return async function(...s) {
    const i = `cache(${t.name})(${s.map((u) => L(u))})`, o = Date.now();
    e && n.update((u, l) => o - l.timestamp < e * 1e3);
    const a = $t(s), c = n.get(a);
    if (c) {
      if (!e || o - c.timestamp < e * 1e3)
        return R(`${i} 击中缓存`), c.value;
      n.delete(a);
    }
    try {
      R(`${i} 没有缓存, 尝试立即执行...`);
      const l = await t.call(r || this, ...s);
      return R(`${i} 缓存设置成功`), n.set(a, {
        value: l,
        timestamp: Date.now()
      }), l;
    } catch (u) {
      throw R(`${i} 执行失败 : ${L(u)}`), u;
    }
  };
}
function di(t, e = new rt(), n) {
  return async function(...r) {
    const s = $t(r), i = `memorize(${t.name})(${r.map((a) => L(a))})`, o = await e.get(s);
    if (o)
      return R(`${i} memorize hit: ${L(o)}`), o;
    try {
      R(`${i} memorize miss, await fetching fresh data...`);
      const a = await t.call(n || this, ...r);
      return R(`${i} memorize settled`), await e.set(s, a), a;
    } catch (a) {
      throw R(`${i} returns error: ${L(a)}`), a;
    }
  };
}
function Ou(t, e) {
  const { ignoreResult: n = () => !1 } = e || {};
  return async (...r) => {
    for (let s = 0, i = t.length; s < i; s++)
      try {
        const o = await t[s](...r);
        if (!n(o))
          return o;
      } catch (o) {
        e?.onError?.(o);
      }
    throw new Error("tryEach failed. No function returned a value");
  };
}
function vu(t, e, n) {
  return function(...r) {
    return t.apply(this, r) ? e.apply(this, r) : n.apply(this, r);
  };
}
function Ru(t, e) {
  return function(...n) {
    try {
      return t.apply(this, n);
    } catch (r) {
      return e.apply(this, r);
    }
  };
}
function _u(t) {
  return (e) => (R(t + ": " + e), e);
}
function Tu(t, e) {
  return function(n) {
    return t.call(this, e(n));
  };
}
const Eu = (t) => (e) => e.map(t), ku = (t) => (e, n) => e.reduce(t, n);
var Ot = function(t, e) {
  return Ot = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var s in r)
      Object.prototype.hasOwnProperty.call(r, s) && (n[s] = r[s]);
  }, Ot(t, e);
};
function Vt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Ot(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
function pi(t, e, n, r) {
  function s(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (h) {
        o(h);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (h) {
        o(h);
      }
    }
    function u(l) {
      l.done ? i(l.value) : s(l.value).then(a, c);
    }
    u((r = r.apply(t, e || [])).next());
  });
}
function er(t, e) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, s, i, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (n = 0)), n; )
      try {
        if (r = 1, s && (i = u[0] & 2 ? s.return : u[0] ? s.throw || ((i = s.return) && i.call(s), 0) : s.next) && !(i = i.call(s, u[1])).done)
          return i;
        switch (s = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, s = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = e.call(t, n);
      } catch (l) {
        u = [6, l], s = 0;
      } finally {
        r = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function be(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n)
    return n.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ze(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), s, i = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(s = r.next()).done; )
      i.push(s.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      s && !s.done && (n = r.return) && n.call(r);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}
function He(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, s = e.length, i; r < s; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function ue(t) {
  return this instanceof ue ? (this.v = t, this) : new ue(t);
}
function mi(t, e, n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(t, e || []), s, i = [];
  return s = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", o), s[Symbol.asyncIterator] = function() {
    return this;
  }, s;
  function o(d) {
    return function(p) {
      return Promise.resolve(p).then(d, h);
    };
  }
  function a(d, p) {
    r[d] && (s[d] = function(g) {
      return new Promise(function(y, w) {
        i.push([d, g, y, w]) > 1 || c(d, g);
      });
    }, p && (s[d] = p(s[d])));
  }
  function c(d, p) {
    try {
      u(r[d](p));
    } catch (g) {
      m(i[0][3], g);
    }
  }
  function u(d) {
    d.value instanceof ue ? Promise.resolve(d.value.v).then(l, h) : m(i[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function h(d) {
    c("throw", d);
  }
  function m(d, p) {
    d(p), i.shift(), i.length && c(i[0][0], i[0][1]);
  }
}
function gi(t) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var e = t[Symbol.asyncIterator], n;
  return e ? e.call(t) : (t = typeof be == "function" ? be(t) : t[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(i) {
    n[i] = t[i] && function(o) {
      return new Promise(function(a, c) {
        o = t[i](o), s(a, c, o.done, o.value);
      });
    };
  }
  function s(i, o, a, c) {
    Promise.resolve(c).then(function(u) {
      i({ value: u, done: a });
    }, o);
  }
}
function C(t) {
  return typeof t == "function";
}
function yi(t) {
  var e = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var ht = yi(function(t) {
  return function(n) {
    t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, s) {
      return s + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function hn(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var Wt = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, r, s, i;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = be(o), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (g) {
            e = { error: g };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (e)
                throw e.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (C(l))
        try {
          l();
        } catch (g) {
          i = g instanceof ht ? g.errors : [g];
        }
      var h = this._finalizers;
      if (h) {
        this._finalizers = null;
        try {
          for (var m = be(h), d = m.next(); !d.done; d = m.next()) {
            var p = d.value;
            try {
              dn(p);
            } catch (g) {
              i = i ?? [], g instanceof ht ? i = He(He([], ze(i)), ze(g.errors)) : i.push(g);
            }
          }
        } catch (g) {
          r = { error: g };
        } finally {
          try {
            d && !d.done && (s = m.return) && s.call(m);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      if (i)
        throw new ht(i);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        dn(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && hn(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && hn(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}();
Wt.EMPTY;
function tr(t) {
  return t instanceof Wt || t && "closed" in t && C(t.remove) && C(t.add) && C(t.unsubscribe);
}
function dn(t) {
  C(t) ? t() : t.unsubscribe();
}
var nr = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, vt = {
  setTimeout: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    var s = vt.delegate;
    return s?.setTimeout ? s.setTimeout.apply(s, He([t, e], ze(n))) : setTimeout.apply(void 0, He([t, e], ze(n)));
  },
  clearTimeout: function(t) {
    var e = vt.delegate;
    return (e?.clearTimeout || clearTimeout)(t);
  },
  delegate: void 0
};
function rr(t) {
  vt.setTimeout(function() {
    throw t;
  });
}
function Rt() {
}
function wi(t) {
  t();
}
var Gt = function(t) {
  Vt(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, tr(n) && n.add(r)) : r.destination = Ai, r;
  }
  return e.create = function(n, r, s) {
    return new _t(n, r, s);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(Wt), bi = Function.prototype.bind;
function dt(t, e) {
  return bi.call(t, e);
}
var Si = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (r) {
        Pe(r);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (r) {
        Pe(r);
      }
    else
      Pe(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        Pe(n);
      }
  }, t;
}(), _t = function(t) {
  Vt(e, t);
  function e(n, r, s) {
    var i = t.call(this) || this, o;
    if (C(n) || !n)
      o = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: s ?? void 0
      };
    else {
      var a;
      i && nr.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return i.unsubscribe();
      }, o = {
        next: n.next && dt(n.next, a),
        error: n.error && dt(n.error, a),
        complete: n.complete && dt(n.complete, a)
      }) : o = n;
    }
    return i.destination = new Si(o), i;
  }
  return e;
}(Gt);
function Pe(t) {
  rr(t);
}
function xi(t) {
  throw t;
}
var Ai = {
  closed: !0,
  next: Rt,
  error: xi,
  complete: Rt
}, Xt = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Oi(t) {
  return t;
}
function vi() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return sr(t);
}
function sr(t) {
  return t.length === 0 ? Oi : t.length === 1 ? t[0] : function(n) {
    return t.reduce(function(r, s) {
      return s(r);
    }, n);
  };
}
var ee = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, r) {
    var s = this, i = _i(e) ? e : new _t(e, n, r);
    return wi(function() {
      var o = s, a = o.operator, c = o.source;
      i.add(a ? a.call(i, c) : c ? s._subscribe(i) : s._trySubscribe(i));
    }), i;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var r = this;
    return n = pn(n), new n(function(s, i) {
      var o = new _t({
        next: function(a) {
          try {
            e(a);
          } catch (c) {
            i(c), o.unsubscribe();
          }
        },
        error: i,
        complete: s
      });
      r.subscribe(o);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[Xt] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return sr(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = pn(e), new e(function(r, s) {
      var i;
      n.subscribe(function(o) {
        return i = o;
      }, function(o) {
        return s(o);
      }, function() {
        return r(i);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function pn(t) {
  var e;
  return (e = t ?? nr.Promise) !== null && e !== void 0 ? e : Promise;
}
function Ri(t) {
  return t && C(t.next) && C(t.error) && C(t.complete);
}
function _i(t) {
  return t && t instanceof Gt || Ri(t) && tr(t);
}
function Ti(t) {
  return C(t?.lift);
}
function Jt(t) {
  return function(e) {
    if (Ti(e))
      return e.lift(function(n) {
        try {
          return t(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ve(t, e, n, r, s) {
  return new Ei(t, e, n, r, s);
}
var Ei = function(t) {
  Vt(e, t);
  function e(n, r, s, i, o, a) {
    var c = t.call(this, n) || this;
    return c.onFinalize = o, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : t.prototype._next, c._error = i ? function(u) {
      try {
        i(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._error, c._complete = s ? function() {
      try {
        s();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : t.prototype._complete, c;
  }
  return e.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      t.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, e;
}(Gt), ki = function(t) {
  return t && typeof t.length == "number" && typeof t != "function";
};
function Ci(t) {
  return C(t?.then);
}
function Pi(t) {
  return C(t[Xt]);
}
function Di(t) {
  return Symbol.asyncIterator && C(t?.[Symbol.asyncIterator]);
}
function Mi(t) {
  return new TypeError("You provided " + (t !== null && typeof t == "object" ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Ii() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var Li = Ii();
function $i(t) {
  return C(t?.[Li]);
}
function Fi(t) {
  return mi(this, arguments, function() {
    var n, r, s, i;
    return er(this, function(o) {
      switch (o.label) {
        case 0:
          n = t.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, ue(n.read())];
        case 3:
          return r = o.sent(), s = r.value, i = r.done, i ? [4, ue(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, ue(s)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function Ni(t) {
  return C(t?.getReader);
}
function Ui(t) {
  if (t instanceof ee)
    return t;
  if (t != null) {
    if (Pi(t))
      return Bi(t);
    if (ki(t))
      return ji(t);
    if (Ci(t))
      return qi(t);
    if (Di(t))
      return ir(t);
    if ($i(t))
      return zi(t);
    if (Ni(t))
      return Hi(t);
  }
  throw Mi(t);
}
function Bi(t) {
  return new ee(function(e) {
    var n = t[Xt]();
    if (C(n.subscribe))
      return n.subscribe(e);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function ji(t) {
  return new ee(function(e) {
    for (var n = 0; n < t.length && !e.closed; n++)
      e.next(t[n]);
    e.complete();
  });
}
function qi(t) {
  return new ee(function(e) {
    t.then(function(n) {
      e.closed || (e.next(n), e.complete());
    }, function(n) {
      return e.error(n);
    }).then(null, rr);
  });
}
function zi(t) {
  return new ee(function(e) {
    var n, r;
    try {
      for (var s = be(t), i = s.next(); !i.done; i = s.next()) {
        var o = i.value;
        if (e.next(o), e.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        i && !i.done && (r = s.return) && r.call(s);
      } finally {
        if (n)
          throw n.error;
      }
    }
    e.complete();
  });
}
function ir(t) {
  return new ee(function(e) {
    Vi(t, e).catch(function(n) {
      return e.error(n);
    });
  });
}
function Hi(t) {
  return ir(Fi(t));
}
function Vi(t, e) {
  var n, r, s, i;
  return pi(this, void 0, void 0, function() {
    var o, a;
    return er(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = gi(t), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done)
            return [3, 4];
          if (o = r.value, e.next(o), e.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), s = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (i = n.return) ? [4, i.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (s)
            throw s.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return e.complete(), [2];
      }
    });
  });
}
function or(t, e) {
  return Jt(function(n, r) {
    var s = 0;
    n.subscribe(Ve(r, function(i) {
      r.next(t.call(e, i, s++));
    }));
  });
}
var Wi = new ee(Rt);
function Gi(t, e) {
  return Jt(function(n, r) {
    var s = 0;
    n.subscribe(Ve(r, function(i) {
      return t.call(e, i, s++) && r.next(i);
    }));
  });
}
function Xi(t, e) {
  return Jt(function(n, r) {
    var s = null, i = 0, o = !1, a = function() {
      return o && !s && r.complete();
    };
    n.subscribe(Ve(r, function(c) {
      s?.unsubscribe();
      var u = 0, l = i++;
      Ui(t(c, l)).subscribe(s = Ve(r, function(h) {
        return r.next(e ? e(c, h, l, u++) : h);
      }, function() {
        s = null, a();
      }));
    }, function() {
      o = !0, a();
    }));
  });
}
function Cu() {
  return vi(
    Gi((t) => !(t % 2)),
    or((t) => t + t)
  );
}
function Pu(t) {
  return (e) => new ee((n) => {
    const r = /* @__PURE__ */ new Set();
    let s = !1;
    const i = e.subscribe({
      next(o) {
        const a = setTimeout(() => {
          n.next(o), r.delete(a), s && r.size === 0 && n.complete();
        }, t);
        r.add(a);
      },
      error(o) {
        n.error(o);
      },
      complete() {
        s = !0, r.size === 0 && n.complete();
      }
    });
    return () => {
      i.unsubscribe();
      for (const o of r)
        clearTimeout(o);
    };
  });
}
function Du(t, e) {
  return t.pipe(Xi((n) => n ? e : Wi));
}
function Mu(t, e) {
  return t.pipe(or((n) => n[e]));
}
function Iu(t, e) {
  return t.name == e.name || t.constructor.name == e.name || t instanceof e;
}
class Lu extends Error {
  name;
  response;
  statusCode;
  constructor(e, n) {
    super(e), this.name = "HttpError", this.response = n, this.statusCode = n.status;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      response: this.response,
      statusCode: this.statusCode
    };
  }
}
let we;
function $u(t) {
  we = t, t(), we = null;
}
class Ji {
  subscribers = /* @__PURE__ */ new Set();
  add() {
    we && !this.subscribers.has(we) && this.subscribers.add(we);
  }
  notify(e) {
    this.subscribers.forEach((n) => n(e));
  }
}
const mn = /* @__PURE__ */ new WeakMap();
function Ie(t, e) {
  let n = mn.get(t);
  n || (n = /* @__PURE__ */ new Map(), mn.set(t, n));
  let r = n.get(e);
  return r || (r = new Ji(), n.set(e, r)), r;
}
function Yi(t, e = We, n) {
  if (!Array.isArray(t))
    return;
  const r = n?.path || "", s = n?.callback, i = Array.prototype, o = Object.create(i);
  ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(
    (a) => {
      o[a] = function(...c) {
        const u = this.slice();
        ["push", "unshift", "splice"].includes(a) && (a === "splice" ? c.slice(2).forEach((d, p) => {
          J(d) && (c[p + 2] = e(d, {
            deep: !0,
            path: r,
            callback: s
          }));
        }) : c.forEach((m, d) => {
          J(m) && (c[d] = e(m, {
            deep: !0,
            path: r,
            callback: s
          }));
        })), i[a].apply(this, c);
        const l = this.slice();
        return s && s({ path: r, newValue: l, oldValue: u }), l;
      };
    }
  ), Object.setPrototypeOf(t, o), t.forEach((a, c) => {
    J(a) && (t[c] = e(a, { deep: !0, path: r, callback: s }));
  });
}
function We(t, e) {
  const n = typeof e?.deep == "boolean" ? e?.deep : !0, r = e?.path || "", s = e?.callback;
  return Object.keys(t).forEach((i) => {
    const o = Ie(t, i);
    let a = t[i];
    const c = r ? `${r}.${String(i)}` : String(i);
    Object.defineProperty(t, i, {
      configurable: !0,
      // 是否可删除、可配置
      enumerable: !0,
      // 是否可枚举
      // 数据描述符
      // value : 默认为 undefined
      // writable : 是否可读写
      // 存取描述符
      get() {
        return n && J(a) && (Array.isArray(a) ? Yi(a, We, {
          callback: (u) => {
            o.notify(u), s && s(u);
          },
          path: c
        }) : We(a, { deep: !0, path: c })), o.add(), a;
      },
      set(u) {
        if (a !== u) {
          const l = a;
          a = u;
          const h = { path: c, newValue: u, oldValue: l };
          o.notify(h), s && s(h);
        }
      }
    });
  }), t;
}
function Fu(t) {
  return t.value ? t.value : typeof t == "function" ? t() : t;
}
function Nu(t, e) {
  return We({ value: t }, e);
}
const Zi = ar;
function ar(t, e) {
  if (!J(t))
    return t;
  const n = typeof e?.deep == "boolean" ? e?.deep : !0, r = e?.path || "", s = e?.callback, i = {
    // 拦截对象属性的读取
    // target 目标对象、key 键值、receiver 当前proxy实例
    get(a, c, u) {
      const l = r ? `${r}.${String(c)}` : String(c);
      let h = Reflect.get(a, c, u);
      const m = Ie(a, c);
      if (n && J(h) && !("isYZProxy" in h)) {
        const d = ar(h, {
          deep: !0,
          path: l,
          callback: s
        });
        Array.isArray(h) && (d.YZProxyArrayDep = m), h = d;
      }
      return m.add(), h;
    },
    // 拦截对象属性的设置
    // target 目标对象、key 键值、value 值、receiver 当前proxy实例
    set(a, c, u, l) {
      const h = Reflect.get(a, c, l), m = Reflect.set(a, c, u, l);
      if (c == "YZProxyArrayDep")
        return m;
      if (h !== u) {
        let d;
        Array.isArray(a) ? d = a.YZProxyArrayDep : d = Ie(a, c);
        const g = { path: r ? `${r}.${String(c)}` : String(c), newValue: u, oldValue: h };
        d.notify(g), s && s(g);
      }
      return m;
    },
    // 拦截 `delete proxy[key]` 的操作，返回一个布尔值
    deleteProperty(a, c) {
      if (!(c in a))
        return !1;
      let l = typeof c == "symbol" ? void 0 : a[c];
      J(l) && (l = Array.isArray(l) ? [...l] : { ...l });
      const h = Reflect.deleteProperty(a, c);
      if (h) {
        let m;
        Array.isArray(a) ? m = a.YZProxyArrayDep : m = Ie(a, c);
        const p = { path: r ? `${r}.${String(c)}` : String(c), newValue: void 0, oldValue: l };
        m.notify(p), s && s(p);
      }
      return h;
    },
    // 拦截 `key in proxy` 的操作，返回一个布尔值
    has(a, c) {
      return c === "isYZProxy" || c in a;
    }
    // 拦截 `Object.keys(proxy)`、`for...in` 等循环，返回一个数组
    // ownKeys(target) {
    //   return [];
    // },
    // 拦截 `Object.getOwnPropertyDescriptor(proxy, key)`，返回属性的描述对象
    // getOwnPropertyDescriptor(target, key) {
    //   return {};
    // },
    // 拦截 `Object.defineProperty(proxy, key, desc`，返回一个布尔值
    // defineProperty(target, key, desc) {
    //   return true;
    // },
    // 拦截 `Object.preventExtensions(proxy)`，返回一个布尔值
    // preventExtensions(target) {
    //   return true;
    // },
    // 拦截 `Object.getPrototypeOf(proxy)`，返回一个对象
    // getPrototypeOf(target) {
    //   return {};
    // },
    // 拦截 `Object.isExtensible(proxy)`，返回一个布尔值
    // isExtensible(target) {
    //   return true;
    // },
    // 拦截 `Object.setPrototypeOf(proxy, proto)`，返回一个布尔值
    // setPrototypeOf(target, proto) {
    //   return true;
    // },
    // 拦截 Proxy 实例作为函数调用的操作
    // apply(target, thisArg, args) {
    //   return target.apply(thisArg, args);
    // },
    // 拦截 Proxy 实例作为构造函数调用的操作
    // construct(target, args) {
    //   return {};
    // }
  };
  return new Proxy(t, i);
}
class Uu {
  events;
  constructor() {
    this.events = {};
  }
  isEmpty(e) {
    return this.events[e] == null || this.events[e].length == 0;
  }
  has(e, n) {
    return this.events[e] !== void 0 && this.events[e].indexOf(n) !== -1;
  }
  prependListener(e, n, r) {
    return this.events[e] || (this.events[e] = []), this.events[e].unshift(
      r ? n.bind(r) : n
    ), this;
  }
  addListener(e, n, r) {
    return this.events[e] || (this.events[e] = []), this.events[e].push(
      r ? n.bind(r) : n
    ), this;
  }
  on(e, n, r) {
    return this.addListener(e, n, r), this;
  }
  removeListener(e, n) {
    return this.events[e] && (this.events[e] = this.events[e].filter((r) => r !== n)), this;
  }
  off(e, n) {
    return this.removeListener(e, n), this;
  }
  removeAllListeners(e) {
    return e ? this.events[e] = [] : this.events = {}, this;
  }
  // 注意：handler 自己绑定 this
  emit(e, ...n) {
    return this.events[e] && this.events[e].slice(0).forEach((s) => {
      s(...n);
    }), this;
  }
  once(e, n, r) {
    const s = (...i) => {
      r ? n.apply(r, i) : n(...i), this.off(e, s);
    };
    return this.on(e, s), this;
  }
}
const Ge = 3.141592653589793 * 3e3 / 180, _ = 3.141592653589793, Xe = 6378245, Je = 0.006693421622965943;
function cr(t, e) {
  return t < 72.004 || t > 137.8347 || e < 0.8293 || e > 55.8271 || !1;
}
function ur(t, e) {
  let n = -100 + 2 * t + 3 * e + 0.2 * e * e + 0.1 * t * e + 0.2 * Math.sqrt(Math.abs(t));
  return n += (20 * Math.sin(6 * t * _) + 20 * Math.sin(2 * t * _)) * 2 / 3, n += (20 * Math.sin(e * _) + 40 * Math.sin(e / 3 * _)) * 2 / 3, n += (160 * Math.sin(e / 12 * _) + 320 * Math.sin(e * _ / 30)) * 2 / 3, n;
}
function lr(t, e) {
  let n = 300 + t + 2 * e + 0.1 * t * t + 0.1 * t * e + 0.1 * Math.sqrt(Math.abs(t));
  return n += (20 * Math.sin(6 * t * _) + 20 * Math.sin(2 * t * _)) * 2 / 3, n += (20 * Math.sin(t * _) + 40 * Math.sin(t / 3 * _)) * 2 / 3, n += (150 * Math.sin(t / 12 * _) + 300 * Math.sin(t / 30 * _)) * 2 / 3, n;
}
function Ki(t, e) {
  if (cr(t, e))
    return [t, e];
  {
    let n = lr(t - 105, e - 35), r = ur(t - 105, e - 35);
    const s = e / 180 * _;
    let i = Math.sin(s);
    i = 1 - Je * i * i;
    const o = Math.sqrt(i);
    n = n * 180 / (Xe / o * Math.cos(s) * _), r = r * 180 / (Xe * (1 - Je) / (i * o) * _);
    const a = e + r;
    return [t + n, a];
  }
}
function Qi(t, e) {
  if (cr(t, e))
    return [t, e];
  {
    let n = ur(t - 105, e - 35), r = lr(t - 105, e - 35);
    const s = e / 180 * _;
    let i = Math.sin(s);
    i = 1 - Je * i * i;
    const o = Math.sqrt(i);
    n = n * 180 / (Xe * (1 - Je) / (i * o) * _), r = r * 180 / (Xe / o * Math.cos(s) * _);
    const a = e + n, c = t + r;
    return [t * 2 - c, e * 2 - a];
  }
}
function eo(t, e) {
  const n = Math.sqrt(t * t + e * e) + 2e-5 * Math.sin(e * Ge), r = Math.atan2(e, t) + 3e-7 * Math.cos(t * Ge), s = n * Math.cos(r) + 65e-4, i = n * Math.sin(r) + 6e-3;
  return [s, i];
}
function to(t, e) {
  const n = t - 65e-4, r = e - 6e-3, s = Math.sqrt(n * n + r * r) - 2e-5 * Math.sin(r * Ge), i = Math.atan2(r, n) - 3e-6 * Math.cos(r * Ge), o = s * Math.cos(i), a = s * Math.sin(i);
  return [o, a];
}
function Bu(t, e) {
  const n = Ki(t, e);
  return eo(n[0], n[1]);
}
function ju(t, e) {
  const n = to(t, e);
  return Qi(n[0], n[1]);
}
function qu(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return new Proxy(t, {
    construct(n, r) {
      return e.has(n) || e.set(n, new n(...r)), e.get(n);
    }
  });
}
function zu(t) {
  return class extends t {
    constructor(...e) {
      super(...e), this.currentUser = null;
    }
    login(e) {
      R(`User ${e.name} logged in with role ${e.role}`), this.currentUser = e;
    }
    logout() {
      R(`User ${this.currentUser.name} logged out`), this.currentUser = null;
    }
  };
}
function Hu(t) {
  return function(e, n, r) {
    const s = r.value;
    return r.value = function(...i) {
      if (!this.currentUser)
        throw new Error("Authentication required");
      if (this.currentUser.role !== t)
        throw new Error(`Requires ${t} role`);
      return s.apply(this, i);
    }, r;
  };
}
function Vu(t) {
  return function(e, n) {
    let r;
    Object.defineProperty(e, n, {
      get() {
        return r;
      },
      set(s) {
        if (s.length < t)
          throw new Error(`${String(n)} must be at least ${t} long`);
        r = s;
      }
    });
  };
}
function Wu(t) {
  return function(e, n) {
    let r;
    Object.defineProperty(e, n, {
      get() {
        return r;
      },
      set(s) {
        if (s.length < t)
          throw new Error(`${String(n)} must be at most ${t} long`);
        r = s;
      }
    });
  };
}
function Gu(t) {
  return function(e, n, r) {
    const s = t || `${e.constructor.name}.${String(n)}`, i = r.value;
    if (typeof i != "function")
      throw new SyntaxError(
        `@LogExecuteResultDecorator() can only be used on functions, not: ${s}`
      );
    return {
      ...r,
      value(...o) {
        const a = i.apply(this, o);
        return R(`${s} ( ${o} ) = ${a}`), a;
      }
    };
  };
}
function Xu(t, e, n) {
  const r = `${t.constructor.name}.${String(e)}`, s = n.value;
  if (typeof s != "function")
    throw new SyntaxError(
      `@LogExecuteTimeDecorator can only be used on functions, not: ${r}`
    );
  let i = 0;
  return {
    ...n,
    value(...o) {
      const a = `${r}-${i++}`;
      qe.start(a);
      try {
        return s.apply(this, o);
      } finally {
        qe.end(a);
      }
    }
  };
}
function Ju(t, e, n) {
  const r = `${t.constructor.name}.${String(e)}`, s = n.value;
  if (typeof s != "function")
    throw new SyntaxError(
      `@ProfileDecorator can only be used on functions, not: ${r}`
    );
  return {
    ...n,
    value(...i) {
      fn.start(r);
      try {
        return s.apply(this, i);
      } finally {
        fn.end(r);
      }
    }
  };
}
function Yu(t = 300, e) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@ThrottleDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...s,
      value(...a) {
        Qe(this).get(`__@ThrottleDecorator_${i}__`, ci(o, t, e)).apply(this, a);
      }
    };
  };
}
function Zu(t = 300, e = !1) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@DebounceDecorator() can only be used on functions, not: ${i}`
      );
    return {
      ...s,
      value(...a) {
        Qe(this).get(
          `__@DebounceDecorator_${i}__`,
          ui(o, t, { immediate: e })
        ).apply(this, a);
      }
    };
  };
}
function Ku(t = 3, e) {
  return function(n, r, s) {
    const i = `${n.constructor.name}.${String(r)}`, o = s.value;
    if (typeof o != "function")
      throw new SyntaxError(
        `@RetryDecoratorDecorator() can only be used on functions, not: ${i}`
      );
    const a = Kn(o, t, e);
    return {
      ...s,
      async value(...c) {
        return await a.apply(this, c);
      }
    };
  };
}
function Qu(t = 60) {
  return function(e, n, r) {
    const s = `${e.constructor.name}.${String(n)}`, i = r.value;
    if (typeof i != "function")
      throw new SyntaxError(
        `@CacheDecorator() can only be used on functions, not: ${s}`
      );
    return {
      ...r,
      async value(...o) {
        return await Qe(this).get(
          `__@CacheDecorator_${s}__`,
          Qn(i, t)
        ).apply(this, o);
      }
    };
  };
}
function el() {
  return function(t, e, n) {
    const r = `${t.constructor.name}.${String(e)}`, s = n.value;
    if (typeof s != "function")
      throw new SyntaxError(
        `@MemorizeDecorator() can only be used on functions, not: ${r}`
      );
    return {
      ...n,
      async value(...i) {
        return await Qe(this).get(
          `__@MemorizeDecorator_${r}__`,
          di(s)
        ).apply(this, i);
      }
    };
  };
}
function tl(t, e, n) {
  if (n)
    return n.writable = !1, n;
  let r;
  Object.defineProperty(t, e, {
    get() {
      return r;
    },
    set(s) {
      if (r === void 0)
        r = s;
      else
        throw new Error(`${t}.${String(e)} is Readonly!`);
    }
  });
}
function nl(t = !0) {
  return (e, n, r) => {
    if (r)
      return r.configurable = t, r;
    Object.defineProperty(e, n, {
      configurable: t
    });
  };
}
function rl(t = !0) {
  return (e, n, r) => {
    if (r)
      return r.enumerable = t, r;
    Object.defineProperty(e, n, {
      enumerable: t
    });
  };
}
function sl(t, e = (n, r) => n <= r) {
  for (let n = 1, r = t.length; n < r; n++) {
    let s = !1;
    for (let i = 0; i < r - n; i++)
      e(t[i], t[i + 1]) || ([t[i], t[i + 1]] = [t[i + 1], t[i]], s = !0);
    if (!s)
      return;
  }
}
function il(t, e = (n, r) => n <= r) {
  let n;
  for (let r = 0, s = t.length; r < s - 1; r++) {
    n = r;
    for (let i = r + 1; i < s; i++)
      e(t[n], t[i]) || (n = i);
    n != r && ([t[n], t[r]] = [t[r], t[n]]);
  }
}
function ol(t, e = (n, r) => n <= r) {
  for (let n = 1, r = t.length; n < r; n++) {
    const s = t[n];
    let i = n - 1;
    for (; i >= 0 && !e(t[i], s); )
      t[i + 1] = t[i], i--;
    t[i + 1] = s;
  }
}
function gn(t, e = (n, r) => n <= r) {
  const n = t.length;
  if (n < 2)
    return t;
  const r = Math.floor(n / 2), s = gn(t.slice(0, r), e), i = gn(t.slice(r), e), o = [];
  for (; s.length && i.length; )
    e(s[0], i[0]) ? o.push(s.shift()) : o.push(i.shift());
  for (; s.length; )
    o.push(s.shift());
  for (; i.length; )
    o.push(i.shift());
  return o;
}
function yn(t, e = 0, n = t.length - 1, r = (s, i) => s <= i) {
  if (e >= n)
    return;
  const s = e + n >> 1;
  yn(t, e, s, r), yn(t, s + 1, n, r);
  let i = e, o = s + 1;
  const a = [];
  for (; i <= s && o <= n; )
    r(t[i], t[o]) ? a.push(t[i++]) : a.push(t[o++]);
  for (; i <= s; )
    a.push(t[i++]);
  for (; o <= n; )
    a.push(t[o++]);
  for (i = e, o = 0; i <= n; ++i, ++o)
    t[i] = a[o];
}
function no(t, e = 0, n = t.length - 1, r = (s, i) => s <= i) {
  if (e >= n)
    return e;
  const s = n, i = t[s];
  let o = e;
  for (let a = e; a <= n; a++)
    a != s && r(t[a], i) && ([t[o], t[a]] = [t[a], t[o]], o++);
  return [t[o], t[s]] = [
    t[s],
    t[o]
  ], o;
}
function wn(t, e = 0, n = t.length - 1, r = (s, i) => s <= i) {
  if (e >= n)
    return;
  const s = no(t, e, n, r);
  wn(t, e, s - 1, r), wn(t, s + 1, n, r);
}
function bn(t, e = 0, n = t.length - 1, r = (s, i) => s <= i) {
  if (e >= n)
    return;
  const s = e, i = t[s];
  let o = e, a = n;
  for (; o < a; ) {
    for (; o < n && r(t[o], i); )
      o++;
    for (; a > e && r(i, t[a]); )
      a--;
    o < a && ([t[o], t[a]] = [t[a], t[o]]);
  }
  [t[s], t[a]] = [t[a], t[s]], bn(t, e, a - 1, r), bn(t, a + 1, n, r);
}
function Sn(t, e = 0, n = t.length - 1, r = (s, i) => s <= i) {
  if (e >= n)
    return;
  const s = e, i = t[s];
  let o = e, a = n, c = e;
  for (; c <= a; )
    r(t[c], i) ? ([t[o], t[c]] = [t[c], t[o]], o++, c++) : r(i, t[c]) ? ([t[c], t[a]] = [t[a], t[c]], a--) : c++;
  [t[s], t[a]] = [t[a], t[s]], Sn(t, e, a - 1, r), Sn(t, a + 1, n, r);
}
function al(t, e = (n, r) => n <= r) {
  const n = t.length;
  let r = Math.floor(n / 2);
  for (; r > 0; ) {
    for (let s = r; s < n; s++) {
      const i = t[s];
      let o = s;
      for (; o >= r && !e(t[o - r], i); )
        t[o] = t[o - r], o -= r;
      t[o] = i;
    }
    r = Math.floor(r / 2);
  }
}
function cl(t, e = (n, r) => n <= r) {
  const n = new nt(e, t), r = [];
  let s;
  for (; (s = n.pop()) !== null; )
    r.push(s);
  return r;
}
function ul(t, e) {
  let n = 0, r = t.length - 1;
  for (; n < r; ) {
    const s = Math.floor((n + r) / 2), i = t[s];
    if (i === e)
      return s;
    i < e ? n = s + 1 : r = s - 1;
  }
  return -1;
}
function ll(t, e) {
  function n(s, i, o) {
    const a = s[o];
    let c = i - 1;
    for (let u = i; u < o; u++)
      s[u] >= a && (c++, [s[c], s[u]] = [s[u], s[c]]);
    return [s[c + 1], s[o]] = [s[o], s[c + 1]], c + 1;
  }
  function r(s, i, o) {
    if (s === i)
      return t[s];
    const a = n(t, s, i);
    return a === o ? t[a] : a < o ? r(a + 1, i, o) : r(s, a - 1, o);
  }
  return r(0, t.length - 1, e - 1);
}
class fl {
  max;
  cache = /* @__PURE__ */ new Map();
  constructor(e) {
    this.max = e;
  }
  add(e, n) {
    const { cache: r } = this;
    if (r.size >= this.max) {
      const s = r.keys().next();
      s.value && r.delete(s.value);
    }
    r.set(e, n);
  }
  get(e) {
    const { cache: n } = this, r = n.get(e);
    if (r)
      return n.delete(e), n.set(e, r), r;
  }
}
class hl {
  max;
  cache = new si();
  constructor(e) {
    this.max = e;
  }
  add(e) {
    const { cache: n } = this;
    n.size() >= this.max && n.pop(), n.unshift(e);
  }
  get(e) {
    const { cache: n } = this, r = n.getIndex(e);
    return r == -1 ? this.add(e) : (n.delete(r), n.unshift(e)), e;
  }
}
class dl {
  prefixSumArray;
  constructor(e) {
    const n = e.length + 1;
    this.prefixSumArray = Array.from({ length: n }).fill(0);
    for (let r = 1; r < n; r++)
      this.prefixSumArray[r] = this.prefixSumArray[r - 1] + e[r - 1];
  }
  // 查询闭区间 [i, j] 的累加和
  sum(e, n) {
    return this.prefixSumArray[n + 1] - this.prefixSumArray[e];
  }
}
class pl {
  diffArray;
  constructor(e) {
    const n = e.length;
    this.diffArray = Array.from({ length: n }).fill(0), this.diffArray[0] = e[0];
    for (let r = 1; r < n; r++)
      this.diffArray[r] = e[r] - e[r - 1];
  }
  // 根据差分数组构造结果数组
  result() {
    const e = this.diffArray.length, n = Array.from({ length: e }).fill(0);
    n[0] = this.diffArray[0];
    for (let r = 1; r < e; r++)
      n[r] = n[r - 1] + this.diffArray[r];
    return n;
  }
  // 对闭区间 [i, j]进行增减的操作 ，num 可以为负数
  // 原理很简单，根据 diffArray 数组反推 nums 数组的过程，diff[i] += 3 意味着给 nums[i..] 所有的元素都加了 3，然后 diffArray[j+1] -= 3 又意味着对于 nums[j+1..] 所有元素再减 3，那综合起来，是不是就是对 nums[i..j] 中的所有元素都加 3 了
  // 只要花费 O(1) 的时间修改 diffArray 数组，就相当于给 原数组 的整个区间做了修改
  operate(e, n, r) {
    e >= 0 && e < this.diffArray.length && (this.diffArray[e] += r), n + 1 >= 0 && n + 1 < this.diffArray.length && (this.diffArray[n + 1] -= r);
  }
}
class ro {
  commands = [];
  pushCommand(e) {
    this.commands.push(e);
  }
  popCommand() {
    this.commands.pop();
  }
  executeCommands(...e) {
    this.commands.forEach((n) => this.executeCommand(n, ...e)), this.commands = [];
  }
  // 子类只需修改此方法
  executeCommand(e, ...n) {
    e.execute(...n);
  }
}
class so {
  data;
  constructor(e) {
    this.data = e;
  }
  get() {
    return this.data;
  }
}
class ml {
  state;
  saveState() {
    if (this.state)
      return new so(this.state);
  }
  restoreState(e) {
    this.state = e.get();
  }
}
class gl extends ro {
  originator;
  mementos = [];
  constructor(e) {
    super(), this.originator = e;
  }
  pushMemento(e) {
    this.mementos.push(e);
  }
  popMemento() {
    return this.mementos.pop();
  }
  executeCommand(e) {
    e.execute(this);
  }
}
class yl {
  execute(e) {
    const n = e.originator.saveState();
    n && e.pushMemento(n);
  }
}
class wl {
  execute(e) {
    const n = e.popMemento();
    n && e.originator.restoreState(n);
  }
}
const io = {
  11e4: "北京市",
  110100: "市辖区",
  110101: "东城区",
  110102: "西城区",
  110105: "朝阳区",
  110106: "丰台区",
  110107: "石景山区",
  110108: "海淀区",
  110109: "门头沟区",
  110111: "房山区",
  110112: "通州区",
  110113: "顺义区",
  110114: "昌平区",
  110115: "大兴区",
  110116: "怀柔区",
  110117: "平谷区",
  110118: "密云区",
  110119: "延庆区",
  12e4: "天津市",
  120100: "市辖区",
  120101: "和平区",
  120102: "河东区",
  120103: "河西区",
  120104: "南开区",
  120105: "河北区",
  120106: "红桥区",
  120110: "东丽区",
  120111: "西青区",
  120112: "津南区",
  120113: "北辰区",
  120114: "武清区",
  120115: "宝坻区",
  120116: "滨海新区",
  120117: "宁河区",
  120118: "静海区",
  120119: "蓟州区",
  13e4: "河北省",
  130100: "石家庄市",
  130101: "市辖区",
  130102: "长安区",
  130104: "桥西区",
  130105: "新华区",
  130107: "井陉矿区",
  130108: "裕华区",
  130109: "藁城区",
  130110: "鹿泉区",
  130111: "栾城区",
  130121: "井陉县",
  130123: "正定县",
  130125: "行唐县",
  130126: "灵寿县",
  130127: "高邑县",
  130128: "深泽县",
  130129: "赞皇县",
  130130: "无极县",
  130131: "平山县",
  130132: "元氏县",
  130133: "赵县",
  130183: "晋州市",
  130184: "新乐市",
  130200: "唐山市",
  130201: "市辖区",
  130202: "路南区",
  130203: "路北区",
  130204: "古冶区",
  130205: "开平区",
  130207: "丰南区",
  130208: "丰润区",
  130209: "曹妃甸区",
  130223: "滦县",
  130224: "滦南县",
  130225: "乐亭县",
  130227: "迁西县",
  130229: "玉田县",
  130281: "遵化市",
  130283: "迁安市",
  130300: "秦皇岛市",
  130301: "市辖区",
  130302: "海港区",
  130303: "山海关区",
  130304: "北戴河区",
  130306: "抚宁区",
  130321: "青龙满族自治县",
  130322: "昌黎县",
  130324: "卢龙县",
  130400: "邯郸市",
  130401: "市辖区",
  130402: "邯山区",
  130403: "丛台区",
  130404: "复兴区",
  130406: "峰峰矿区",
  130421: "邯郸县",
  130423: "临漳县",
  130424: "成安县",
  130425: "大名县",
  130426: "涉县",
  130427: "磁县",
  130428: "肥乡县",
  130429: "永年县",
  130430: "邱县",
  130431: "鸡泽县",
  130432: "广平县",
  130433: "馆陶县",
  130434: "魏县",
  130435: "曲周县",
  130481: "武安市",
  130500: "邢台市",
  130501: "市辖区",
  130502: "桥东区",
  130503: "桥西区",
  130521: "邢台县",
  130522: "临城县",
  130523: "内丘县",
  130524: "柏乡县",
  130525: "隆尧县",
  130526: "任县",
  130527: "南和县",
  130528: "宁晋县",
  130529: "巨鹿县",
  130530: "新河县",
  130531: "广宗县",
  130532: "平乡县",
  130533: "威县",
  130534: "清河县",
  130535: "临西县",
  130581: "南宫市",
  130582: "沙河市",
  130600: "保定市",
  130601: "市辖区",
  130602: "竞秀区",
  130606: "莲池区",
  130607: "满城区",
  130608: "清苑区",
  130609: "徐水区",
  130623: "涞水县",
  130624: "阜平县",
  130626: "定兴县",
  130627: "唐县",
  130628: "高阳县",
  130629: "容城县",
  130630: "涞源县",
  130631: "望都县",
  130632: "安新县",
  130633: "易县",
  130634: "曲阳县",
  130635: "蠡县",
  130636: "顺平县",
  130637: "博野县",
  130638: "雄县",
  130681: "涿州市",
  130683: "安国市",
  130684: "高碑店市",
  130700: "张家口市",
  130701: "市辖区",
  130702: "桥东区",
  130703: "桥西区",
  130705: "宣化区",
  130706: "下花园区",
  130708: "万全区",
  130709: "崇礼区",
  130722: "张北县",
  130723: "康保县",
  130724: "沽源县",
  130725: "尚义县",
  130726: "蔚县",
  130727: "阳原县",
  130728: "怀安县",
  130730: "怀来县",
  130731: "涿鹿县",
  130732: "赤城县",
  130800: "承德市",
  130801: "市辖区",
  130802: "双桥区",
  130803: "双滦区",
  130804: "鹰手营子矿区",
  130821: "承德县",
  130822: "兴隆县",
  130823: "平泉县",
  130824: "滦平县",
  130825: "隆化县",
  130826: "丰宁满族自治县",
  130827: "宽城满族自治县",
  130828: "围场满族蒙古族自治县",
  130900: "沧州市",
  130901: "市辖区",
  130902: "新华区",
  130903: "运河区",
  130921: "沧县",
  130922: "青县",
  130923: "东光县",
  130924: "海兴县",
  130925: "盐山县",
  130926: "肃宁县",
  130927: "南皮县",
  130928: "吴桥县",
  130929: "献县",
  130930: "孟村回族自治县",
  130981: "泊头市",
  130982: "任丘市",
  130983: "黄骅市",
  130984: "河间市",
  131e3: "廊坊市",
  131001: "市辖区",
  131002: "安次区",
  131003: "广阳区",
  131022: "固安县",
  131023: "永清县",
  131024: "香河县",
  131025: "大城县",
  131026: "文安县",
  131028: "大厂回族自治县",
  131081: "霸州市",
  131082: "三河市",
  131100: "衡水市",
  131101: "市辖区",
  131102: "桃城区",
  131103: "冀州区",
  131121: "枣强县",
  131122: "武邑县",
  131123: "武强县",
  131124: "饶阳县",
  131125: "安平县",
  131126: "故城县",
  131127: "景县",
  131128: "阜城县",
  131182: "深州市",
  139e3: "省直辖县级行政区划",
  139001: "定州市",
  139002: "辛集市",
  14e4: "山西省",
  140100: "太原市",
  140101: "市辖区",
  140105: "小店区",
  140106: "迎泽区",
  140107: "杏花岭区",
  140108: "尖草坪区",
  140109: "万柏林区",
  140110: "晋源区",
  140121: "清徐县",
  140122: "阳曲县",
  140123: "娄烦县",
  140181: "古交市",
  140200: "大同市",
  140201: "市辖区",
  140202: "城区",
  140203: "矿区",
  140211: "南郊区",
  140212: "新荣区",
  140221: "阳高县",
  140222: "天镇县",
  140223: "广灵县",
  140224: "灵丘县",
  140225: "浑源县",
  140226: "左云县",
  140227: "大同县",
  140300: "阳泉市",
  140301: "市辖区",
  140302: "城区",
  140303: "矿区",
  140311: "郊区",
  140321: "平定县",
  140322: "盂县",
  140400: "长治市",
  140401: "市辖区",
  140402: "城区",
  140411: "郊区",
  140421: "长治县",
  140423: "襄垣县",
  140424: "屯留县",
  140425: "平顺县",
  140426: "黎城县",
  140427: "壶关县",
  140428: "长子县",
  140429: "武乡县",
  140430: "沁县",
  140431: "沁源县",
  140481: "潞城市",
  140500: "晋城市",
  140501: "市辖区",
  140502: "城区",
  140521: "沁水县",
  140522: "阳城县",
  140524: "陵川县",
  140525: "泽州县",
  140581: "高平市",
  140600: "朔州市",
  140601: "市辖区",
  140602: "朔城区",
  140603: "平鲁区",
  140621: "山阴县",
  140622: "应县",
  140623: "右玉县",
  140624: "怀仁县",
  140700: "晋中市",
  140701: "市辖区",
  140702: "榆次区",
  140721: "榆社县",
  140722: "左权县",
  140723: "和顺县",
  140724: "昔阳县",
  140725: "寿阳县",
  140726: "太谷县",
  140727: "祁县",
  140728: "平遥县",
  140729: "灵石县",
  140781: "介休市",
  140800: "运城市",
  140801: "市辖区",
  140802: "盐湖区",
  140821: "临猗县",
  140822: "万荣县",
  140823: "闻喜县",
  140824: "稷山县",
  140825: "新绛县",
  140826: "绛县",
  140827: "垣曲县",
  140828: "夏县",
  140829: "平陆县",
  140830: "芮城县",
  140881: "永济市",
  140882: "河津市",
  140900: "忻州市",
  140901: "市辖区",
  140902: "忻府区",
  140921: "定襄县",
  140922: "五台县",
  140923: "代县",
  140924: "繁峙县",
  140925: "宁武县",
  140926: "静乐县",
  140927: "神池县",
  140928: "五寨县",
  140929: "岢岚县",
  140930: "河曲县",
  140931: "保德县",
  140932: "偏关县",
  140981: "原平市",
  141e3: "临汾市",
  141001: "市辖区",
  141002: "尧都区",
  141021: "曲沃县",
  141022: "翼城县",
  141023: "襄汾县",
  141024: "洪洞县",
  141025: "古县",
  141026: "安泽县",
  141027: "浮山县",
  141028: "吉县",
  141029: "乡宁县",
  141030: "大宁县",
  141031: "隰县",
  141032: "永和县",
  141033: "蒲县",
  141034: "汾西县",
  141081: "侯马市",
  141082: "霍州市",
  141100: "吕梁市",
  141101: "市辖区",
  141102: "离石区",
  141121: "文水县",
  141122: "交城县",
  141123: "兴县",
  141124: "临县",
  141125: "柳林县",
  141126: "石楼县",
  141127: "岚县",
  141128: "方山县",
  141129: "中阳县",
  141130: "交口县",
  141181: "孝义市",
  141182: "汾阳市",
  15e4: "内蒙古自治区",
  150100: "呼和浩特市",
  150101: "市辖区",
  150102: "新城区",
  150103: "回民区",
  150104: "玉泉区",
  150105: "赛罕区",
  150121: "土默特左旗",
  150122: "托克托县",
  150123: "和林格尔县",
  150124: "清水河县",
  150125: "武川县",
  150200: "包头市",
  150201: "市辖区",
  150202: "东河区",
  150203: "昆都仑区",
  150204: "青山区",
  150205: "石拐区",
  150206: "白云鄂博矿区",
  150207: "九原区",
  150221: "土默特右旗",
  150222: "固阳县",
  150223: "达尔罕茂明安联合旗",
  150300: "乌海市",
  150301: "市辖区",
  150302: "海勃湾区",
  150303: "海南区",
  150304: "乌达区",
  150400: "赤峰市",
  150401: "市辖区",
  150402: "红山区",
  150403: "元宝山区",
  150404: "松山区",
  150421: "阿鲁科尔沁旗",
  150422: "巴林左旗",
  150423: "巴林右旗",
  150424: "林西县",
  150425: "克什克腾旗",
  150426: "翁牛特旗",
  150428: "喀喇沁旗",
  150429: "宁城县",
  150430: "敖汉旗",
  150500: "通辽市",
  150501: "市辖区",
  150502: "科尔沁区",
  150521: "科尔沁左翼中旗",
  150522: "科尔沁左翼后旗",
  150523: "开鲁县",
  150524: "库伦旗",
  150525: "奈曼旗",
  150526: "扎鲁特旗",
  150581: "霍林郭勒市",
  150600: "鄂尔多斯市",
  150601: "市辖区",
  150602: "东胜区",
  150603: "康巴什区",
  150621: "达拉特旗",
  150622: "准格尔旗",
  150623: "鄂托克前旗",
  150624: "鄂托克旗",
  150625: "杭锦旗",
  150626: "乌审旗",
  150627: "伊金霍洛旗",
  150700: "呼伦贝尔市",
  150701: "市辖区",
  150702: "海拉尔区",
  150703: "扎赉诺尔区",
  150721: "阿荣旗",
  150722: "莫力达瓦达斡尔族自治旗",
  150723: "鄂伦春自治旗",
  150724: "鄂温克族自治旗",
  150725: "陈巴尔虎旗",
  150726: "新巴尔虎左旗",
  150727: "新巴尔虎右旗",
  150781: "满洲里市",
  150782: "牙克石市",
  150783: "扎兰屯市",
  150784: "额尔古纳市",
  150785: "根河市",
  150800: "巴彦淖尔市",
  150801: "市辖区",
  150802: "临河区",
  150821: "五原县",
  150822: "磴口县",
  150823: "乌拉特前旗",
  150824: "乌拉特中旗",
  150825: "乌拉特后旗",
  150826: "杭锦后旗",
  150900: "乌兰察布市",
  150901: "市辖区",
  150902: "集宁区",
  150921: "卓资县",
  150922: "化德县",
  150923: "商都县",
  150924: "兴和县",
  150925: "凉城县",
  150926: "察哈尔右翼前旗",
  150927: "察哈尔右翼中旗",
  150928: "察哈尔右翼后旗",
  150929: "四子王旗",
  150981: "丰镇市",
  152200: "兴安盟",
  152201: "乌兰浩特市",
  152202: "阿尔山市",
  152221: "科尔沁右翼前旗",
  152222: "科尔沁右翼中旗",
  152223: "扎赉特旗",
  152224: "突泉县",
  152500: "锡林郭勒盟",
  152501: "二连浩特市",
  152502: "锡林浩特市",
  152522: "阿巴嘎旗",
  152523: "苏尼特左旗",
  152524: "苏尼特右旗",
  152525: "东乌珠穆沁旗",
  152526: "西乌珠穆沁旗",
  152527: "太仆寺旗",
  152528: "镶黄旗",
  152529: "正镶白旗",
  152530: "正蓝旗",
  152531: "多伦县",
  152900: "阿拉善盟",
  152921: "阿拉善左旗",
  152922: "阿拉善右旗",
  152923: "额济纳旗",
  21e4: "辽宁省",
  210100: "沈阳市",
  210101: "市辖区",
  210102: "和平区",
  210103: "沈河区",
  210104: "大东区",
  210105: "皇姑区",
  210106: "铁西区",
  210111: "苏家屯区",
  210112: "浑南区",
  210113: "沈北新区",
  210114: "于洪区",
  210115: "辽中区",
  210123: "康平县",
  210124: "法库县",
  210181: "新民市",
  210200: "大连市",
  210201: "市辖区",
  210202: "中山区",
  210203: "西岗区",
  210204: "沙河口区",
  210211: "甘井子区",
  210212: "旅顺口区",
  210213: "金州区",
  210214: "普兰店区",
  210224: "长海县",
  210281: "瓦房店市",
  210283: "庄河市",
  210300: "鞍山市",
  210301: "市辖区",
  210302: "铁东区",
  210303: "铁西区",
  210304: "立山区",
  210311: "千山区",
  210321: "台安县",
  210323: "岫岩满族自治县",
  210381: "海城市",
  210400: "抚顺市",
  210401: "市辖区",
  210402: "新抚区",
  210403: "东洲区",
  210404: "望花区",
  210411: "顺城区",
  210421: "抚顺县",
  210422: "新宾满族自治县",
  210423: "清原满族自治县",
  210500: "本溪市",
  210501: "市辖区",
  210502: "平山区",
  210503: "溪湖区",
  210504: "明山区",
  210505: "南芬区",
  210521: "本溪满族自治县",
  210522: "桓仁满族自治县",
  210600: "丹东市",
  210601: "市辖区",
  210602: "元宝区",
  210603: "振兴区",
  210604: "振安区",
  210624: "宽甸满族自治县",
  210681: "东港市",
  210682: "凤城市",
  210700: "锦州市",
  210701: "市辖区",
  210702: "古塔区",
  210703: "凌河区",
  210711: "太和区",
  210726: "黑山县",
  210727: "义县",
  210781: "凌海市",
  210782: "北镇市",
  210800: "营口市",
  210801: "市辖区",
  210802: "站前区",
  210803: "西市区",
  210804: "鲅鱼圈区",
  210811: "老边区",
  210881: "盖州市",
  210882: "大石桥市",
  210900: "阜新市",
  210901: "市辖区",
  210902: "海州区",
  210903: "新邱区",
  210904: "太平区",
  210905: "清河门区",
  210911: "细河区",
  210921: "阜新蒙古族自治县",
  210922: "彰武县",
  211e3: "辽阳市",
  211001: "市辖区",
  211002: "白塔区",
  211003: "文圣区",
  211004: "宏伟区",
  211005: "弓长岭区",
  211011: "太子河区",
  211021: "辽阳县",
  211081: "灯塔市",
  211100: "盘锦市",
  211101: "市辖区",
  211102: "双台子区",
  211103: "兴隆台区",
  211104: "大洼区",
  211122: "盘山县",
  211200: "铁岭市",
  211201: "市辖区",
  211202: "银州区",
  211204: "清河区",
  211221: "铁岭县",
  211223: "西丰县",
  211224: "昌图县",
  211281: "调兵山市",
  211282: "开原市",
  211300: "朝阳市",
  211301: "市辖区",
  211302: "双塔区",
  211303: "龙城区",
  211321: "朝阳县",
  211322: "建平县",
  211324: "喀喇沁左翼蒙古族自治县",
  211381: "北票市",
  211382: "凌源市",
  211400: "葫芦岛市",
  211401: "市辖区",
  211402: "连山区",
  211403: "龙港区",
  211404: "南票区",
  211421: "绥中县",
  211422: "建昌县",
  211481: "兴城市",
  22e4: "吉林省",
  220100: "长春市",
  220101: "市辖区",
  220102: "南关区",
  220103: "宽城区",
  220104: "朝阳区",
  220105: "二道区",
  220106: "绿园区",
  220112: "双阳区",
  220113: "九台区",
  220122: "农安县",
  220182: "榆树市",
  220183: "德惠市",
  220200: "吉林市",
  220201: "市辖区",
  220202: "昌邑区",
  220203: "龙潭区",
  220204: "船营区",
  220211: "丰满区",
  220221: "永吉县",
  220281: "蛟河市",
  220282: "桦甸市",
  220283: "舒兰市",
  220284: "磐石市",
  220300: "四平市",
  220301: "市辖区",
  220302: "铁西区",
  220303: "铁东区",
  220322: "梨树县",
  220323: "伊通满族自治县",
  220381: "公主岭市",
  220382: "双辽市",
  220400: "辽源市",
  220401: "市辖区",
  220402: "龙山区",
  220403: "西安区",
  220421: "东丰县",
  220422: "东辽县",
  220500: "通化市",
  220501: "市辖区",
  220502: "东昌区",
  220503: "二道江区",
  220521: "通化县",
  220523: "辉南县",
  220524: "柳河县",
  220581: "梅河口市",
  220582: "集安市",
  220600: "白山市",
  220601: "市辖区",
  220602: "浑江区",
  220605: "江源区",
  220621: "抚松县",
  220622: "靖宇县",
  220623: "长白朝鲜族自治县",
  220681: "临江市",
  220700: "松原市",
  220701: "市辖区",
  220702: "宁江区",
  220721: "前郭尔罗斯蒙古族自治县",
  220722: "长岭县",
  220723: "乾安县",
  220781: "扶余市",
  220800: "白城市",
  220801: "市辖区",
  220802: "洮北区",
  220821: "镇赉县",
  220822: "通榆县",
  220881: "洮南市",
  220882: "大安市",
  222400: "延边朝鲜族自治州",
  222401: "延吉市",
  222402: "图们市",
  222403: "敦化市",
  222404: "珲春市",
  222405: "龙井市",
  222406: "和龙市",
  222424: "汪清县",
  222426: "安图县",
  23e4: "黑龙江省",
  230100: "哈尔滨市",
  230101: "市辖区",
  230102: "道里区",
  230103: "南岗区",
  230104: "道外区",
  230108: "平房区",
  230109: "松北区",
  230110: "香坊区",
  230111: "呼兰区",
  230112: "阿城区",
  230113: "双城区",
  230123: "依兰县",
  230124: "方正县",
  230125: "宾县",
  230126: "巴彦县",
  230127: "木兰县",
  230128: "通河县",
  230129: "延寿县",
  230183: "尚志市",
  230184: "五常市",
  230200: "齐齐哈尔市",
  230201: "市辖区",
  230202: "龙沙区",
  230203: "建华区",
  230204: "铁锋区",
  230205: "昂昂溪区",
  230206: "富拉尔基区",
  230207: "碾子山区",
  230208: "梅里斯达斡尔族区",
  230221: "龙江县",
  230223: "依安县",
  230224: "泰来县",
  230225: "甘南县",
  230227: "富裕县",
  230229: "克山县",
  230230: "克东县",
  230231: "拜泉县",
  230281: "讷河市",
  230300: "鸡西市",
  230301: "市辖区",
  230302: "鸡冠区",
  230303: "恒山区",
  230304: "滴道区",
  230305: "梨树区",
  230306: "城子河区",
  230307: "麻山区",
  230321: "鸡东县",
  230381: "虎林市",
  230382: "密山市",
  230400: "鹤岗市",
  230401: "市辖区",
  230402: "向阳区",
  230403: "工农区",
  230404: "南山区",
  230405: "兴安区",
  230406: "东山区",
  230407: "兴山区",
  230421: "萝北县",
  230422: "绥滨县",
  230500: "双鸭山市",
  230501: "市辖区",
  230502: "尖山区",
  230503: "岭东区",
  230505: "四方台区",
  230506: "宝山区",
  230521: "集贤县",
  230522: "友谊县",
  230523: "宝清县",
  230524: "饶河县",
  230600: "大庆市",
  230601: "市辖区",
  230602: "萨尔图区",
  230603: "龙凤区",
  230604: "让胡路区",
  230605: "红岗区",
  230606: "大同区",
  230621: "肇州县",
  230622: "肇源县",
  230623: "林甸县",
  230624: "杜尔伯特蒙古族自治县",
  230700: "伊春市",
  230701: "市辖区",
  230702: "伊春区",
  230703: "南岔区",
  230704: "友好区",
  230705: "西林区",
  230706: "翠峦区",
  230707: "新青区",
  230708: "美溪区",
  230709: "金山屯区",
  230710: "五营区",
  230711: "乌马河区",
  230712: "汤旺河区",
  230713: "带岭区",
  230714: "乌伊岭区",
  230715: "红星区",
  230716: "上甘岭区",
  230722: "嘉荫县",
  230781: "铁力市",
  230800: "佳木斯市",
  230801: "市辖区",
  230803: "向阳区",
  230804: "前进区",
  230805: "东风区",
  230811: "郊区",
  230822: "桦南县",
  230826: "桦川县",
  230828: "汤原县",
  230881: "同江市",
  230882: "富锦市",
  230883: "抚远市",
  230900: "七台河市",
  230901: "市辖区",
  230902: "新兴区",
  230903: "桃山区",
  230904: "茄子河区",
  230921: "勃利县",
  231e3: "牡丹江市",
  231001: "市辖区",
  231002: "东安区",
  231003: "阳明区",
  231004: "爱民区",
  231005: "西安区",
  231025: "林口县",
  231081: "绥芬河市",
  231083: "海林市",
  231084: "宁安市",
  231085: "穆棱市",
  231086: "东宁市",
  231100: "黑河市",
  231101: "市辖区",
  231102: "爱辉区",
  231121: "嫩江县",
  231123: "逊克县",
  231124: "孙吴县",
  231181: "北安市",
  231182: "五大连池市",
  231200: "绥化市",
  231201: "市辖区",
  231202: "北林区",
  231221: "望奎县",
  231222: "兰西县",
  231223: "青冈县",
  231224: "庆安县",
  231225: "明水县",
  231226: "绥棱县",
  231281: "安达市",
  231282: "肇东市",
  231283: "海伦市",
  232700: "大兴安岭地区",
  232721: "呼玛县",
  232722: "塔河县",
  232723: "漠河县",
  31e4: "上海市",
  310100: "市辖区",
  310101: "黄浦区",
  310104: "徐汇区",
  310105: "长宁区",
  310106: "静安区",
  310107: "普陀区",
  310109: "虹口区",
  310110: "杨浦区",
  310112: "闵行区",
  310113: "宝山区",
  310114: "嘉定区",
  310115: "浦东新区",
  310116: "金山区",
  310117: "松江区",
  310118: "青浦区",
  310120: "奉贤区",
  310151: "崇明区",
  32e4: "江苏省",
  320100: "南京市",
  320101: "市辖区",
  320102: "玄武区",
  320104: "秦淮区",
  320105: "建邺区",
  320106: "鼓楼区",
  320111: "浦口区",
  320113: "栖霞区",
  320114: "雨花台区",
  320115: "江宁区",
  320116: "六合区",
  320117: "溧水区",
  320118: "高淳区",
  320200: "无锡市",
  320201: "市辖区",
  320205: "锡山区",
  320206: "惠山区",
  320211: "滨湖区",
  320213: "梁溪区",
  320214: "新吴区",
  320281: "江阴市",
  320282: "宜兴市",
  320300: "徐州市",
  320301: "市辖区",
  320302: "鼓楼区",
  320303: "云龙区",
  320305: "贾汪区",
  320311: "泉山区",
  320312: "铜山区",
  320321: "丰县",
  320322: "沛县",
  320324: "睢宁县",
  320381: "新沂市",
  320382: "邳州市",
  320400: "常州市",
  320401: "市辖区",
  320402: "天宁区",
  320404: "钟楼区",
  320411: "新北区",
  320412: "武进区",
  320413: "金坛区",
  320481: "溧阳市",
  320500: "苏州市",
  320501: "市辖区",
  320505: "虎丘区",
  320506: "吴中区",
  320507: "相城区",
  320508: "姑苏区",
  320509: "吴江区",
  320581: "常熟市",
  320582: "张家港市",
  320583: "昆山市",
  320585: "太仓市",
  320594: "苏州工业园区",
  320600: "南通市",
  320601: "市辖区",
  320602: "崇川区",
  320611: "港闸区",
  320612: "通州区",
  320621: "海安县",
  320623: "如东县",
  320681: "启东市",
  320682: "如皋市",
  320684: "海门市",
  320700: "连云港市",
  320701: "市辖区",
  320703: "连云区",
  320706: "海州区",
  320707: "赣榆区",
  320722: "东海县",
  320723: "灌云县",
  320724: "灌南县",
  320800: "淮安市",
  320801: "市辖区",
  320803: "淮安区",
  320804: "淮阴区",
  320812: "清江浦区",
  320813: "洪泽区",
  320826: "涟水县",
  320830: "盱眙县",
  320831: "金湖县",
  320900: "盐城市",
  320901: "市辖区",
  320902: "亭湖区",
  320903: "盐都区",
  320904: "大丰区",
  320921: "响水县",
  320922: "滨海县",
  320923: "阜宁县",
  320924: "射阳县",
  320925: "建湖县",
  320981: "东台市",
  321e3: "扬州市",
  321001: "市辖区",
  321002: "广陵区",
  321003: "邗江区",
  321012: "江都区",
  321023: "宝应县",
  321081: "仪征市",
  321084: "高邮市",
  321100: "镇江市",
  321101: "市辖区",
  321102: "京口区",
  321111: "润州区",
  321112: "丹徒区",
  321181: "丹阳市",
  321182: "扬中市",
  321183: "句容市",
  321200: "泰州市",
  321201: "市辖区",
  321202: "海陵区",
  321203: "高港区",
  321204: "姜堰区",
  321281: "兴化市",
  321282: "靖江市",
  321283: "泰兴市",
  321300: "宿迁市",
  321301: "市辖区",
  321302: "宿城区",
  321311: "宿豫区",
  321322: "沭阳县",
  321323: "泗阳县",
  321324: "泗洪县",
  33e4: "浙江省",
  330100: "杭州市",
  330101: "市辖区",
  330102: "上城区",
  330103: "下城区",
  330104: "江干区",
  330105: "拱墅区",
  330106: "西湖区",
  330108: "滨江区",
  330109: "萧山区",
  330110: "余杭区",
  330111: "富阳区",
  330122: "桐庐县",
  330127: "淳安县",
  330182: "建德市",
  330185: "临安市",
  330200: "宁波市",
  330201: "市辖区",
  330203: "海曙区",
  330204: "江东区",
  330205: "江北区",
  330206: "北仑区",
  330211: "镇海区",
  330212: "鄞州区",
  330225: "象山县",
  330226: "宁海县",
  330281: "余姚市",
  330282: "慈溪市",
  330283: "奉化市",
  330300: "温州市",
  330301: "市辖区",
  330302: "鹿城区",
  330303: "龙湾区",
  330304: "瓯海区",
  330305: "洞头区",
  330324: "永嘉县",
  330326: "平阳县",
  330327: "苍南县",
  330328: "文成县",
  330329: "泰顺县",
  330381: "瑞安市",
  330382: "乐清市",
  330400: "嘉兴市",
  330401: "市辖区",
  330402: "南湖区",
  330411: "秀洲区",
  330421: "嘉善县",
  330424: "海盐县",
  330481: "海宁市",
  330482: "平湖市",
  330483: "桐乡市",
  330500: "湖州市",
  330501: "市辖区",
  330502: "吴兴区",
  330503: "南浔区",
  330521: "德清县",
  330522: "长兴县",
  330523: "安吉县",
  330600: "绍兴市",
  330601: "市辖区",
  330602: "越城区",
  330603: "柯桥区",
  330604: "上虞区",
  330624: "新昌县",
  330681: "诸暨市",
  330683: "嵊州市",
  330700: "金华市",
  330701: "市辖区",
  330702: "婺城区",
  330703: "金东区",
  330723: "武义县",
  330726: "浦江县",
  330727: "磐安县",
  330781: "兰溪市",
  330782: "义乌市",
  330783: "东阳市",
  330784: "永康市",
  330800: "衢州市",
  330801: "市辖区",
  330802: "柯城区",
  330803: "衢江区",
  330822: "常山县",
  330824: "开化县",
  330825: "龙游县",
  330881: "江山市",
  330900: "舟山市",
  330901: "市辖区",
  330902: "定海区",
  330903: "普陀区",
  330921: "岱山县",
  330922: "嵊泗县",
  331e3: "台州市",
  331001: "市辖区",
  331002: "椒江区",
  331003: "黄岩区",
  331004: "路桥区",
  331021: "玉环县",
  331022: "三门县",
  331023: "天台县",
  331024: "仙居县",
  331081: "温岭市",
  331082: "临海市",
  331100: "丽水市",
  331101: "市辖区",
  331102: "莲都区",
  331121: "青田县",
  331122: "缙云县",
  331123: "遂昌县",
  331124: "松阳县",
  331125: "云和县",
  331126: "庆元县",
  331127: "景宁畲族自治县",
  331181: "龙泉市",
  34e4: "安徽省",
  340100: "合肥市",
  340101: "市辖区",
  340102: "瑶海区",
  340103: "庐阳区",
  340104: "蜀山区",
  340111: "包河区",
  340121: "长丰县",
  340122: "肥东县",
  340123: "肥西县",
  340124: "庐江县",
  340181: "巢湖市",
  340200: "芜湖市",
  340201: "市辖区",
  340202: "镜湖区",
  340203: "弋江区",
  340207: "鸠江区",
  340208: "三山区",
  340221: "芜湖县",
  340222: "繁昌县",
  340223: "南陵县",
  340225: "无为县",
  340300: "蚌埠市",
  340301: "市辖区",
  340302: "龙子湖区",
  340303: "蚌山区",
  340304: "禹会区",
  340311: "淮上区",
  340321: "怀远县",
  340322: "五河县",
  340323: "固镇县",
  340400: "淮南市",
  340401: "市辖区",
  340402: "大通区",
  340403: "田家庵区",
  340404: "谢家集区",
  340405: "八公山区",
  340406: "潘集区",
  340421: "凤台县",
  340422: "寿县",
  340500: "马鞍山市",
  340501: "市辖区",
  340503: "花山区",
  340504: "雨山区",
  340506: "博望区",
  340521: "当涂县",
  340522: "含山县",
  340523: "和县",
  340600: "淮北市",
  340601: "市辖区",
  340602: "杜集区",
  340603: "相山区",
  340604: "烈山区",
  340621: "濉溪县",
  340700: "铜陵市",
  340701: "市辖区",
  340705: "铜官区",
  340706: "义安区",
  340711: "郊区",
  340722: "枞阳县",
  340800: "安庆市",
  340801: "市辖区",
  340802: "迎江区",
  340803: "大观区",
  340811: "宜秀区",
  340822: "怀宁县",
  340824: "潜山县",
  340825: "太湖县",
  340826: "宿松县",
  340827: "望江县",
  340828: "岳西县",
  340881: "桐城市",
  341e3: "黄山市",
  341001: "市辖区",
  341002: "屯溪区",
  341003: "黄山区",
  341004: "徽州区",
  341021: "歙县",
  341022: "休宁县",
  341023: "黟县",
  341024: "祁门县",
  341100: "滁州市",
  341101: "市辖区",
  341102: "琅琊区",
  341103: "南谯区",
  341122: "来安县",
  341124: "全椒县",
  341125: "定远县",
  341126: "凤阳县",
  341181: "天长市",
  341182: "明光市",
  341200: "阜阳市",
  341201: "市辖区",
  341202: "颍州区",
  341203: "颍东区",
  341204: "颍泉区",
  341221: "临泉县",
  341222: "太和县",
  341225: "阜南县",
  341226: "颍上县",
  341282: "界首市",
  341300: "宿州市",
  341301: "市辖区",
  341302: "埇桥区",
  341321: "砀山县",
  341322: "萧县",
  341323: "灵璧县",
  341324: "泗县",
  341500: "六安市",
  341501: "市辖区",
  341502: "金安区",
  341503: "裕安区",
  341504: "叶集区",
  341522: "霍邱县",
  341523: "舒城县",
  341524: "金寨县",
  341525: "霍山县",
  341600: "亳州市",
  341601: "市辖区",
  341602: "谯城区",
  341621: "涡阳县",
  341622: "蒙城县",
  341623: "利辛县",
  341700: "池州市",
  341701: "市辖区",
  341702: "贵池区",
  341721: "东至县",
  341722: "石台县",
  341723: "青阳县",
  341800: "宣城市",
  341801: "市辖区",
  341802: "宣州区",
  341821: "郎溪县",
  341822: "广德县",
  341823: "泾县",
  341824: "绩溪县",
  341825: "旌德县",
  341881: "宁国市",
  35e4: "福建省",
  350100: "福州市",
  350101: "市辖区",
  350102: "鼓楼区",
  350103: "台江区",
  350104: "仓山区",
  350105: "马尾区",
  350111: "晋安区",
  350121: "闽侯县",
  350122: "连江县",
  350123: "罗源县",
  350124: "闽清县",
  350125: "永泰县",
  350128: "平潭县",
  350181: "福清市",
  350182: "长乐市",
  350200: "厦门市",
  350201: "市辖区",
  350203: "思明区",
  350205: "海沧区",
  350206: "湖里区",
  350211: "集美区",
  350212: "同安区",
  350213: "翔安区",
  350300: "莆田市",
  350301: "市辖区",
  350302: "城厢区",
  350303: "涵江区",
  350304: "荔城区",
  350305: "秀屿区",
  350322: "仙游县",
  350400: "三明市",
  350401: "市辖区",
  350402: "梅列区",
  350403: "三元区",
  350421: "明溪县",
  350423: "清流县",
  350424: "宁化县",
  350425: "大田县",
  350426: "尤溪县",
  350427: "沙县",
  350428: "将乐县",
  350429: "泰宁县",
  350430: "建宁县",
  350481: "永安市",
  350500: "泉州市",
  350501: "市辖区",
  350502: "鲤城区",
  350503: "丰泽区",
  350504: "洛江区",
  350505: "泉港区",
  350521: "惠安县",
  350524: "安溪县",
  350525: "永春县",
  350526: "德化县",
  350527: "金门县",
  350581: "石狮市",
  350582: "晋江市",
  350583: "南安市",
  350600: "漳州市",
  350601: "市辖区",
  350602: "芗城区",
  350603: "龙文区",
  350622: "云霄县",
  350623: "漳浦县",
  350624: "诏安县",
  350625: "长泰县",
  350626: "东山县",
  350627: "南靖县",
  350628: "平和县",
  350629: "华安县",
  350681: "龙海市",
  350700: "南平市",
  350701: "市辖区",
  350702: "延平区",
  350703: "建阳区",
  350721: "顺昌县",
  350722: "浦城县",
  350723: "光泽县",
  350724: "松溪县",
  350725: "政和县",
  350781: "邵武市",
  350782: "武夷山市",
  350783: "建瓯市",
  350800: "龙岩市",
  350801: "市辖区",
  350802: "新罗区",
  350803: "永定区",
  350821: "长汀县",
  350823: "上杭县",
  350824: "武平县",
  350825: "连城县",
  350881: "漳平市",
  350900: "宁德市",
  350901: "市辖区",
  350902: "蕉城区",
  350921: "霞浦县",
  350922: "古田县",
  350923: "屏南县",
  350924: "寿宁县",
  350925: "周宁县",
  350926: "柘荣县",
  350981: "福安市",
  350982: "福鼎市",
  36e4: "江西省",
  360100: "南昌市",
  360101: "市辖区",
  360102: "东湖区",
  360103: "西湖区",
  360104: "青云谱区",
  360105: "湾里区",
  360111: "青山湖区",
  360112: "新建区",
  360121: "南昌县",
  360123: "安义县",
  360124: "进贤县",
  360200: "景德镇市",
  360201: "市辖区",
  360202: "昌江区",
  360203: "珠山区",
  360222: "浮梁县",
  360281: "乐平市",
  360300: "萍乡市",
  360301: "市辖区",
  360302: "安源区",
  360313: "湘东区",
  360321: "莲花县",
  360322: "上栗县",
  360323: "芦溪县",
  360400: "九江市",
  360401: "市辖区",
  360402: "濂溪区",
  360403: "浔阳区",
  360421: "九江县",
  360423: "武宁县",
  360424: "修水县",
  360425: "永修县",
  360426: "德安县",
  360428: "都昌县",
  360429: "湖口县",
  360430: "彭泽县",
  360481: "瑞昌市",
  360482: "共青城市",
  360483: "庐山市",
  360500: "新余市",
  360501: "市辖区",
  360502: "渝水区",
  360521: "分宜县",
  360600: "鹰潭市",
  360601: "市辖区",
  360602: "月湖区",
  360622: "余江县",
  360681: "贵溪市",
  360700: "赣州市",
  360701: "市辖区",
  360702: "章贡区",
  360703: "南康区",
  360721: "赣县",
  360722: "信丰县",
  360723: "大余县",
  360724: "上犹县",
  360725: "崇义县",
  360726: "安远县",
  360727: "龙南县",
  360728: "定南县",
  360729: "全南县",
  360730: "宁都县",
  360731: "于都县",
  360732: "兴国县",
  360733: "会昌县",
  360734: "寻乌县",
  360735: "石城县",
  360781: "瑞金市",
  360800: "吉安市",
  360801: "市辖区",
  360802: "吉州区",
  360803: "青原区",
  360821: "吉安县",
  360822: "吉水县",
  360823: "峡江县",
  360824: "新干县",
  360825: "永丰县",
  360826: "泰和县",
  360827: "遂川县",
  360828: "万安县",
  360829: "安福县",
  360830: "永新县",
  360881: "井冈山市",
  360900: "宜春市",
  360901: "市辖区",
  360902: "袁州区",
  360921: "奉新县",
  360922: "万载县",
  360923: "上高县",
  360924: "宜丰县",
  360925: "靖安县",
  360926: "铜鼓县",
  360981: "丰城市",
  360982: "樟树市",
  360983: "高安市",
  361e3: "抚州市",
  361001: "市辖区",
  361002: "临川区",
  361021: "南城县",
  361022: "黎川县",
  361023: "南丰县",
  361024: "崇仁县",
  361025: "乐安县",
  361026: "宜黄县",
  361027: "金溪县",
  361028: "资溪县",
  361029: "东乡县",
  361030: "广昌县",
  361100: "上饶市",
  361101: "市辖区",
  361102: "信州区",
  361103: "广丰区",
  361121: "上饶县",
  361123: "玉山县",
  361124: "铅山县",
  361125: "横峰县",
  361126: "弋阳县",
  361127: "余干县",
  361128: "鄱阳县",
  361129: "万年县",
  361130: "婺源县",
  361181: "德兴市",
  37e4: "山东省",
  370100: "济南市",
  370101: "市辖区",
  370102: "历下区",
  370103: "市中区",
  370104: "槐荫区",
  370105: "天桥区",
  370112: "历城区",
  370113: "长清区",
  370124: "平阴县",
  370125: "济阳县",
  370126: "商河县",
  370181: "章丘市",
  370200: "青岛市",
  370201: "市辖区",
  370202: "市南区",
  370203: "市北区",
  370211: "黄岛区",
  370212: "崂山区",
  370213: "李沧区",
  370214: "城阳区",
  370281: "胶州市",
  370282: "即墨市",
  370283: "平度市",
  370285: "莱西市",
  370300: "淄博市",
  370301: "市辖区",
  370302: "淄川区",
  370303: "张店区",
  370304: "博山区",
  370305: "临淄区",
  370306: "周村区",
  370321: "桓台县",
  370322: "高青县",
  370323: "沂源县",
  370400: "枣庄市",
  370401: "市辖区",
  370402: "市中区",
  370403: "薛城区",
  370404: "峄城区",
  370405: "台儿庄区",
  370406: "山亭区",
  370481: "滕州市",
  370500: "东营市",
  370501: "市辖区",
  370502: "东营区",
  370503: "河口区",
  370505: "垦利区",
  370522: "利津县",
  370523: "广饶县",
  370600: "烟台市",
  370601: "市辖区",
  370602: "芝罘区",
  370611: "福山区",
  370612: "牟平区",
  370613: "莱山区",
  370634: "长岛县",
  370681: "龙口市",
  370682: "莱阳市",
  370683: "莱州市",
  370684: "蓬莱市",
  370685: "招远市",
  370686: "栖霞市",
  370687: "海阳市",
  370700: "潍坊市",
  370701: "市辖区",
  370702: "潍城区",
  370703: "寒亭区",
  370704: "坊子区",
  370705: "奎文区",
  370724: "临朐县",
  370725: "昌乐县",
  370781: "青州市",
  370782: "诸城市",
  370783: "寿光市",
  370784: "安丘市",
  370785: "高密市",
  370786: "昌邑市",
  370800: "济宁市",
  370801: "市辖区",
  370811: "任城区",
  370812: "兖州区",
  370826: "微山县",
  370827: "鱼台县",
  370828: "金乡县",
  370829: "嘉祥县",
  370830: "汶上县",
  370831: "泗水县",
  370832: "梁山县",
  370881: "曲阜市",
  370883: "邹城市",
  370900: "泰安市",
  370901: "市辖区",
  370902: "泰山区",
  370911: "岱岳区",
  370921: "宁阳县",
  370923: "东平县",
  370982: "新泰市",
  370983: "肥城市",
  371e3: "威海市",
  371001: "市辖区",
  371002: "环翠区",
  371003: "文登区",
  371082: "荣成市",
  371083: "乳山市",
  371100: "日照市",
  371101: "市辖区",
  371102: "东港区",
  371103: "岚山区",
  371121: "五莲县",
  371122: "莒县",
  371200: "莱芜市",
  371201: "市辖区",
  371202: "莱城区",
  371203: "钢城区",
  371300: "临沂市",
  371301: "市辖区",
  371302: "兰山区",
  371311: "罗庄区",
  371312: "河东区",
  371321: "沂南县",
  371322: "郯城县",
  371323: "沂水县",
  371324: "兰陵县",
  371325: "费县",
  371326: "平邑县",
  371327: "莒南县",
  371328: "蒙阴县",
  371329: "临沭县",
  371400: "德州市",
  371401: "市辖区",
  371402: "德城区",
  371403: "陵城区",
  371422: "宁津县",
  371423: "庆云县",
  371424: "临邑县",
  371425: "齐河县",
  371426: "平原县",
  371427: "夏津县",
  371428: "武城县",
  371481: "乐陵市",
  371482: "禹城市",
  371500: "聊城市",
  371501: "市辖区",
  371502: "东昌府区",
  371521: "阳谷县",
  371522: "莘县",
  371523: "茌平县",
  371524: "东阿县",
  371525: "冠县",
  371526: "高唐县",
  371581: "临清市",
  371600: "滨州市",
  371601: "市辖区",
  371602: "滨城区",
  371603: "沾化区",
  371621: "惠民县",
  371622: "阳信县",
  371623: "无棣县",
  371625: "博兴县",
  371626: "邹平县",
  371700: "菏泽市",
  371701: "市辖区",
  371702: "牡丹区",
  371703: "定陶区",
  371721: "曹县",
  371722: "单县",
  371723: "成武县",
  371724: "巨野县",
  371725: "郓城县",
  371726: "鄄城县",
  371728: "东明县",
  41e4: "河南省",
  410100: "郑州市",
  410101: "市辖区",
  410102: "中原区",
  410103: "二七区",
  410104: "管城回族区",
  410105: "金水区",
  410106: "上街区",
  410108: "惠济区",
  410122: "中牟县",
  410181: "巩义市",
  410182: "荥阳市",
  410183: "新密市",
  410184: "新郑市",
  410185: "登封市",
  410200: "开封市",
  410201: "市辖区",
  410202: "龙亭区",
  410203: "顺河回族区",
  410204: "鼓楼区",
  410205: "禹王台区",
  410211: "金明区",
  410212: "祥符区",
  410221: "杞县",
  410222: "通许县",
  410223: "尉氏县",
  410225: "兰考县",
  410300: "洛阳市",
  410301: "市辖区",
  410302: "老城区",
  410303: "西工区",
  410304: "瀍河回族区",
  410305: "涧西区",
  410306: "吉利区",
  410311: "洛龙区",
  410322: "孟津县",
  410323: "新安县",
  410324: "栾川县",
  410325: "嵩县",
  410326: "汝阳县",
  410327: "宜阳县",
  410328: "洛宁县",
  410329: "伊川县",
  410381: "偃师市",
  410400: "平顶山市",
  410401: "市辖区",
  410402: "新华区",
  410403: "卫东区",
  410404: "石龙区",
  410411: "湛河区",
  410421: "宝丰县",
  410422: "叶县",
  410423: "鲁山县",
  410425: "郏县",
  410481: "舞钢市",
  410482: "汝州市",
  410500: "安阳市",
  410501: "市辖区",
  410502: "文峰区",
  410503: "北关区",
  410505: "殷都区",
  410506: "龙安区",
  410522: "安阳县",
  410523: "汤阴县",
  410526: "滑县",
  410527: "内黄县",
  410581: "林州市",
  410600: "鹤壁市",
  410601: "市辖区",
  410602: "鹤山区",
  410603: "山城区",
  410611: "淇滨区",
  410621: "浚县",
  410622: "淇县",
  410700: "新乡市",
  410701: "市辖区",
  410702: "红旗区",
  410703: "卫滨区",
  410704: "凤泉区",
  410711: "牧野区",
  410721: "新乡县",
  410724: "获嘉县",
  410725: "原阳县",
  410726: "延津县",
  410727: "封丘县",
  410728: "长垣县",
  410781: "卫辉市",
  410782: "辉县市",
  410800: "焦作市",
  410801: "市辖区",
  410802: "解放区",
  410803: "中站区",
  410804: "马村区",
  410811: "山阳区",
  410821: "修武县",
  410822: "博爱县",
  410823: "武陟县",
  410825: "温县",
  410882: "沁阳市",
  410883: "孟州市",
  410900: "濮阳市",
  410901: "市辖区",
  410902: "华龙区",
  410922: "清丰县",
  410923: "南乐县",
  410926: "范县",
  410927: "台前县",
  410928: "濮阳县",
  411e3: "许昌市",
  411001: "市辖区",
  411002: "魏都区",
  411023: "许昌县",
  411024: "鄢陵县",
  411025: "襄城县",
  411081: "禹州市",
  411082: "长葛市",
  411100: "漯河市",
  411101: "市辖区",
  411102: "源汇区",
  411103: "郾城区",
  411104: "召陵区",
  411121: "舞阳县",
  411122: "临颍县",
  411200: "三门峡市",
  411201: "市辖区",
  411202: "湖滨区",
  411203: "陕州区",
  411221: "渑池县",
  411224: "卢氏县",
  411281: "义马市",
  411282: "灵宝市",
  411300: "南阳市",
  411301: "市辖区",
  411302: "宛城区",
  411303: "卧龙区",
  411321: "南召县",
  411322: "方城县",
  411323: "西峡县",
  411324: "镇平县",
  411325: "内乡县",
  411326: "淅川县",
  411327: "社旗县",
  411328: "唐河县",
  411329: "新野县",
  411330: "桐柏县",
  411381: "邓州市",
  411400: "商丘市",
  411401: "市辖区",
  411402: "梁园区",
  411403: "睢阳区",
  411421: "民权县",
  411422: "睢县",
  411423: "宁陵县",
  411424: "柘城县",
  411425: "虞城县",
  411426: "夏邑县",
  411481: "永城市",
  411500: "信阳市",
  411501: "市辖区",
  411502: "浉河区",
  411503: "平桥区",
  411521: "罗山县",
  411522: "光山县",
  411523: "新县",
  411524: "商城县",
  411525: "固始县",
  411526: "潢川县",
  411527: "淮滨县",
  411528: "息县",
  411600: "周口市",
  411601: "市辖区",
  411602: "川汇区",
  411621: "扶沟县",
  411622: "西华县",
  411623: "商水县",
  411624: "沈丘县",
  411625: "郸城县",
  411626: "淮阳县",
  411627: "太康县",
  411628: "鹿邑县",
  411681: "项城市",
  411700: "驻马店市",
  411701: "市辖区",
  411702: "驿城区",
  411721: "西平县",
  411722: "上蔡县",
  411723: "平舆县",
  411724: "正阳县",
  411725: "确山县",
  411726: "泌阳县",
  411727: "汝南县",
  411728: "遂平县",
  411729: "新蔡县",
  419e3: "省直辖县级行政区划",
  419001: "济源市",
  42e4: "湖北省",
  420100: "武汉市",
  420101: "市辖区",
  420102: "江岸区",
  420103: "江汉区",
  420104: "硚口区",
  420105: "汉阳区",
  420106: "武昌区",
  420107: "青山区",
  420111: "洪山区",
  420112: "东西湖区",
  420113: "汉南区",
  420114: "蔡甸区",
  420115: "江夏区",
  420116: "黄陂区",
  420117: "新洲区",
  420200: "黄石市",
  420201: "市辖区",
  420202: "黄石港区",
  420203: "西塞山区",
  420204: "下陆区",
  420205: "铁山区",
  420222: "阳新县",
  420281: "大冶市",
  420300: "十堰市",
  420301: "市辖区",
  420302: "茅箭区",
  420303: "张湾区",
  420304: "郧阳区",
  420322: "郧西县",
  420323: "竹山县",
  420324: "竹溪县",
  420325: "房县",
  420381: "丹江口市",
  420500: "宜昌市",
  420501: "市辖区",
  420502: "西陵区",
  420503: "伍家岗区",
  420504: "点军区",
  420505: "猇亭区",
  420506: "夷陵区",
  420525: "远安县",
  420526: "兴山县",
  420527: "秭归县",
  420528: "长阳土家族自治县",
  420529: "五峰土家族自治县",
  420581: "宜都市",
  420582: "当阳市",
  420583: "枝江市",
  420600: "襄阳市",
  420601: "市辖区",
  420602: "襄城区",
  420606: "樊城区",
  420607: "襄州区",
  420624: "南漳县",
  420625: "谷城县",
  420626: "保康县",
  420682: "老河口市",
  420683: "枣阳市",
  420684: "宜城市",
  420700: "鄂州市",
  420701: "市辖区",
  420702: "梁子湖区",
  420703: "华容区",
  420704: "鄂城区",
  420800: "荆门市",
  420801: "市辖区",
  420802: "东宝区",
  420804: "掇刀区",
  420821: "京山县",
  420822: "沙洋县",
  420881: "钟祥市",
  420900: "孝感市",
  420901: "市辖区",
  420902: "孝南区",
  420921: "孝昌县",
  420922: "大悟县",
  420923: "云梦县",
  420981: "应城市",
  420982: "安陆市",
  420984: "汉川市",
  421e3: "荆州市",
  421001: "市辖区",
  421002: "沙市区",
  421003: "荆州区",
  421022: "公安县",
  421023: "监利县",
  421024: "江陵县",
  421081: "石首市",
  421083: "洪湖市",
  421087: "松滋市",
  421100: "黄冈市",
  421101: "市辖区",
  421102: "黄州区",
  421121: "团风县",
  421122: "红安县",
  421123: "罗田县",
  421124: "英山县",
  421125: "浠水县",
  421126: "蕲春县",
  421127: "黄梅县",
  421181: "麻城市",
  421182: "武穴市",
  421200: "咸宁市",
  421201: "市辖区",
  421202: "咸安区",
  421221: "嘉鱼县",
  421222: "通城县",
  421223: "崇阳县",
  421224: "通山县",
  421281: "赤壁市",
  421300: "随州市",
  421301: "市辖区",
  421303: "曾都区",
  421321: "随县",
  421381: "广水市",
  422800: "恩施土家族苗族自治州",
  422801: "恩施市",
  422802: "利川市",
  422822: "建始县",
  422823: "巴东县",
  422825: "宣恩县",
  422826: "咸丰县",
  422827: "来凤县",
  422828: "鹤峰县",
  429e3: "省直辖县级行政区划",
  429004: "仙桃市",
  429005: "潜江市",
  429006: "天门市",
  429021: "神农架林区",
  43e4: "湖南省",
  430100: "长沙市",
  430101: "市辖区",
  430102: "芙蓉区",
  430103: "天心区",
  430104: "岳麓区",
  430105: "开福区",
  430111: "雨花区",
  430112: "望城区",
  430121: "长沙县",
  430124: "宁乡县",
  430181: "浏阳市",
  430200: "株洲市",
  430201: "市辖区",
  430202: "荷塘区",
  430203: "芦淞区",
  430204: "石峰区",
  430211: "天元区",
  430221: "株洲县",
  430223: "攸县",
  430224: "茶陵县",
  430225: "炎陵县",
  430281: "醴陵市",
  430300: "湘潭市",
  430301: "市辖区",
  430302: "雨湖区",
  430304: "岳塘区",
  430321: "湘潭县",
  430381: "湘乡市",
  430382: "韶山市",
  430400: "衡阳市",
  430401: "市辖区",
  430405: "珠晖区",
  430406: "雁峰区",
  430407: "石鼓区",
  430408: "蒸湘区",
  430412: "南岳区",
  430421: "衡阳县",
  430422: "衡南县",
  430423: "衡山县",
  430424: "衡东县",
  430426: "祁东县",
  430481: "耒阳市",
  430482: "常宁市",
  430500: "邵阳市",
  430501: "市辖区",
  430502: "双清区",
  430503: "大祥区",
  430511: "北塔区",
  430521: "邵东县",
  430522: "新邵县",
  430523: "邵阳县",
  430524: "隆回县",
  430525: "洞口县",
  430527: "绥宁县",
  430528: "新宁县",
  430529: "城步苗族自治县",
  430581: "武冈市",
  430600: "岳阳市",
  430601: "市辖区",
  430602: "岳阳楼区",
  430603: "云溪区",
  430611: "君山区",
  430621: "岳阳县",
  430623: "华容县",
  430624: "湘阴县",
  430626: "平江县",
  430681: "汨罗市",
  430682: "临湘市",
  430700: "常德市",
  430701: "市辖区",
  430702: "武陵区",
  430703: "鼎城区",
  430721: "安乡县",
  430722: "汉寿县",
  430723: "澧县",
  430724: "临澧县",
  430725: "桃源县",
  430726: "石门县",
  430781: "津市市",
  430800: "张家界市",
  430801: "市辖区",
  430802: "永定区",
  430811: "武陵源区",
  430821: "慈利县",
  430822: "桑植县",
  430900: "益阳市",
  430901: "市辖区",
  430902: "资阳区",
  430903: "赫山区",
  430921: "南县",
  430922: "桃江县",
  430923: "安化县",
  430981: "沅江市",
  431e3: "郴州市",
  431001: "市辖区",
  431002: "北湖区",
  431003: "苏仙区",
  431021: "桂阳县",
  431022: "宜章县",
  431023: "永兴县",
  431024: "嘉禾县",
  431025: "临武县",
  431026: "汝城县",
  431027: "桂东县",
  431028: "安仁县",
  431081: "资兴市",
  431100: "永州市",
  431101: "市辖区",
  431102: "零陵区",
  431103: "冷水滩区",
  431121: "祁阳县",
  431122: "东安县",
  431123: "双牌县",
  431124: "道县",
  431125: "江永县",
  431126: "宁远县",
  431127: "蓝山县",
  431128: "新田县",
  431129: "江华瑶族自治县",
  431200: "怀化市",
  431201: "市辖区",
  431202: "鹤城区",
  431221: "中方县",
  431222: "沅陵县",
  431223: "辰溪县",
  431224: "溆浦县",
  431225: "会同县",
  431226: "麻阳苗族自治县",
  431227: "新晃侗族自治县",
  431228: "芷江侗族自治县",
  431229: "靖州苗族侗族自治县",
  431230: "通道侗族自治县",
  431281: "洪江市",
  431300: "娄底市",
  431301: "市辖区",
  431302: "娄星区",
  431321: "双峰县",
  431322: "新化县",
  431381: "冷水江市",
  431382: "涟源市",
  433100: "湘西土家族苗族自治州",
  433101: "吉首市",
  433122: "泸溪县",
  433123: "凤凰县",
  433124: "花垣县",
  433125: "保靖县",
  433126: "古丈县",
  433127: "永顺县",
  433130: "龙山县",
  44e4: "广东省",
  440100: "广州市",
  440101: "市辖区",
  440103: "荔湾区",
  440104: "越秀区",
  440105: "海珠区",
  440106: "天河区",
  440111: "白云区",
  440112: "黄埔区",
  440113: "番禺区",
  440114: "花都区",
  440115: "南沙区",
  440117: "从化区",
  440118: "增城区",
  440200: "韶关市",
  440201: "市辖区",
  440203: "武江区",
  440204: "浈江区",
  440205: "曲江区",
  440222: "始兴县",
  440224: "仁化县",
  440229: "翁源县",
  440232: "乳源瑶族自治县",
  440233: "新丰县",
  440281: "乐昌市",
  440282: "南雄市",
  440300: "深圳市",
  440301: "市辖区",
  440303: "罗湖区",
  440304: "福田区",
  440305: "南山区",
  440306: "宝安区",
  440307: "龙岗区",
  440308: "盐田区",
  440400: "珠海市",
  440401: "市辖区",
  440402: "香洲区",
  440403: "斗门区",
  440404: "金湾区",
  440500: "汕头市",
  440501: "市辖区",
  440507: "龙湖区",
  440511: "金平区",
  440512: "濠江区",
  440513: "潮阳区",
  440514: "潮南区",
  440515: "澄海区",
  440523: "南澳县",
  440600: "佛山市",
  440601: "市辖区",
  440604: "禅城区",
  440605: "南海区",
  440606: "顺德区",
  440607: "三水区",
  440608: "高明区",
  440700: "江门市",
  440701: "市辖区",
  440703: "蓬江区",
  440704: "江海区",
  440705: "新会区",
  440781: "台山市",
  440783: "开平市",
  440784: "鹤山市",
  440785: "恩平市",
  440800: "湛江市",
  440801: "市辖区",
  440802: "赤坎区",
  440803: "霞山区",
  440804: "坡头区",
  440811: "麻章区",
  440823: "遂溪县",
  440825: "徐闻县",
  440881: "廉江市",
  440882: "雷州市",
  440883: "吴川市",
  440900: "茂名市",
  440901: "市辖区",
  440902: "茂南区",
  440904: "电白区",
  440981: "高州市",
  440982: "化州市",
  440983: "信宜市",
  441200: "肇庆市",
  441201: "市辖区",
  441202: "端州区",
  441203: "鼎湖区",
  441204: "高要区",
  441223: "广宁县",
  441224: "怀集县",
  441225: "封开县",
  441226: "德庆县",
  441284: "四会市",
  441300: "惠州市",
  441301: "市辖区",
  441302: "惠城区",
  441303: "惠阳区",
  441322: "博罗县",
  441323: "惠东县",
  441324: "龙门县",
  441400: "梅州市",
  441401: "市辖区",
  441402: "梅江区",
  441403: "梅县区",
  441422: "大埔县",
  441423: "丰顺县",
  441424: "五华县",
  441426: "平远县",
  441427: "蕉岭县",
  441481: "兴宁市",
  441500: "汕尾市",
  441501: "市辖区",
  441502: "城区",
  441521: "海丰县",
  441523: "陆河县",
  441581: "陆丰市",
  441600: "河源市",
  441601: "市辖区",
  441602: "源城区",
  441621: "紫金县",
  441622: "龙川县",
  441623: "连平县",
  441624: "和平县",
  441625: "东源县",
  441700: "阳江市",
  441701: "市辖区",
  441702: "江城区",
  441704: "阳东区",
  441721: "阳西县",
  441781: "阳春市",
  441800: "清远市",
  441801: "市辖区",
  441802: "清城区",
  441803: "清新区",
  441821: "佛冈县",
  441823: "阳山县",
  441825: "连山壮族瑶族自治县",
  441826: "连南瑶族自治县",
  441881: "英德市",
  441882: "连州市",
  441900: "东莞市",
  442e3: "中山市",
  445100: "潮州市",
  445101: "市辖区",
  445102: "湘桥区",
  445103: "潮安区",
  445122: "饶平县",
  445200: "揭阳市",
  445201: "市辖区",
  445202: "榕城区",
  445203: "揭东区",
  445222: "揭西县",
  445224: "惠来县",
  445281: "普宁市",
  445300: "云浮市",
  445301: "市辖区",
  445302: "云城区",
  445303: "云安区",
  445321: "新兴县",
  445322: "郁南县",
  445381: "罗定市",
  45e4: "广西壮族自治区",
  450100: "南宁市",
  450101: "市辖区",
  450102: "兴宁区",
  450103: "青秀区",
  450105: "江南区",
  450107: "西乡塘区",
  450108: "良庆区",
  450109: "邕宁区",
  450110: "武鸣区",
  450123: "隆安县",
  450124: "马山县",
  450125: "上林县",
  450126: "宾阳县",
  450127: "横县",
  450200: "柳州市",
  450201: "市辖区",
  450202: "城中区",
  450203: "鱼峰区",
  450204: "柳南区",
  450205: "柳北区",
  450206: "柳江区",
  450222: "柳城县",
  450223: "鹿寨县",
  450224: "融安县",
  450225: "融水苗族自治县",
  450226: "三江侗族自治县",
  450300: "桂林市",
  450301: "市辖区",
  450302: "秀峰区",
  450303: "叠彩区",
  450304: "象山区",
  450305: "七星区",
  450311: "雁山区",
  450312: "临桂区",
  450321: "阳朔县",
  450323: "灵川县",
  450324: "全州县",
  450325: "兴安县",
  450326: "永福县",
  450327: "灌阳县",
  450328: "龙胜各族自治县",
  450329: "资源县",
  450330: "平乐县",
  450331: "荔浦县",
  450332: "恭城瑶族自治县",
  450400: "梧州市",
  450401: "市辖区",
  450403: "万秀区",
  450405: "长洲区",
  450406: "龙圩区",
  450421: "苍梧县",
  450422: "藤县",
  450423: "蒙山县",
  450481: "岑溪市",
  450500: "北海市",
  450501: "市辖区",
  450502: "海城区",
  450503: "银海区",
  450512: "铁山港区",
  450521: "合浦县",
  450600: "防城港市",
  450601: "市辖区",
  450602: "港口区",
  450603: "防城区",
  450621: "上思县",
  450681: "东兴市",
  450700: "钦州市",
  450701: "市辖区",
  450702: "钦南区",
  450703: "钦北区",
  450721: "灵山县",
  450722: "浦北县",
  450800: "贵港市",
  450801: "市辖区",
  450802: "港北区",
  450803: "港南区",
  450804: "覃塘区",
  450821: "平南县",
  450881: "桂平市",
  450900: "玉林市",
  450901: "市辖区",
  450902: "玉州区",
  450903: "福绵区",
  450921: "容县",
  450922: "陆川县",
  450923: "博白县",
  450924: "兴业县",
  450981: "北流市",
  451e3: "百色市",
  451001: "市辖区",
  451002: "右江区",
  451021: "田阳县",
  451022: "田东县",
  451023: "平果县",
  451024: "德保县",
  451026: "那坡县",
  451027: "凌云县",
  451028: "乐业县",
  451029: "田林县",
  451030: "西林县",
  451031: "隆林各族自治县",
  451081: "靖西市",
  451100: "贺州市",
  451101: "市辖区",
  451102: "八步区",
  451103: "平桂区",
  451121: "昭平县",
  451122: "钟山县",
  451123: "富川瑶族自治县",
  451200: "河池市",
  451201: "市辖区",
  451202: "金城江区",
  451221: "南丹县",
  451222: "天峨县",
  451223: "凤山县",
  451224: "东兰县",
  451225: "罗城仫佬族自治县",
  451226: "环江毛南族自治县",
  451227: "巴马瑶族自治县",
  451228: "都安瑶族自治县",
  451229: "大化瑶族自治县",
  451281: "宜州市",
  451300: "来宾市",
  451301: "市辖区",
  451302: "兴宾区",
  451321: "忻城县",
  451322: "象州县",
  451323: "武宣县",
  451324: "金秀瑶族自治县",
  451381: "合山市",
  451400: "崇左市",
  451401: "市辖区",
  451402: "江州区",
  451421: "扶绥县",
  451422: "宁明县",
  451423: "龙州县",
  451424: "大新县",
  451425: "天等县",
  451481: "凭祥市",
  46e4: "海南省",
  460100: "海口市",
  460101: "市辖区",
  460105: "秀英区",
  460106: "龙华区",
  460107: "琼山区",
  460108: "美兰区",
  460200: "三亚市",
  460201: "市辖区",
  460202: "海棠区",
  460203: "吉阳区",
  460204: "天涯区",
  460205: "崖州区",
  460300: "三沙市",
  460400: "儋州市",
  469e3: "省直辖县级行政区划",
  469001: "五指山市",
  469002: "琼海市",
  469005: "文昌市",
  469006: "万宁市",
  469007: "东方市",
  469021: "定安县",
  469022: "屯昌县",
  469023: "澄迈县",
  469024: "临高县",
  469025: "白沙黎族自治县",
  469026: "昌江黎族自治县",
  469027: "乐东黎族自治县",
  469028: "陵水黎族自治县",
  469029: "保亭黎族苗族自治县",
  469030: "琼中黎族苗族自治县",
  5e5: "重庆市",
  500100: "市辖区",
  500101: "万州区",
  500102: "涪陵区",
  500103: "渝中区",
  500104: "大渡口区",
  500105: "江北区",
  500106: "沙坪坝区",
  500107: "九龙坡区",
  500108: "南岸区",
  500109: "北碚区",
  500110: "綦江区",
  500111: "大足区",
  500112: "渝北区",
  500113: "巴南区",
  500114: "黔江区",
  500115: "长寿区",
  500116: "江津区",
  500117: "合川区",
  500118: "永川区",
  500119: "南川区",
  500120: "璧山区",
  500151: "铜梁区",
  500152: "潼南区",
  500153: "荣昌区",
  500154: "开州区",
  500200: "县",
  500228: "梁平县",
  500229: "城口县",
  500230: "丰都县",
  500231: "垫江县",
  500232: "武隆县",
  500233: "忠县",
  500235: "云阳县",
  500236: "奉节县",
  500237: "巫山县",
  500238: "巫溪县",
  500240: "石柱土家族自治县",
  500241: "秀山土家族苗族自治县",
  500242: "酉阳土家族苗族自治县",
  500243: "彭水苗族土家族自治县",
  51e4: "四川省",
  510100: "成都市",
  510101: "市辖区",
  510104: "锦江区",
  510105: "青羊区",
  510106: "金牛区",
  510107: "武侯区",
  510108: "成华区",
  510112: "龙泉驿区",
  510113: "青白江区",
  510114: "新都区",
  510115: "温江区",
  510116: "双流区",
  510121: "金堂县",
  510124: "郫县",
  510129: "大邑县",
  510131: "蒲江县",
  510132: "新津县",
  510181: "都江堰市",
  510182: "彭州市",
  510183: "邛崃市",
  510184: "崇州市",
  510185: "简阳市",
  510300: "自贡市",
  510301: "市辖区",
  510302: "自流井区",
  510303: "贡井区",
  510304: "大安区",
  510311: "沿滩区",
  510321: "荣县",
  510322: "富顺县",
  510400: "攀枝花市",
  510401: "市辖区",
  510402: "东区",
  510403: "西区",
  510411: "仁和区",
  510421: "米易县",
  510422: "盐边县",
  510500: "泸州市",
  510501: "市辖区",
  510502: "江阳区",
  510503: "纳溪区",
  510504: "龙马潭区",
  510521: "泸县",
  510522: "合江县",
  510524: "叙永县",
  510525: "古蔺县",
  510600: "德阳市",
  510601: "市辖区",
  510603: "旌阳区",
  510623: "中江县",
  510626: "罗江县",
  510681: "广汉市",
  510682: "什邡市",
  510683: "绵竹市",
  510700: "绵阳市",
  510701: "市辖区",
  510703: "涪城区",
  510704: "游仙区",
  510705: "安州区",
  510722: "三台县",
  510723: "盐亭县",
  510725: "梓潼县",
  510726: "北川羌族自治县",
  510727: "平武县",
  510781: "江油市",
  510800: "广元市",
  510801: "市辖区",
  510802: "利州区",
  510811: "昭化区",
  510812: "朝天区",
  510821: "旺苍县",
  510822: "青川县",
  510823: "剑阁县",
  510824: "苍溪县",
  510900: "遂宁市",
  510901: "市辖区",
  510903: "船山区",
  510904: "安居区",
  510921: "蓬溪县",
  510922: "射洪县",
  510923: "大英县",
  511e3: "内江市",
  511001: "市辖区",
  511002: "市中区",
  511011: "东兴区",
  511024: "威远县",
  511025: "资中县",
  511028: "隆昌县",
  511100: "乐山市",
  511101: "市辖区",
  511102: "市中区",
  511111: "沙湾区",
  511112: "五通桥区",
  511113: "金口河区",
  511123: "犍为县",
  511124: "井研县",
  511126: "夹江县",
  511129: "沐川县",
  511132: "峨边彝族自治县",
  511133: "马边彝族自治县",
  511181: "峨眉山市",
  511300: "南充市",
  511301: "市辖区",
  511302: "顺庆区",
  511303: "高坪区",
  511304: "嘉陵区",
  511321: "南部县",
  511322: "营山县",
  511323: "蓬安县",
  511324: "仪陇县",
  511325: "西充县",
  511381: "阆中市",
  511400: "眉山市",
  511401: "市辖区",
  511402: "东坡区",
  511403: "彭山区",
  511421: "仁寿县",
  511423: "洪雅县",
  511424: "丹棱县",
  511425: "青神县",
  511500: "宜宾市",
  511501: "市辖区",
  511502: "翠屏区",
  511503: "南溪区",
  511521: "宜宾县",
  511523: "江安县",
  511524: "长宁县",
  511525: "高县",
  511526: "珙县",
  511527: "筠连县",
  511528: "兴文县",
  511529: "屏山县",
  511600: "广安市",
  511601: "市辖区",
  511602: "广安区",
  511603: "前锋区",
  511621: "岳池县",
  511622: "武胜县",
  511623: "邻水县",
  511681: "华蓥市",
  511700: "达州市",
  511701: "市辖区",
  511702: "通川区",
  511703: "达川区",
  511722: "宣汉县",
  511723: "开江县",
  511724: "大竹县",
  511725: "渠县",
  511781: "万源市",
  511800: "雅安市",
  511801: "市辖区",
  511802: "雨城区",
  511803: "名山区",
  511822: "荥经县",
  511823: "汉源县",
  511824: "石棉县",
  511825: "天全县",
  511826: "芦山县",
  511827: "宝兴县",
  511900: "巴中市",
  511901: "市辖区",
  511902: "巴州区",
  511903: "恩阳区",
  511921: "通江县",
  511922: "南江县",
  511923: "平昌县",
  512e3: "资阳市",
  512001: "市辖区",
  512002: "雁江区",
  512021: "安岳县",
  512022: "乐至县",
  513200: "阿坝藏族羌族自治州",
  513201: "马尔康市",
  513221: "汶川县",
  513222: "理县",
  513223: "茂县",
  513224: "松潘县",
  513225: "九寨沟县",
  513226: "金川县",
  513227: "小金县",
  513228: "黑水县",
  513230: "壤塘县",
  513231: "阿坝县",
  513232: "若尔盖县",
  513233: "红原县",
  513300: "甘孜藏族自治州",
  513301: "康定市",
  513322: "泸定县",
  513323: "丹巴县",
  513324: "九龙县",
  513325: "雅江县",
  513326: "道孚县",
  513327: "炉霍县",
  513328: "甘孜县",
  513329: "新龙县",
  513330: "德格县",
  513331: "白玉县",
  513332: "石渠县",
  513333: "色达县",
  513334: "理塘县",
  513335: "巴塘县",
  513336: "乡城县",
  513337: "稻城县",
  513338: "得荣县",
  513400: "凉山彝族自治州",
  513401: "西昌市",
  513422: "木里藏族自治县",
  513423: "盐源县",
  513424: "德昌县",
  513425: "会理县",
  513426: "会东县",
  513427: "宁南县",
  513428: "普格县",
  513429: "布拖县",
  513430: "金阳县",
  513431: "昭觉县",
  513432: "喜德县",
  513433: "冕宁县",
  513434: "越西县",
  513435: "甘洛县",
  513436: "美姑县",
  513437: "雷波县",
  52e4: "贵州省",
  520100: "贵阳市",
  520101: "市辖区",
  520102: "南明区",
  520103: "云岩区",
  520111: "花溪区",
  520112: "乌当区",
  520113: "白云区",
  520115: "观山湖区",
  520121: "开阳县",
  520122: "息烽县",
  520123: "修文县",
  520181: "清镇市",
  520200: "六盘水市",
  520201: "钟山区",
  520203: "六枝特区",
  520221: "水城县",
  520222: "盘县",
  520300: "遵义市",
  520301: "市辖区",
  520302: "红花岗区",
  520303: "汇川区",
  520304: "播州区",
  520322: "桐梓县",
  520323: "绥阳县",
  520324: "正安县",
  520325: "道真仡佬族苗族自治县",
  520326: "务川仡佬族苗族自治县",
  520327: "凤冈县",
  520328: "湄潭县",
  520329: "余庆县",
  520330: "习水县",
  520381: "赤水市",
  520382: "仁怀市",
  520400: "安顺市",
  520401: "市辖区",
  520402: "西秀区",
  520403: "平坝区",
  520422: "普定县",
  520423: "镇宁布依族苗族自治县",
  520424: "关岭布依族苗族自治县",
  520425: "紫云苗族布依族自治县",
  520500: "毕节市",
  520501: "市辖区",
  520502: "七星关区",
  520521: "大方县",
  520522: "黔西县",
  520523: "金沙县",
  520524: "织金县",
  520525: "纳雍县",
  520526: "威宁彝族回族苗族自治县",
  520527: "赫章县",
  520600: "铜仁市",
  520601: "市辖区",
  520602: "碧江区",
  520603: "万山区",
  520621: "江口县",
  520622: "玉屏侗族自治县",
  520623: "石阡县",
  520624: "思南县",
  520625: "印江土家族苗族自治县",
  520626: "德江县",
  520627: "沿河土家族自治县",
  520628: "松桃苗族自治县",
  522300: "黔西南布依族苗族自治州",
  522301: "兴义市",
  522322: "兴仁县",
  522323: "普安县",
  522324: "晴隆县",
  522325: "贞丰县",
  522326: "望谟县",
  522327: "册亨县",
  522328: "安龙县",
  522600: "黔东南苗族侗族自治州",
  522601: "凯里市",
  522622: "黄平县",
  522623: "施秉县",
  522624: "三穗县",
  522625: "镇远县",
  522626: "岑巩县",
  522627: "天柱县",
  522628: "锦屏县",
  522629: "剑河县",
  522630: "台江县",
  522631: "黎平县",
  522632: "榕江县",
  522633: "从江县",
  522634: "雷山县",
  522635: "麻江县",
  522636: "丹寨县",
  522700: "黔南布依族苗族自治州",
  522701: "都匀市",
  522702: "福泉市",
  522722: "荔波县",
  522723: "贵定县",
  522725: "瓮安县",
  522726: "独山县",
  522727: "平塘县",
  522728: "罗甸县",
  522729: "长顺县",
  522730: "龙里县",
  522731: "惠水县",
  522732: "三都水族自治县",
  53e4: "云南省",
  530100: "昆明市",
  530101: "市辖区",
  530102: "五华区",
  530103: "盘龙区",
  530111: "官渡区",
  530112: "西山区",
  530113: "东川区",
  530114: "呈贡区",
  530122: "晋宁县",
  530124: "富民县",
  530125: "宜良县",
  530126: "石林彝族自治县",
  530127: "嵩明县",
  530128: "禄劝彝族苗族自治县",
  530129: "寻甸回族彝族自治县",
  530181: "安宁市",
  530300: "曲靖市",
  530301: "市辖区",
  530302: "麒麟区",
  530303: "沾益区",
  530321: "马龙县",
  530322: "陆良县",
  530323: "师宗县",
  530324: "罗平县",
  530325: "富源县",
  530326: "会泽县",
  530381: "宣威市",
  530400: "玉溪市",
  530401: "市辖区",
  530402: "红塔区",
  530403: "江川区",
  530422: "澄江县",
  530423: "通海县",
  530424: "华宁县",
  530425: "易门县",
  530426: "峨山彝族自治县",
  530427: "新平彝族傣族自治县",
  530428: "元江哈尼族彝族傣族自治县",
  530500: "保山市",
  530501: "市辖区",
  530502: "隆阳区",
  530521: "施甸县",
  530523: "龙陵县",
  530524: "昌宁县",
  530581: "腾冲市",
  530600: "昭通市",
  530601: "市辖区",
  530602: "昭阳区",
  530621: "鲁甸县",
  530622: "巧家县",
  530623: "盐津县",
  530624: "大关县",
  530625: "永善县",
  530626: "绥江县",
  530627: "镇雄县",
  530628: "彝良县",
  530629: "威信县",
  530630: "水富县",
  530700: "丽江市",
  530701: "市辖区",
  530702: "古城区",
  530721: "玉龙纳西族自治县",
  530722: "永胜县",
  530723: "华坪县",
  530724: "宁蒗彝族自治县",
  530800: "普洱市",
  530801: "市辖区",
  530802: "思茅区",
  530821: "宁洱哈尼族彝族自治县",
  530822: "墨江哈尼族自治县",
  530823: "景东彝族自治县",
  530824: "景谷傣族彝族自治县",
  530825: "镇沅彝族哈尼族拉祜族自治县",
  530826: "江城哈尼族彝族自治县",
  530827: "孟连傣族拉祜族佤族自治县",
  530828: "澜沧拉祜族自治县",
  530829: "西盟佤族自治县",
  530900: "临沧市",
  530901: "市辖区",
  530902: "临翔区",
  530921: "凤庆县",
  530922: "云县",
  530923: "永德县",
  530924: "镇康县",
  530925: "双江拉祜族佤族布朗族傣族自治县",
  530926: "耿马傣族佤族自治县",
  530927: "沧源佤族自治县",
  532300: "楚雄彝族自治州",
  532301: "楚雄市",
  532322: "双柏县",
  532323: "牟定县",
  532324: "南华县",
  532325: "姚安县",
  532326: "大姚县",
  532327: "永仁县",
  532328: "元谋县",
  532329: "武定县",
  532331: "禄丰县",
  532500: "红河哈尼族彝族自治州",
  532501: "个旧市",
  532502: "开远市",
  532503: "蒙自市",
  532504: "弥勒市",
  532523: "屏边苗族自治县",
  532524: "建水县",
  532525: "石屏县",
  532527: "泸西县",
  532528: "元阳县",
  532529: "红河县",
  532530: "金平苗族瑶族傣族自治县",
  532531: "绿春县",
  532532: "河口瑶族自治县",
  532600: "文山壮族苗族自治州",
  532601: "文山市",
  532622: "砚山县",
  532623: "西畴县",
  532624: "麻栗坡县",
  532625: "马关县",
  532626: "丘北县",
  532627: "广南县",
  532628: "富宁县",
  532800: "西双版纳傣族自治州",
  532801: "景洪市",
  532822: "勐海县",
  532823: "勐腊县",
  532900: "大理白族自治州",
  532901: "大理市",
  532922: "漾濞彝族自治县",
  532923: "祥云县",
  532924: "宾川县",
  532925: "弥渡县",
  532926: "南涧彝族自治县",
  532927: "巍山彝族回族自治县",
  532928: "永平县",
  532929: "云龙县",
  532930: "洱源县",
  532931: "剑川县",
  532932: "鹤庆县",
  533100: "德宏傣族景颇族自治州",
  533102: "瑞丽市",
  533103: "芒市",
  533122: "梁河县",
  533123: "盈江县",
  533124: "陇川县",
  533300: "怒江傈僳族自治州",
  533301: "泸水市",
  533323: "福贡县",
  533324: "贡山独龙族怒族自治县",
  533325: "兰坪白族普米族自治县",
  533400: "迪庆藏族自治州",
  533401: "香格里拉市",
  533422: "德钦县",
  533423: "维西傈僳族自治县",
  54e4: "西藏自治区",
  540100: "拉萨市",
  540101: "市辖区",
  540102: "城关区",
  540103: "堆龙德庆区",
  540121: "林周县",
  540122: "当雄县",
  540123: "尼木县",
  540124: "曲水县",
  540126: "达孜县",
  540127: "墨竹工卡县",
  540200: "日喀则市",
  540202: "桑珠孜区",
  540221: "南木林县",
  540222: "江孜县",
  540223: "定日县",
  540224: "萨迦县",
  540225: "拉孜县",
  540226: "昂仁县",
  540227: "谢通门县",
  540228: "白朗县",
  540229: "仁布县",
  540230: "康马县",
  540231: "定结县",
  540232: "仲巴县",
  540233: "亚东县",
  540234: "吉隆县",
  540235: "聂拉木县",
  540236: "萨嘎县",
  540237: "岗巴县",
  540300: "昌都市",
  540302: "卡若区",
  540321: "江达县",
  540322: "贡觉县",
  540323: "类乌齐县",
  540324: "丁青县",
  540325: "察雅县",
  540326: "八宿县",
  540327: "左贡县",
  540328: "芒康县",
  540329: "洛隆县",
  540330: "边坝县",
  540400: "林芝市",
  540402: "巴宜区",
  540421: "工布江达县",
  540422: "米林县",
  540423: "墨脱县",
  540424: "波密县",
  540425: "察隅县",
  540426: "朗县",
  540500: "山南市",
  540501: "市辖区",
  540502: "乃东区",
  540521: "扎囊县",
  540522: "贡嘎县",
  540523: "桑日县",
  540524: "琼结县",
  540525: "曲松县",
  540526: "措美县",
  540527: "洛扎县",
  540528: "加查县",
  540529: "隆子县",
  540530: "错那县",
  540531: "浪卡子县",
  542400: "那曲地区",
  542421: "那曲县",
  542422: "嘉黎县",
  542423: "比如县",
  542424: "聂荣县",
  542425: "安多县",
  542426: "申扎县",
  542427: "索县",
  542428: "班戈县",
  542429: "巴青县",
  542430: "尼玛县",
  542431: "双湖县",
  542500: "阿里地区",
  542521: "普兰县",
  542522: "札达县",
  542523: "噶尔县",
  542524: "日土县",
  542525: "革吉县",
  542526: "改则县",
  542527: "措勤县",
  61e4: "陕西省",
  610100: "西安市",
  610101: "市辖区",
  610102: "新城区",
  610103: "碑林区",
  610104: "莲湖区",
  610111: "灞桥区",
  610112: "未央区",
  610113: "雁塔区",
  610114: "阎良区",
  610115: "临潼区",
  610116: "长安区",
  610117: "高陵区",
  610122: "蓝田县",
  610124: "周至县",
  610125: "户县",
  610200: "铜川市",
  610201: "市辖区",
  610202: "王益区",
  610203: "印台区",
  610204: "耀州区",
  610222: "宜君县",
  610300: "宝鸡市",
  610301: "市辖区",
  610302: "渭滨区",
  610303: "金台区",
  610304: "陈仓区",
  610322: "凤翔县",
  610323: "岐山县",
  610324: "扶风县",
  610326: "眉县",
  610327: "陇县",
  610328: "千阳县",
  610329: "麟游县",
  610330: "凤县",
  610331: "太白县",
  610400: "咸阳市",
  610401: "市辖区",
  610402: "秦都区",
  610403: "杨陵区",
  610404: "渭城区",
  610422: "三原县",
  610423: "泾阳县",
  610424: "乾县",
  610425: "礼泉县",
  610426: "永寿县",
  610427: "彬县",
  610428: "长武县",
  610429: "旬邑县",
  610430: "淳化县",
  610431: "武功县",
  610481: "兴平市",
  610500: "渭南市",
  610501: "市辖区",
  610502: "临渭区",
  610503: "华州区",
  610522: "潼关县",
  610523: "大荔县",
  610524: "合阳县",
  610525: "澄城县",
  610526: "蒲城县",
  610527: "白水县",
  610528: "富平县",
  610581: "韩城市",
  610582: "华阴市",
  610600: "延安市",
  610601: "市辖区",
  610602: "宝塔区",
  610603: "安塞区",
  610621: "延长县",
  610622: "延川县",
  610623: "子长县",
  610625: "志丹县",
  610626: "吴起县",
  610627: "甘泉县",
  610628: "富县",
  610629: "洛川县",
  610630: "宜川县",
  610631: "黄龙县",
  610632: "黄陵县",
  610700: "汉中市",
  610701: "市辖区",
  610702: "汉台区",
  610721: "南郑县",
  610722: "城固县",
  610723: "洋县",
  610724: "西乡县",
  610725: "勉县",
  610726: "宁强县",
  610727: "略阳县",
  610728: "镇巴县",
  610729: "留坝县",
  610730: "佛坪县",
  610800: "榆林市",
  610801: "市辖区",
  610802: "榆阳区",
  610803: "横山区",
  610821: "神木县",
  610822: "府谷县",
  610824: "靖边县",
  610825: "定边县",
  610826: "绥德县",
  610827: "米脂县",
  610828: "佳县",
  610829: "吴堡县",
  610830: "清涧县",
  610831: "子洲县",
  610900: "安康市",
  610901: "市辖区",
  610902: "汉滨区",
  610921: "汉阴县",
  610922: "石泉县",
  610923: "宁陕县",
  610924: "紫阳县",
  610925: "岚皋县",
  610926: "平利县",
  610927: "镇坪县",
  610928: "旬阳县",
  610929: "白河县",
  611e3: "商洛市",
  611001: "市辖区",
  611002: "商州区",
  611021: "洛南县",
  611022: "丹凤县",
  611023: "商南县",
  611024: "山阳县",
  611025: "镇安县",
  611026: "柞水县",
  62e4: "甘肃省",
  620100: "兰州市",
  620101: "市辖区",
  620102: "城关区",
  620103: "七里河区",
  620104: "西固区",
  620105: "安宁区",
  620111: "红古区",
  620121: "永登县",
  620122: "皋兰县",
  620123: "榆中县",
  620200: "嘉峪关市",
  620201: "市辖区",
  620300: "金昌市",
  620301: "市辖区",
  620302: "金川区",
  620321: "永昌县",
  620400: "白银市",
  620401: "市辖区",
  620402: "白银区",
  620403: "平川区",
  620421: "靖远县",
  620422: "会宁县",
  620423: "景泰县",
  620500: "天水市",
  620501: "市辖区",
  620502: "秦州区",
  620503: "麦积区",
  620521: "清水县",
  620522: "秦安县",
  620523: "甘谷县",
  620524: "武山县",
  620525: "张家川回族自治县",
  620600: "武威市",
  620601: "市辖区",
  620602: "凉州区",
  620621: "民勤县",
  620622: "古浪县",
  620623: "天祝藏族自治县",
  620700: "张掖市",
  620701: "市辖区",
  620702: "甘州区",
  620721: "肃南裕固族自治县",
  620722: "民乐县",
  620723: "临泽县",
  620724: "高台县",
  620725: "山丹县",
  620800: "平凉市",
  620801: "市辖区",
  620802: "崆峒区",
  620821: "泾川县",
  620822: "灵台县",
  620823: "崇信县",
  620824: "华亭县",
  620825: "庄浪县",
  620826: "静宁县",
  620900: "酒泉市",
  620901: "市辖区",
  620902: "肃州区",
  620921: "金塔县",
  620922: "瓜州县",
  620923: "肃北蒙古族自治县",
  620924: "阿克塞哈萨克族自治县",
  620981: "玉门市",
  620982: "敦煌市",
  621e3: "庆阳市",
  621001: "市辖区",
  621002: "西峰区",
  621021: "庆城县",
  621022: "环县",
  621023: "华池县",
  621024: "合水县",
  621025: "正宁县",
  621026: "宁县",
  621027: "镇原县",
  621100: "定西市",
  621101: "市辖区",
  621102: "安定区",
  621121: "通渭县",
  621122: "陇西县",
  621123: "渭源县",
  621124: "临洮县",
  621125: "漳县",
  621126: "岷县",
  621200: "陇南市",
  621201: "市辖区",
  621202: "武都区",
  621221: "成县",
  621222: "文县",
  621223: "宕昌县",
  621224: "康县",
  621225: "西和县",
  621226: "礼县",
  621227: "徽县",
  621228: "两当县",
  622900: "临夏回族自治州",
  622901: "临夏市",
  622921: "临夏县",
  622922: "康乐县",
  622923: "永靖县",
  622924: "广河县",
  622925: "和政县",
  622926: "东乡族自治县",
  622927: "积石山保安族东乡族撒拉族自治县",
  623e3: "甘南藏族自治州",
  623001: "合作市",
  623021: "临潭县",
  623022: "卓尼县",
  623023: "舟曲县",
  623024: "迭部县",
  623025: "玛曲县",
  623026: "碌曲县",
  623027: "夏河县",
  63e4: "青海省",
  630100: "西宁市",
  630101: "市辖区",
  630102: "城东区",
  630103: "城中区",
  630104: "城西区",
  630105: "城北区",
  630121: "大通回族土族自治县",
  630122: "湟中县",
  630123: "湟源县",
  630200: "海东市",
  630202: "乐都区",
  630203: "平安区",
  630222: "民和回族土族自治县",
  630223: "互助土族自治县",
  630224: "化隆回族自治县",
  630225: "循化撒拉族自治县",
  632200: "海北藏族自治州",
  632221: "门源回族自治县",
  632222: "祁连县",
  632223: "海晏县",
  632224: "刚察县",
  632300: "黄南藏族自治州",
  632321: "同仁县",
  632322: "尖扎县",
  632323: "泽库县",
  632324: "河南蒙古族自治县",
  632500: "海南藏族自治州",
  632521: "共和县",
  632522: "同德县",
  632523: "贵德县",
  632524: "兴海县",
  632525: "贵南县",
  632600: "果洛藏族自治州",
  632621: "玛沁县",
  632622: "班玛县",
  632623: "甘德县",
  632624: "达日县",
  632625: "久治县",
  632626: "玛多县",
  632700: "玉树藏族自治州",
  632701: "玉树市",
  632722: "杂多县",
  632723: "称多县",
  632724: "治多县",
  632725: "囊谦县",
  632726: "曲麻莱县",
  632800: "海西蒙古族藏族自治州",
  632801: "格尔木市",
  632802: "德令哈市",
  632821: "乌兰县",
  632822: "都兰县",
  632823: "天峻县",
  64e4: "宁夏回族自治区",
  640100: "银川市",
  640101: "市辖区",
  640104: "兴庆区",
  640105: "西夏区",
  640106: "金凤区",
  640121: "永宁县",
  640122: "贺兰县",
  640181: "灵武市",
  640200: "石嘴山市",
  640201: "市辖区",
  640202: "大武口区",
  640205: "惠农区",
  640221: "平罗县",
  640300: "吴忠市",
  640301: "市辖区",
  640302: "利通区",
  640303: "红寺堡区",
  640323: "盐池县",
  640324: "同心县",
  640381: "青铜峡市",
  640400: "固原市",
  640401: "市辖区",
  640402: "原州区",
  640422: "西吉县",
  640423: "隆德县",
  640424: "泾源县",
  640425: "彭阳县",
  640500: "中卫市",
  640501: "市辖区",
  640502: "沙坡头区",
  640521: "中宁县",
  640522: "海原县",
  65e4: "新疆维吾尔自治区",
  650100: "乌鲁木齐市",
  650101: "市辖区",
  650102: "天山区",
  650103: "沙依巴克区",
  650104: "新市区",
  650105: "水磨沟区",
  650106: "头屯河区",
  650107: "达坂城区",
  650109: "米东区",
  650121: "乌鲁木齐县",
  650200: "克拉玛依市",
  650201: "市辖区",
  650202: "独山子区",
  650203: "克拉玛依区",
  650204: "白碱滩区",
  650205: "乌尔禾区",
  650400: "吐鲁番市",
  650402: "高昌区",
  650421: "鄯善县",
  650422: "托克逊县",
  650500: "哈密市",
  650502: "伊州区",
  650521: "巴里坤哈萨克自治县",
  650522: "伊吾县",
  652300: "昌吉回族自治州",
  652301: "昌吉市",
  652302: "阜康市",
  652323: "呼图壁县",
  652324: "玛纳斯县",
  652325: "奇台县",
  652327: "吉木萨尔县",
  652328: "木垒哈萨克自治县",
  652700: "博尔塔拉蒙古自治州",
  652701: "博乐市",
  652702: "阿拉山口市",
  652722: "精河县",
  652723: "温泉县",
  652800: "巴音郭楞蒙古自治州",
  652801: "库尔勒市",
  652822: "轮台县",
  652823: "尉犁县",
  652824: "若羌县",
  652825: "且末县",
  652826: "焉耆回族自治县",
  652827: "和静县",
  652828: "和硕县",
  652829: "博湖县",
  652900: "阿克苏地区",
  652901: "阿克苏市",
  652922: "温宿县",
  652923: "库车县",
  652924: "沙雅县",
  652925: "新和县",
  652926: "拜城县",
  652927: "乌什县",
  652928: "阿瓦提县",
  652929: "柯坪县",
  653e3: "克孜勒苏柯尔克孜自治州",
  653001: "阿图什市",
  653022: "阿克陶县",
  653023: "阿合奇县",
  653024: "乌恰县",
  653100: "喀什地区",
  653101: "喀什市",
  653121: "疏附县",
  653122: "疏勒县",
  653123: "英吉沙县",
  653124: "泽普县",
  653125: "莎车县",
  653126: "叶城县",
  653127: "麦盖提县",
  653128: "岳普湖县",
  653129: "伽师县",
  653130: "巴楚县",
  653131: "塔什库尔干塔吉克自治县",
  653200: "和田地区",
  653201: "和田市",
  653221: "和田县",
  653222: "墨玉县",
  653223: "皮山县",
  653224: "洛浦县",
  653225: "策勒县",
  653226: "于田县",
  653227: "民丰县",
  654e3: "伊犁哈萨克自治州",
  654002: "伊宁市",
  654003: "奎屯市",
  654004: "霍尔果斯市",
  654021: "伊宁县",
  654022: "察布查尔锡伯自治县",
  654023: "霍城县",
  654024: "巩留县",
  654025: "新源县",
  654026: "昭苏县",
  654027: "特克斯县",
  654028: "尼勒克县",
  654200: "塔城地区",
  654201: "塔城市",
  654202: "乌苏市",
  654221: "额敏县",
  654223: "沙湾县",
  654224: "托里县",
  654225: "裕民县",
  654226: "和布克赛尔蒙古自治县",
  654300: "阿勒泰地区",
  654301: "阿勒泰市",
  654321: "布尔津县",
  654322: "富蕴县",
  654323: "福海县",
  654324: "哈巴河县",
  654325: "青河县",
  654326: "吉木乃县",
  659e3: "自治区直辖县级行政区划",
  659001: "石河子市",
  659002: "阿拉尔市",
  659003: "图木舒克市",
  659004: "五家渠市",
  659006: "铁门关市",
  71e4: "台湾省",
  81e4: "香港特别行政区",
  82e4: "澳门特别行政区"
};
function fr(t, e, n) {
  if (!t || t.length !== e || !/^[0-9A-Z]+$/.test(t))
    throw new Error(n);
}
function P(t, e, n) {
  if (e.findIndex((r) => r == t) < 0)
    throw new Error(n);
}
function oo(t, e, n) {
  const r = Object.entries(e).find(([s]) => s == t);
  if (!r)
    throw new Error(n || `{ ${t} } 不在范围内！`);
  return r[1];
}
function ao(t, e, n) {
  const r = Object.entries(e).find(([s, i]) => i == t);
  if (!r)
    throw new Error(n || `{ ${t} } 不在范围内！`);
  return r[0];
}
function hr(t, e, n, r) {
  let s = 0;
  for (let i = 0, o = n.length; i < o; i++) {
    if (!(t[i] in r))
      throw new Error(
        `计算校验码失败: 参与校验的字符 { ${t[i]} } 不在代码字符集范围内！`
      );
    const a = r[t[i]];
    s += a * n[i];
  }
  return s = (e - s % e) % e, ao(
    s,
    r,
    `计算校验码失败: 校验码 { ${s} } 不在代码字符集范围内！`
  );
}
const co = 11, uo = [3, 7, 9, 10, 5, 8, 4, 2], lo = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  I: 18,
  J: 19,
  K: 20,
  L: 21,
  M: 22,
  N: 23,
  O: 24,
  P: 25,
  Q: 26,
  R: 27,
  S: 28,
  T: 29,
  U: 30,
  V: 31,
  W: 32,
  X: 33,
  Y: 34,
  Z: 35
};
function fo(t) {
  if (fr(
    t,
    9,
    "不符合《GB 11714-1997》：组织机构代码只能 9 位 且 大写！"
  ), hr(t, co, uo, lo) !== t[8])
    throw new Error("不符合《GB 11714-1997》：校验码检验失败");
  return !0;
}
const ho = 31, po = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28], mo = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  G: 16,
  H: 17,
  J: 18,
  K: 19,
  L: 20,
  M: 21,
  N: 22,
  P: 23,
  Q: 24,
  R: 25,
  T: 26,
  U: 27,
  W: 28,
  X: 29,
  Y: 30
};
function bl(t) {
  fr(
    t,
    18,
    "不符合《GB 32100-2015》：税号只能 18 位 且 大写！"
  );
  const e = t[0];
  P(
    e,
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "N", "Y"],
    "不符合《GB 32100-2015》： { 第1位 : 登记管理部门代码 } "
  );
  const n = t[1], r = "不符合《GB 32100-2015》： { 第2位 : 机构类别代码 } ";
  switch (e) {
    case "1":
      P(n, ["1", "2", "3", "9"], r);
      break;
    case "2":
      P(n, ["1", "9"], r);
      break;
    case "3":
      P(
        n,
        ["1", "2", "3", "4", "5", "9"],
        r
      );
      break;
    case "4":
      P(n, ["1", "9"], r);
      break;
    case "5":
      P(n, ["1", "2", "3", "9"], r);
      break;
    case "6":
      P(n, ["1", "2", "9"], r);
      break;
    case "7":
      P(n, ["1", "2", "9"], r);
      break;
    case "8":
      P(n, ["1", "9"], r);
      break;
    case "9":
      P(n, ["1", "2", "3"], r);
      break;
    case "A":
      P(n, ["1", "9"], r);
      break;
    case "N":
      P(n, ["1", "2", "3", "9"], r);
      break;
    case "Y":
      P(n, ["1"], r);
      break;
  }
  const s = t.substring(2, 8);
  oo(
    s,
    io,
    "不符合《GB 32100-2015》： { 第3位 ~ 第8位 : 登记管理机关行政区划码 } "
  );
  const i = t.substring(8, 17);
  try {
    fo(i);
  } catch {
    throw new Error(
      "不符合《GB 32100-2015》： { 第9位 ~ 第17位 : 主体标识码 (组织机构代码) }"
    );
  }
  if (hr(t, ho, po, mo) !== t[17])
    throw new Error("不符合《GB 32100-2015》：校验码检验失败");
  return !0;
}
function go() {
  const t = {};
  return t.promise = new Promise((e, n) => {
    t.resolve = e, t.reject = n;
  }), t;
}
async function Sl(t, e) {
  const n = hs(t) ? t : t(), r = async (s) => {
    s.value && s.value.then ? s.value.then(async (i) => {
      await e?.(i), s.done || await r(await n.next(i));
    }).catch(async (i) => {
      if (s.done || !n.throw)
        throw new Error(i);
      await r(await n.throw(i));
    }) : typeof s.value == "function" ? s.value(async (i, o) => {
      if (i) {
        if (s.done || !n.throw)
          throw new Error(i);
        return await r(await n.throw(i));
      }
      await e?.(o), s.done || await r(await n.next(o));
    }) : (await e?.(s.value), s.done || await r(await n.next(s.value)));
  };
  await r(await n.next());
}
function xl(t) {
  return (...e) => (
    // Thunk函数签名
    (n) => {
      let r;
      try {
        t.apply(this, [
          ...e,
          (s, i) => {
            r || (r = !0, n(s, i));
          }
        ]);
      } catch (s) {
        n(s);
      }
    }
  );
}
function Al(t) {
  return new Promise((e, n) => {
    t.call(this, (r, s) => r ? n(r) : e(s));
  });
}
function Ol(t) {
  let e = !1;
  return {
    promise: new Promise((n, r) => {
      t.then(
        (s) => e ? r({ isCanceled: !0, value: s }) : n(s),
        (s) => r({ isCanceled: e, error: s })
      );
    }),
    cancel: () => e = !0
  };
}
function vl(t, e) {
  let n;
  return Promise.race([
    t,
    new Promise((r, s) => {
      n = setTimeout(() => s(new Error("Timeout")), e);
    })
  ]).then((r) => (clearTimeout(n), r)).catch((r) => (clearTimeout(n), r));
}
function Rl(t) {
  let e = null, n = Promise.resolve();
  for (const r of t)
    n = n.then((s) => (e = s, r));
  return n.catch((r) => {
    throw r;
  }).then(() => e);
}
const yo = 2147483647;
async function _l(t) {
  return new Promise((e) => {
    setTimeout(e, Math.min(yo, t));
  });
}
function Tl(t) {
}
async function El(t, e) {
  return Promise.race([
    t(),
    new Promise(
      (n, r) => setTimeout(() => r(new Error("Timeout exceeded")), e)
    )
  ]);
}
async function kl(t = []) {
  return await t.reduce(async (e, n) => (await e, await n()), Promise.resolve(void 0));
}
let wo = 0;
function dr(t) {
  const e = go();
  let n = !1;
  return {
    name: t.name || String(++wo),
    deadline: typeof t.deadline == "number" ? Math.max(t.deadline, 0) : -1,
    run: async () => {
      if (!n) {
        n = !0;
        try {
          let r;
          const s = t.args || [];
          t.thisArg ? r = await t.fn.call(t.thisArg, ...s) : r = await t.fn(...s), e.resolve(r);
        } catch (r) {
          e.reject(r);
        }
      }
    },
    result: () => e.promise
  };
}
class bo {
  // 任务队列
  queue;
  // 是否暂停执行任务队列
  suspend = !1;
  // 执行信号
  // Incrementing adds a lock
  // Decrementing releases a lock
  semaphore = 0;
  // 并发执行数量 或 并发等待结果数量
  concurrency = 1;
  // 剩余可执行时间，毫秒
  // -1 不考虑剩余可执行时间
  // =0 自动暂停执行任务队列
  timeRemaining = -1;
  // 超时任务检查id
  timeoutId;
  // queue = createNoneRingQueue() : 不缓存数据
  // queue = createFixedRingQueue(10) : 超出缓存空间时，抛错
  // queue = createDroppingRingQueue(10) : 超出缓存空间时，忽略新数据
  // queue = createSlidingRingQueue(10) : 超出缓存空间时，删除旧数据
  // queue = createExpandingRingQueue(10) : 超出缓存空间时，扩大缓存空间
  constructor(e) {
    this.queue = e?.queue || ii(10), typeof e?.concurrency == "number" && (this.concurrency = Math.max(e?.concurrency, 1)), typeof e?.timeRemaining == "number" && this.setTimeRemaining(e.timeRemaining);
  }
  setTimeRemaining(e) {
    this.timeRemaining = Math.max(0, e);
  }
  increaseTimeRemaining(e, n = !1) {
    this.timeRemaining !== -1 ? this.setTimeRemaining(this.timeRemaining + e) : n && this.setTimeRemaining(e);
  }
  decreaseTimeRemaining(e) {
    this.timeRemaining !== -1 && this.setTimeRemaining(this.timeRemaining - e);
  }
  // 执行任务，不管执行结果
  _exec(e, n = !0) {
    const r = X();
    try {
      this.semaphore++, e.run();
    } finally {
      this.semaphore--, n && (this.decreaseTimeRemaining(X() - r), this._flush());
    }
  }
  // 执行队列
  _flush() {
    for (; !this.suspend && this.semaphore < this.concurrency && (this.timeRemaining == -1 || this.timeRemaining > 0); ) {
      const e = this.queue.dequeue();
      if (!e)
        break;
      this._exec(e);
    }
    this._timeout();
  }
  // 超时任务检查
  _timeout(e = 0, n = 0) {
    clearTimeout(this.timeoutId), this.timeoutId = setTimeout(() => {
      if (!(this.suspend || this.semaphore > 0 || !this.queue.length)) {
        for (let r = 0; r < this.queue.length(); ) {
          const s = this.queue.index(r);
          if (!s)
            break;
          s.deadline != -1 && s.deadline <= X() ? (this._exec(s, !1), this.queue.deleteIndex(r)) : r++;
        }
        this.queue.length() && (this.timeoutId = setTimeout(
          () => {
            this._timeout(e, ++n);
          },
          300 * Math.pow(2, n)
          // wait a bit longer between each retry
        ));
      }
    }, e);
  }
  // 暂停
  pause() {
    this.suspend = !0;
  }
  // 恢复
  resume() {
    this.suspend = !1, this._flush();
  }
  addTask(e) {
    this.queue.delete((n) => n.name == e.name), this.queue.enqueue(e);
  }
  // 立即触发执行
  immediately(e) {
    this._exec(e), this._flush();
  }
  // 立即顺序触发执行队列
  asap(e) {
    this.addTask(e), this._flush();
  }
  // 有空余时间再执行队列
  idleCallback(e) {
    this.setTimeRemaining(e.timeRemaining()), this._flush();
  }
  clear() {
    this.queue.clear();
  }
}
class pr extends bo {
  // 上个任务的执行结果
  lastResult;
  constructor(e) {
    super(e);
  }
  // 执行任务
  _exec(e, n = !0) {
    const r = X();
    try {
      this.semaphore++, e.run();
    } finally {
      e.result().then((s) => {
        this.lastResult = s;
      }).finally(() => {
        this.semaphore--, n && (this.decreaseTimeRemaining(X() - r), this._flush());
      });
    }
  }
}
class Cl {
  schedule;
  constructor(e) {
    this.schedule = new pr(e);
  }
  get lastResult() {
    return this.schedule.lastResult;
  }
  // promise 自己绑定this
  asap(e, ...n) {
    const r = dr({
      fn: e,
      args: n
    });
    return this.schedule.asap(r), r;
  }
  immediately(e, ...n) {
    return this.clear(), this.asap(e, ...n);
  }
  // 丢弃所有未处理的 promise
  clear() {
    this.schedule.clear();
  }
}
class Pl {
  schedule;
  closeLastDialog;
  constructor(e) {
    this.schedule = new pr(e);
  }
  // dialog 自己绑定this
  // 将 Dialog 放入队列，依次关闭后显示
  asap(e, n) {
    const r = dr({
      fn: (s) => new Promise((i) => {
        this.closeLastDialog = e({
          ...s,
          onClose: () => {
            this.closeLastDialog = void 0, s?.onClose?.(), i();
          }
        });
      }),
      args: [n]
    });
    return this.schedule.asap(r), r;
  }
  // 强制显示 Dialog
  immediately(e, n) {
    return this.clear(), this.asap(e, n);
  }
  // 强制关闭上一个 Dialog
  closeLast() {
    this.closeLastDialog && this.closeLastDialog();
  }
  // 丢弃所有未处理的 Dialog
  clear() {
    this.schedule.clear(), this.closeLast();
  }
}
function Dl(t) {
  if (typeof setImmediate < "u" && ft(setImmediate))
    setImmediate(t);
  else if (typeof MessageChannel < "u" && (ft(MessageChannel) || MessageChannel.toString() === "[object MessageChannelConstructor]")) {
    const { port1: e, port2: n } = new MessageChannel();
    n.onmessage = t, e.postMessage(null);
  } else
    typeof Promise < "u" && ft(Promise) ? Promise.resolve().then(t) : setTimeout(t, 0);
}
function Ml(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch(
    (e) => setTimeout(() => {
      throw e;
    })
  );
}
class Il {
  // postMessage
  port;
  // onmessage
  port2;
  constructor() {
    const { port1: e, port2: n } = new MessageChannel();
    this.port = e, this.port2 = n, this.port.start(), this.port2.start();
  }
  close() {
    this.port.close(), this.port2.close();
  }
  postMessage(e) {
    const n = In();
    return this.port.postMessage({ id: n, message: e }), n;
  }
  onmessage(e) {
    this.port2.addEventListener("message", e);
  }
  offmessage(e) {
    this.port2.removeEventListener("message", e);
  }
  onmessageerror(e) {
    this.port2.addEventListener("messageerror", e);
  }
  offmessageerror(e) {
    this.port2.removeEventListener("messageerror", e);
  }
}
function Ll(t = "", e) {
  const {
    OPERATION_DELIMITER: n = "/",
    KEY_DELIMITER: r = ",",
    KEY_VALUE_DELIMITER: s = ":"
  } = e || {};
  return t.split(n).filter((i) => i !== "").reduce((i, o) => {
    const [a, ...c] = o.split(r);
    if (c.length === 0) {
      const [u, l] = a.split(s);
      i.push({
        type: u,
        payload: l !== void 0 ? decodeURIComponent(l) : !0
      });
    } else {
      if (a.indexOf(s) !== -1)
        throw new Error(`"${a}" is invalid`);
      i.push(
        c.reduce(
          (u, l) => {
            const [h, m] = l.split(s);
            return u[h] = m !== void 0 ? decodeURIComponent(m) : !0, u;
          },
          {
            type: a
          }
        )
      );
    }
    return i;
  }, []);
}
function So(t) {
  const e = typeof t.immutable == "boolean" ? t.immutable : !0, n = t.initState || {};
  let r = t.reducer;
  if (t.enhancer)
    return t.enhancer(So)({ reducer: r, initState: n, immutable: e });
  const s = [], i = (u) => (s.push(u), () => {
    const l = s.indexOf(u);
    l > -1 && s.splice(l, 1);
  });
  let o = n;
  e || (o = Zi(o, {
    callback: (u) => {
      s.forEach((l) => l(u));
    }
  }));
  const a = (u) => {
    if (e) {
      const l = o;
      o = r(o, u);
      const h = jn(l, o);
      for (const m of h)
        s.forEach((d) => d(m));
    } else
      r(o, u);
  }, c = (u) => {
    r = u, a({ type: "INIT" });
  };
  return a({ type: "INIT" }), {
    getState: () => o,
    dispatch: a,
    subscribe: i,
    replaceReducer: c
  };
}
function $l(t, e = !0) {
  const n = Object.keys(t);
  return (r, s) => {
    const i = e ? { ...r } : r;
    for (let o = 0, a = n.length; o < a; o++) {
      const c = n[o];
      i[c] = t[c](i[c] || {}, s);
    }
    return i;
  };
}
function Fl(...t) {
  return (e) => (n) => {
    const r = e(n);
    let s = r.dispatch;
    const i = { getState: r.getState, dispatch: s }, o = t.map((a) => a(i));
    return s = fi(...o)(s), r.dispatch = s, r;
  };
}
const Nl = (t) => {
  let e = 0;
  return (n) => (r) => {
    ln.start(
      `--- State Change index: ${++e} action: ${String(
        r.type
      )} ---`
    ), R(`action: ${L(r)}`), R(`old-state: ${L(t.getState())}`), n(r), R(`new-state: ${L(t.getState())}`), ln.end();
  };
}, Ul = (t) => (e) => (n) => {
  try {
    e(n);
  } catch (r) {
    throw R(`Reducer错误报告: ${r}`), r;
  }
}, Bl = (t) => (e) => (n) => {
  const r = `dispatch(${String(n.type)}) execute time`;
  qe.start(r), e(n), qe.end(r);
};
class jl {
  _next;
  _error;
  _complete;
  constructor() {
  }
  subscribe(e) {
    return this._next = e.next, this._error = e.error, this._complete = e.complete, {
      unsubscribe: () => {
        this.complete();
      }
    };
  }
  next(e) {
    this._next?.(e);
  }
  error(e) {
    this._error?.(e);
  }
  complete() {
    this._complete?.();
  }
}
function mr(t = window.location.href) {
  try {
    return new URL(t);
  } catch {
    const n = "(?<protocol>https?:)", r = "(?<host>(?<hostname>[^/#?:]+)(?::(?<port>\\d+))?)", s = "(?<pathname>(?:\\/[^/#?]+)*\\/?)", i = "(?<search>(?:\\?[^#]*)?)", o = "(?<hash>(?:#.*)?)", c = new RegExp(`^${n}//${r}${s}${i}${o}$`).exec(t);
    return {
      href: t,
      protocol: c?.groups?.protocol || "",
      host: c?.groups?.host || "",
      hostname: c?.groups?.hostname || "",
      port: c?.groups?.port || "",
      pathname: c?.groups?.pathname || "",
      search: c?.groups?.search || "",
      hash: c?.groups?.hash || ""
    };
  }
}
function ql(t) {
  const e = mr(t);
  return e.protocol === "http:" || e.protocol === "https:";
}
function xo(t) {
  return !t.includes("://") || t.includes(window.location.origin);
}
function zl(t = window.location.href) {
  const e = mr(t), n = e.href.indexOf(e.hash);
  return e.hash && n >= 0 ? e.href.substring(0, n) : e.href;
}
function Ao(t, e) {
  return t.replace(/(?:\?.*)?$/, e.replace(/^[&?]/, "?"));
}
function Hl(t, e) {
  return Ao(t, gr(e));
}
function Oo(t, e) {
  return t + e.replace(/^[&?]/, t.indexOf("?") >= 0 ? "&" : "?");
}
function Vl(t, e) {
  return Oo(t, gr(e));
}
function Wl(t = window.location.href) {
  const e = {};
  let n = decodeURIComponent(t).split(/[?]/)[1];
  if (n || (n = t), n = n.replace(/^[#?&]/, ""), n = n.replace(/#\/(([^?&=]*))$/, ""), n) {
    const r = /(?:^|&)([^&=]*)=?([^&]*?)(?=&|$)/y;
    let s = r.exec(n);
    for (; s; )
      e[s[1]] = s[2], s = r.exec(n);
  }
  return e;
}
function Gl(t = window.location.href) {
  return JSON.parse(
    '{"' + decodeURI(t.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
  );
}
function gr(t) {
  return "?" + Object.entries(t).map(([e, n]) => `${encodeURIComponent(e)}=${encodeURIComponent(n)}`).join("&");
}
function Xl(t) {
  return "?" + [...t.entries()].map(
    (e) => encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1] instanceof File ? e[1].name : e[1])
  ).join("&");
}
async function vo(t, e) {
  if (xo(t))
    return t;
  const r = await (await fetch(t)).text(), s = new URL(t).href.split("/");
  s.pop();
  const i = `const _importScripts = importScripts;
const _fixImports = (url) => new URL(url, '${s.join("/") + "/"}').href;
importScripts = (...urls) => _importScripts(...urls.map(_fixImports));
`, o = "application/javascript";
  let a = `data:${o},` + encodeURIComponent(i + r);
  return (typeof e?.useBlob == "boolean" ? e?.useBlob : !0) && (a = URL.createObjectURL(
    new Blob([`importScripts("${a}")`], { type: o })
  )), a;
}
class Jl {
  worker;
  constructor() {
    if (!Ls)
      throw new Error("Your environment do not support Worker !");
  }
  async createFromURL(e, n = !1) {
    const r = await vo(e);
    return n ? (this.worker = new SharedWorker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(r, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  async createFromCode(e, n = !1) {
    const r = new Blob([e]), s = URL.createObjectURL(r);
    return n ? (this.worker = new SharedWorker(s, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker.port.start()) : this.worker = new Worker(s, {
      type: "module"
      // 声明为 ES 模块，默认是 classic
    }), this.worker;
  }
  terminate() {
    this.worker instanceof Worker && this.worker.terminate(), this.worker instanceof SharedWorker && this.worker.port.close();
  }
  // type Transferable = OffscreenCanvas | ImageBitmap | MessagePort | ReadableStream | WritableStream | TransformStream | ArrayBuffer;
  postMessage(e, n = []) {
    const r = In();
    return this.worker instanceof Worker && this.worker.postMessage({ id: r, message: e }, n), this.worker instanceof SharedWorker && this.worker.port.postMessage({ id: r, message: e }, n), r;
  }
  postCanvas(e) {
    const n = e.transferControlToOffscreen();
    this.postMessage({ canvas: n }, [n]);
  }
  postPort(e) {
    this.postMessage({ port: e }, [e]);
  }
  onmessage(e) {
    this.worker instanceof Worker && this.worker.addEventListener("message", e), this.worker instanceof SharedWorker && this.worker.port.addEventListener("message", e);
  }
  offmessage(e) {
    this.worker instanceof Worker && this.worker.removeEventListener("message", e), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("message", e);
  }
  onmessageerror(e) {
    this.worker instanceof Worker && this.worker.addEventListener("messageerror", e), this.worker instanceof SharedWorker && this.worker.port.addEventListener("messageerror", e);
  }
  offmessageerror(e) {
    this.worker instanceof Worker && this.worker.removeEventListener("messageerror", e), this.worker instanceof SharedWorker && this.worker.port.removeEventListener("messageerror", e);
  }
}
function Ro(t) {
  return t * Math.PI / 180;
}
function z(t) {
  return t * 180 / Math.PI;
}
function V(t, e = 0) {
  if (!t)
    return e;
  switch (t.unit) {
    case "turn":
      return t.v * 360;
    case "rad":
      return z(t.v);
    case "deg":
    default:
      return t.v;
  }
}
function Yl(t, e) {
  return {
    dx: Math.cos(t) * e,
    dy: Math.sin(t) * e
  };
}
function _o(t) {
  const e = [];
  return t.replace(
    /([a-z0-9]+)\s*\(?\s*((-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)*[a-z%]*\s*,?\s*)+)\)?/gi,
    (n, r, s) => {
      const i = [];
      return s.split(/\s*[,\s]+\s*/).forEach((o) => {
        o.trim() && i.push({
          v: G(o, 0),
          unit: o.match(/[a-z%]+$/)?.[0] || ""
        });
      }), e.push({
        command: r,
        values: i
      }), "";
    }
  ), e;
}
class O {
  precision = 1e-6;
  x;
  y;
  z;
  w;
  // 齐次坐标 w = 1：表示 3D 点坐标  w = 0：作为一个向量或方向使用
  constructor(e = 0, n = 0, r = 0, s = 1) {
    this.x = e, this.y = n, this.z = r, this.w = s;
  }
  clone() {
    return new O(this.x, this.y, this.z, this.w);
  }
  add(e) {
    return new O(this.x + e.x, this.y + e.y, this.z + e.z, this.w);
  }
  sub(e) {
    return new O(this.x - e.x, this.y - e.y, this.z - e.z, this.w);
  }
  multiply(e) {
    return new O(this.x * e.x, this.y * e.y, this.z * e.z, this.w);
  }
  divide(e) {
    return new O(this.x / e.x, this.y / e.y, this.z / e.z, this.w);
  }
  min(e) {
    return new O(
      Math.min(this.x, e.x),
      Math.min(this.y, e.y),
      Math.min(this.z, e.z),
      this.w
    );
  }
  max(e) {
    return new O(
      Math.max(this.x, e.x),
      Math.max(this.y, e.y),
      Math.max(this.z, e.z),
      this.w
    );
  }
  clamp(e, n) {
    return new O(
      ce(this.x, e.x, n.x),
      ce(this.y, e.y, n.y),
      ce(this.z, e.z, n.z),
      this.w
    );
  }
  floor() {
    return new O(
      Math.floor(this.x),
      Math.floor(this.y),
      Math.floor(this.z),
      this.w
    );
  }
  ceil() {
    return new O(
      Math.ceil(this.x),
      Math.ceil(this.y),
      Math.ceil(this.z),
      this.w
    );
  }
  round() {
    return new O(
      Math.round(this.x),
      Math.round(this.y),
      Math.round(this.z),
      this.w
    );
  }
  roundToZero() {
    return new O(
      Math.trunc(this.x),
      Math.trunc(this.y),
      Math.trunc(this.z),
      this.w
    );
  }
  negate() {
    return new O(
      this.x - this.x,
      this.y - this.y,
      this.z - this.z,
      this.w
    );
  }
  // Returns the scalar product of the vector with the argument
  // Both vectors must have equal dimensionality
  dot(e) {
    const n = e.toArray(), r = this.toArray();
    let s = 0, i = 3;
    do
      s += r[i - 1] * n[i - 1];
    while (--i);
    return s;
  }
  // Returns the vector product of the vector with the argument
  // Both vectors must have dimensionality 3
  cross(e) {
    const n = e.toArray(), r = this.toArray();
    return new O(
      r[1] * n[2] - r[2] * n[1],
      r[2] * n[0] - r[0] * n[2],
      r[0] * n[1] - r[1] * n[0]
    );
  }
  length() {
    return Math.sqrt(this.dot(this));
  }
  distance(e) {
    return this.sub(e).length();
  }
  normalize() {
    const e = this.length();
    return e == 0 ? new O() : new O(this.x / e, this.y / e, this.z / e, this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  // Returns the angle between the vector and the argument (also a vector)
  degreeFrom(e) {
    const n = e.toArray();
    let r = 0, s = 0, i = 0;
    if (this.toArray().forEach((a, c) => {
      r += a * n[c], s += a * a, i += n[c] * n[c];
    }), s = Math.sqrt(s), i = Math.sqrt(i), s * i === 0)
      return;
    let o = r / (s * i);
    return o < -1 && (o = -1), o > 1 && (o = 1), z(Math.acos(o));
  }
  // Returns true iff the vector is parallel to the argument
  isParallelTo(e) {
    const n = this.degreeFrom(e);
    return n === void 0 ? void 0 : n <= this.precision;
  }
  // 2D: 与 x 轴正方向之间的弧度值
  radian() {
    let e = Math.atan2(this.y, this.x);
    return e < 0 && (e += Math.PI * 2), e;
  }
  // 2D: 与 x 轴正方向之间的角度值
  degree() {
    return z(this.radian());
  }
  // 2D: 返回滑动方向
  getDirection(e = 10) {
    if (Math.abs(this.x) < e && Math.abs(this.y) < e)
      return "no";
    const n = this.degree();
    return n >= -135 && n <= -45 ? "up" : n > 45 && n < 135 ? "down" : n >= 135 && n <= 180 || n >= -180 && n < -135 ? "left" : "right";
  }
  toArray() {
    return [this.x, this.y, this.z, this.w];
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class q {
  _elements;
  _margin;
  // protected isCoordinateChanged = false;
  // private _is2D: boolean;
  // 2D矩阵属性
  get a() {
    return this._elements[0];
  }
  set a(e) {
    this._elements[0] = e;
  }
  get b() {
    return this._elements[1];
  }
  set b(e) {
    this._elements[1] = e;
  }
  get c() {
    return this._elements[4];
  }
  set c(e) {
    this._elements[4] = e;
  }
  get d() {
    return this._elements[5];
  }
  set d(e) {
    this._elements[5] = e;
  }
  get e() {
    return this._elements[12];
  }
  set e(e) {
    this._elements[12] = e;
  }
  get f() {
    return this._elements[13];
  }
  set f(e) {
    this._elements[13] = e;
  }
  // 3D矩阵属性
  get m11() {
    return this._elements[0];
  }
  set m11(e) {
    this._elements[0] = e;
  }
  get m12() {
    return this._elements[1];
  }
  set m12(e) {
    this._elements[1] = e;
  }
  get m13() {
    return this._elements[2];
  }
  set m13(e) {
    this._elements[2] = e;
  }
  get m14() {
    return this._elements[3];
  }
  set m14(e) {
    this._elements[3] = e;
  }
  get m21() {
    return this._elements[4];
  }
  set m21(e) {
    this._elements[4] = e;
  }
  get m22() {
    return this._elements[5];
  }
  set m22(e) {
    this._elements[5] = e;
  }
  get m23() {
    return this._elements[6];
  }
  set m23(e) {
    this._elements[6] = e;
  }
  get m24() {
    return this._elements[7];
  }
  set m24(e) {
    this._elements[7] = e;
  }
  get m31() {
    return this._elements[8];
  }
  set m31(e) {
    this._elements[8] = e;
  }
  get m32() {
    return this._elements[9];
  }
  set m32(e) {
    this._elements[9] = e;
  }
  get m33() {
    return this._elements[10];
  }
  set m33(e) {
    this._elements[10] = e;
  }
  get m34() {
    return this._elements[11];
  }
  set m34(e) {
    this._elements[11] = e;
  }
  get m41() {
    return this._elements[12];
  }
  set m41(e) {
    this._elements[12] = e;
  }
  get m42() {
    return this._elements[13];
  }
  set m42(e) {
    this._elements[13] = e;
  }
  get m43() {
    return this._elements[14];
  }
  set m43(e) {
    this._elements[14] = e;
  }
  get m44() {
    return this._elements[15];
  }
  set m44(e) {
    this._elements[15] = e;
  }
  get elements() {
    return Array.from(this._elements);
  }
  constructor(e, n) {
    this._margin = bs(n), this._elements = new Float64Array(16), this.identity(), e && (typeof e == "string" ? this._parseTransformString(e) : Array.isArray(e) ? this._fromArray(e) : e instanceof q && this._elements.set(e._elements));
  }
  identity() {
    this._elements.fill(0), this.m11 = 1, this.m22 = 1, this.m33 = 1, this.m44 = 1;
  }
  get isIdentity() {
    return this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m41, 0) && this._margin(this.m42, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  get isCoordinateChanged() {
    return !(this._margin(this.m11, 1) && this._margin(this.m12, 0) && this._margin(this.m13, 0) && this._margin(this.m14, 0) && this._margin(this.m21, 0) && this._margin(this.m22, 1) && this._margin(this.m23, 0) && this._margin(this.m24, 0) && this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && // this._margin(this.m41, 0) &&
    // this._margin(this.m42, 0) &&
    // this._margin(this.m43, 0) &&
    this._margin(this.m44, 1));
  }
  get is2D() {
    return this._margin(this.m31, 0) && this._margin(this.m32, 0) && this._margin(this.m33, 1) && this._margin(this.m34, 0) && this._margin(this.m43, 0) && this._margin(this.m44, 1);
  }
  _fromArray(e) {
    if (e.length === 6)
      this._elements.set([
        e[0],
        e[1],
        0,
        0,
        e[2],
        e[3],
        0,
        0,
        0,
        0,
        1,
        0,
        e[4],
        e[5],
        0,
        1
      ]);
    else if (e.length === 16)
      this._elements.set(e);
    else
      throw new TypeError(
        "Invalid matrix length (must be 6 for 2D or 16 for 3D)"
      );
  }
  // 矩阵不满足交换律，所以顺序很重要
  _parseTransformString(e) {
    return _o(e).forEach(({ command: n, values: r }) => {
      switch (n) {
        case "m":
        case "matrix":
        case "matrix3d":
          this._fromArray(r.map((s) => s.v));
          break;
        case "t":
        case "translate":
        case "translate3d":
          this.translateSelf(
            r[0]?.v || 0,
            r[1]?.v || 0,
            r[2]?.v || 0
          );
          break;
        case "translateX":
          this.translateSelf(r[0]?.v || 0, 0, 0);
          break;
        case "translateY":
          this.translateSelf(0, r[0]?.v || 0, 0);
          break;
        case "translateZ":
          this.translateSelf(0, 0, r[0]?.v || 0);
          break;
        case "r":
        case "rotate":
        case "rotateZ":
          this.rotateSelf(V(r[0], 0), 0, 0, 1);
          break;
        case "rotateX":
          this.rotateSelf(V(r[0], 0), 1, 0, 0);
          break;
        case "rotateY":
          this.rotateSelf(V(r[0], 0), 0, 1, 0);
          break;
        case "rotate3d":
          this.rotateSelf(
            V(r[3], 0),
            V(r[0], 0),
            V(r[1], 0),
            V(r[2], 0)
          );
          break;
        case "s":
        case "scale":
        case "scale3d":
          this.scaleSelf(
            r[0]?.v || 1,
            r[1]?.v || r[0]?.v || 1,
            r[2]?.v || 1
          );
          break;
        case "scaleX":
          this.scaleSelf(r[0]?.v || 1, 1, 1);
          break;
        case "scaleY":
          this.scaleSelf(1, r[0]?.v || 1, 1);
          break;
        case "scaleZ":
          this.scaleSelf(1, 1, r[0]?.v || 1);
          break;
        case "skewX":
          this.skewXSelf(V(r[0], 0));
          break;
        case "skewY":
          this.skewYSelf(V(r[0], 0));
          break;
        case "none":
        default:
          oi(`Unsupported transform function: ${n}`);
      }
    }), this;
  }
  // other * this  =>  this first, then other
  multiply(e) {
    return this.clone().multiplySelf(e);
  }
  // other * this  =>  this first, then other
  multiplySelf(e) {
    const n = this.elements, r = e.elements, s = new Float64Array(16);
    for (let i = 0; i < 4; i++)
      for (let o = 0; o < 4; o++)
        s[i * 4 + o] = n[i * 4 + 0] * r[0 * 4 + o] + n[i * 4 + 1] * r[1 * 4 + o] + n[i * 4 + 2] * r[2 * 4 + o] + n[i * 4 + 3] * r[3 * 4 + o];
    return this._elements.set(s), this;
  }
  translate(e, n = 0, r = 0) {
    return this.clone().translateSelf(e, n, r);
  }
  translateSelf(e, n = 0, r = 0) {
    const s = new q();
    if (this.isCoordinateChanged) {
      const i = this.transformPoint(new O(e, n, r));
      s.m41 = i.x, s.m42 = i.y, s.m43 = i.z;
    } else
      s.m41 = e, s.m42 = n, s.m43 = r;
    return this.multiplySelf(s);
  }
  rotate(e, n = 0, r = 0, s = 1) {
    return this.clone().rotateSelf(e, n, r, s);
  }
  // x, y, z 代表旋转轴的方向向量
  // 对于多个旋转，通常是先绕 Z 轴旋转，然后绕 Y 轴，再绕 X 轴
  rotateSelf(e, n = 0, r = 0, s = 1) {
    if (this.isCoordinateChanged) {
      const u = this.transformPoint(new O(n, r, s));
      n = u.x, r = u.y, s = u.z;
    }
    const i = e * Math.PI / 180, o = Math.cos(i), a = Math.sin(i), c = new q();
    if (n === 0 && r === 0 && s === 1)
      c.m11 = o, c.m12 = a, c.m21 = -a, c.m22 = o;
    else if (n === 1 && r === 0 && s === 0)
      c.m22 = o, c.m23 = a, c.m32 = -a, c.m33 = o;
    else if (n === 0 && r === 1 && s === 0)
      c.m11 = o, c.m13 = -a, c.m31 = a, c.m33 = o;
    else {
      const u = Math.sqrt(n * n + r * r + s * s) || 1;
      if (u == 0)
        return this;
      const l = n / u, h = r / u, m = s / u, d = 1 - o;
      c.m11 = o + l * l * d, c.m12 = l * h * d + m * a, c.m13 = l * m * d - h * a, c.m21 = h * l * d - m * a, c.m22 = o + h * h * d, c.m23 = h * m * d + l * a, c.m31 = m * l * d + h * a, c.m32 = m * h * d - l * a, c.m33 = o + m * m * d;
    }
    return this.multiplySelf(c);
  }
  scale(e, n = e, r = 1) {
    return this.clone().scaleSelf(e, n, r);
  }
  scaleSelf(e, n = e, r = 1) {
    const s = new q();
    return s.m11 = e, s.m22 = n, s.m33 = r, this.multiplySelf(s);
  }
  skewX(e) {
    return this.clone().skewXSelf(e);
  }
  skewXSelf(e) {
    const n = e * Math.PI / 180, r = new q();
    return r.m21 = Math.tan(n), this.multiplySelf(r);
  }
  skewY(e) {
    return this.clone().skewYSelf(e);
  }
  skewYSelf(e) {
    const n = e * Math.PI / 180, r = new q();
    return r.m12 = Math.tan(n), this.multiplySelf(r);
  }
  // skewZ(degree: number): DomMatrix {
  //   return this.clone().skewZSelf(degree);
  // }
  // skewZSelf(degree: number): this {
  //   const rad = (degree * Math.PI) / 180;
  //   const skew = new DomMatrix();
  //   skew.m13 = Math.tan(rad); // c参数
  //   // if (skew.m13 !== 0) {
  //   //   this.isCoordinateChanged = true;
  //   // }
  //   return this.multiplySelf(skew);
  // }
  to2D() {
    return new q([
      this.a,
      this.b,
      this.c,
      this.d,
      this.e,
      this.f
    ]);
  }
  // 正射投影
  // | 2/(r-l)   0         0      -(r+l)/(r-l) |
  // | 0         2/(t-b)   0      -(t+b)/(t-b) |
  // | 0         0         -2/(f-n)  -(f+n)/(f-n) |
  // | 0         0         0       1            |
  // 透视投影
  // | 2n/(r-l)  0        (r+l)/(r-l)   0       |
  // | 0        2n/(t-b)  (t+b)/(t-b)   0       |
  // | 0        0        -(f+n)/(f-n)   -2fn/(f-n) |
  // | 0        0        -1             0       |
  inverse() {
    return this.clone().invertSelf();
  }
  /**
   * Inverts the matrix
   * -> based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
   * -> based on https://github.com/mrdoob/three.js/blob/master/src/math/Matrix4.js
   */
  invertSelf() {
    if (this.is2D) {
      const e = this.a * this.d - this.b * this.c;
      if (e === 0)
        throw new Error("Matrix is not invertible.");
      const n = 1 / e;
      return this.multiplySelf(
        new q([
          this.d * n,
          -this.b * n,
          -this.c * n,
          this.a * n,
          (this.c * this.f - this.d * this.e) * n,
          (this.b * this.e - this.a * this.f) * n
        ])
      );
    } else {
      const e = Array.from(this.elements), n = e[0], r = e[1], s = e[2], i = e[3], o = e[4], a = e[5], c = e[6], u = e[7], l = e[8], h = e[9], m = e[10], d = e[11], p = e[12], g = e[13], y = e[14], w = e[15], x = h * y * u - g * m * u + g * c * d - a * y * d - h * c * w + a * m * w, A = p * m * u - l * y * u - p * c * d + o * y * d + l * c * w - o * m * w, I = l * g * u - p * h * u + p * a * d - o * g * d - l * a * w + o * h * w, T = p * h * c - l * g * c - p * a * m + o * g * m + l * a * y - o * h * y, F = n * x + r * A + s * I + i * T;
      if (F === 0)
        throw new Error("Matrix is not invertible.");
      const S = 1 / F;
      return e[0] = x * S, e[1] = (g * m * i - h * y * i - g * s * d + r * y * d + h * s * w - r * m * w) * S, e[2] = (a * y * i - g * c * i + g * s * u - r * y * u - a * s * w + r * c * w) * S, e[3] = (h * c * i - a * m * i - h * s * u + r * m * u + a * s * d - r * c * d) * S, e[4] = A * S, e[5] = (l * y * i - p * m * i + p * s * d - n * y * d - l * s * w + n * m * w) * S, e[6] = (p * c * i - o * y * i - p * s * u + n * y * u + o * s * w - n * c * w) * S, e[7] = (o * m * i - l * c * i + l * s * u - n * m * u - o * s * d + n * c * d) * S, e[8] = I * S, e[9] = (p * h * i - l * g * i - p * r * d + n * g * d + l * r * w - n * h * w) * S, e[10] = (o * g * i - p * a * i + p * r * u - n * g * u - o * r * w + n * a * w) * S, e[11] = (l * a * i - o * h * i - l * r * u + n * h * u + o * r * d - n * a * d) * S, e[12] = T * S, e[13] = (l * g * s - p * h * s + p * r * m - n * g * m - l * r * y + n * h * y) * S, e[14] = (p * a * s - o * g * s - p * r * c + n * g * c + o * r * y - n * a * y) * S, e[15] = (o * h * s - l * a * s + l * r * c - n * h * c - o * r * m + n * a * m) * S, this._elements.set(e), this;
    }
  }
  transformPoint(e) {
    const { x: n = 0, y: r = 0, z: s = 0, w: i = 1 } = e, o = new O(
      this.m11 * n + this.m21 * r + this.m31 * s + this.m41 * i,
      this.m12 * n + this.m22 * r + this.m32 * s + this.m42 * i,
      this.m13 * n + this.m23 * r + this.m33 * s + this.m43 * i,
      this.m14 * n + this.m24 * r + this.m34 * s + this.m44 * i
    );
    return o.w !== 1 && (o.x /= o.w, o.y /= o.w, o.z /= o.w), o;
  }
  toString(e = 6) {
    return this.is2D ? `matrix(${[
      K(this.a, e),
      K(this.b, e),
      K(this.c, e),
      K(this.d, e),
      K(this.e, e),
      K(this.f, e)
    ].join(", ")})` : `matrix3d(${Array.from(this.elements).map((n) => K(n, e)).join(", ")})`;
  }
  toArray() {
    return this.is2D ? [this.a, this.b, this.c, this.d, this.e, this.f] : [
      this.m11,
      this.m12,
      this.m13,
      this.m14,
      this.m21,
      this.m22,
      this.m23,
      this.m24,
      this.m31,
      this.m32,
      this.m33,
      this.m34,
      this.m41,
      this.m42,
      this.m43,
      this.m44
    ];
  }
  clone() {
    return new q(this);
  }
  split() {
    const e = Math.sqrt(
      this.m11 * this.m11 + this.m12 * this.m12 + this.m13 * this.m13
    ), n = Math.sqrt(
      this.m21 * this.m21 + this.m22 * this.m22 + this.m23 * this.m23
    ), r = Math.sqrt(
      this.m31 * this.m31 + this.m32 * this.m32 + this.m33 * this.m33
    ), s = z(ce(Math.asin(-this.m13), -1, 1));
    let i = z(Math.atan2(this.m23, this.m33));
    Math.cos(Ro(s)) === 0 && (i = z(Math.atan2(-this.m31, this.m22)));
    let o = z(Math.atan2(this.m12, this.m11));
    return this.m11 < 0 && this.m22 >= 0 && (o += 180), {
      x: this.m41,
      y: this.m42,
      z: this.m43,
      scalarX: e,
      scalarY: n,
      scalarZ: r,
      degreeX: i,
      degreeY: s,
      degreeZ: o,
      skewX: z(this.m14),
      skewY: z(this.m24),
      skewZ: z(this.m34),
      skewW: this.m44,
      perspective: this.m34 ? -(1 / this.m34) : 0
    };
  }
  // 行列式
  determinant() {
    if (this.is2D)
      return this.a * this.d - this.b * this.c;
    const e = this.elements, n = e[0], r = e[4], s = e[8], i = e[12], o = e[1], a = e[5], c = e[9], u = e[13], l = e[2], h = e[6], m = e[10], d = e[14], p = e[3], g = e[7], y = e[11], w = e[15];
    return p * (+i * c * h - s * u * h - i * a * m + r * u * m + s * a * d - r * c * d) + g * (+n * c * d - n * u * m + i * o * m - s * o * d + s * u * l - i * c * l) + y * (+n * u * h - n * a * d - i * o * h + r * o * d + i * a * l - r * u * l) + w * (-s * a * l - n * c * h + n * a * m + s * o * h - r * o * m + r * c * l);
  }
}
function yr(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: To } = Object.prototype, { getPrototypeOf: Yt } = Object, st = ((t) => (e) => {
  const n = To.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), B = (t) => (t = t.toLowerCase(), (e) => st(e) === t), it = (t) => (e) => typeof e === t, { isArray: he } = Array, Se = it("undefined");
function Eo(t) {
  return t !== null && !Se(t) && t.constructor !== null && !Se(t.constructor) && M(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const wr = B("ArrayBuffer");
function ko(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && wr(t.buffer), e;
}
const Co = it("string"), M = it("function"), br = it("number"), ot = (t) => t !== null && typeof t == "object", Po = (t) => t === !0 || t === !1, Le = (t) => {
  if (st(t) !== "object")
    return !1;
  const e = Yt(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Do = B("Date"), Mo = B("File"), Io = B("Blob"), Lo = B("FileList"), $o = (t) => ot(t) && M(t.pipe), Fo = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || M(t.append) && ((e = st(t)) === "formdata" || // detect form-data instance
  e === "object" && M(t.toString) && t.toString() === "[object FormData]"));
}, No = B("URLSearchParams"), [Uo, Bo, jo, qo] = ["ReadableStream", "Request", "Response", "Headers"].map(B), zo = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function _e(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let r, s;
  if (typeof t != "object" && (t = [t]), he(t))
    for (r = 0, s = t.length; r < s; r++)
      e.call(null, t[r], r, t);
  else {
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++)
      a = i[r], e.call(null, t[a], a, t);
  }
}
function Sr(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], e === s.toLowerCase())
      return s;
  return null;
}
const ne = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), xr = (t) => !Se(t) && t !== ne;
function Tt() {
  const { caseless: t } = xr(this) && this || {}, e = {}, n = (r, s) => {
    const i = t && Sr(e, s) || s;
    Le(e[i]) && Le(r) ? e[i] = Tt(e[i], r) : Le(r) ? e[i] = Tt({}, r) : he(r) ? e[i] = r.slice() : e[i] = r;
  };
  for (let r = 0, s = arguments.length; r < s; r++)
    arguments[r] && _e(arguments[r], n);
  return e;
}
const Ho = (t, e, n, { allOwnKeys: r } = {}) => (_e(e, (s, i) => {
  n && M(s) ? t[i] = yr(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), Vo = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Wo = (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, Go = (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, t, e)) && !a[o] && (e[o] = t[o], a[o] = !0);
    t = n !== !1 && Yt(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, Xo = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, Jo = (t) => {
  if (!t)
    return null;
  if (he(t))
    return t;
  let e = t.length;
  if (!br(e))
    return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, Yo = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Yt(Uint8Array)), Zo = (t, e) => {
  const r = (t && t[Symbol.iterator]).call(t);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, Ko = (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; )
    r.push(n);
  return r;
}, Qo = B("HTMLFormElement"), e0 = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), xn = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), t0 = B("RegExp"), Ar = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  _e(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, n0 = (t) => {
  Ar(t, (e, n) => {
    if (M(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = t[n];
    if (M(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, r0 = (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return he(t) ? r(t) : r(String(t).split(e)), n;
}, s0 = () => {
}, i0 = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function o0(t) {
  return !!(t && M(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const a0 = (t) => {
  const e = new Array(10), n = (r, s) => {
    if (ot(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = he(r) ? [] : {};
        return _e(r, (o, a) => {
          const c = n(o, s + 1);
          !Se(c) && (i[a] = c);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, c0 = B("AsyncFunction"), u0 = (t) => t && (ot(t) || M(t)) && M(t.then) && M(t.catch), Or = ((t, e) => t ? setImmediate : e ? ((n, r) => (ne.addEventListener("message", ({ source: s, data: i }) => {
  s === ne && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), ne.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  M(ne.postMessage)
), l0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(ne) : typeof process < "u" && process.nextTick || Or, f = {
  isArray: he,
  isArrayBuffer: wr,
  isBuffer: Eo,
  isFormData: Fo,
  isArrayBufferView: ko,
  isString: Co,
  isNumber: br,
  isBoolean: Po,
  isObject: ot,
  isPlainObject: Le,
  isReadableStream: Uo,
  isRequest: Bo,
  isResponse: jo,
  isHeaders: qo,
  isUndefined: Se,
  isDate: Do,
  isFile: Mo,
  isBlob: Io,
  isRegExp: t0,
  isFunction: M,
  isStream: $o,
  isURLSearchParams: No,
  isTypedArray: Yo,
  isFileList: Lo,
  forEach: _e,
  merge: Tt,
  extend: Ho,
  trim: zo,
  stripBOM: Vo,
  inherits: Wo,
  toFlatObject: Go,
  kindOf: st,
  kindOfTest: B,
  endsWith: Xo,
  toArray: Jo,
  forEachEntry: Zo,
  matchAll: Ko,
  isHTMLForm: Qo,
  hasOwnProperty: xn,
  hasOwnProp: xn,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ar,
  freezeMethods: n0,
  toObjectSet: r0,
  toCamelCase: e0,
  noop: s0,
  toFiniteNumber: i0,
  findKey: Sr,
  global: ne,
  isContextDefined: xr,
  isSpecCompliantForm: o0,
  toJSONObject: a0,
  isAsyncFn: c0,
  isThenable: u0,
  setImmediate: Or,
  asap: l0
};
function b(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
f.inherits(b, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const vr = b.prototype, Rr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Rr[t] = { value: t };
});
Object.defineProperties(b, Rr);
Object.defineProperty(vr, "isAxiosError", { value: !0 });
b.from = (t, e, n, r, s, i) => {
  const o = Object.create(vr);
  return f.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (a) => a !== "isAxiosError"), b.call(o, t.message, e, n, r, s), o.cause = t, o.name = t.name, i && Object.assign(o, i), o;
};
const f0 = null;
function Et(t) {
  return f.isPlainObject(t) || f.isArray(t);
}
function _r(t) {
  return f.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function An(t, e, n) {
  return t ? t.concat(e).map(function(s, i) {
    return s = _r(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : e;
}
function h0(t) {
  return f.isArray(t) && !t.some(Et);
}
const d0 = f.toFlatObject(f, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function at(t, e, n) {
  if (!f.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = f.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(g, y) {
    return !f.isUndefined(y[g]);
  });
  const r = n.metaTokens, s = n.visitor || l, i = n.dots, o = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(e);
  if (!f.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(p) {
    if (p === null)
      return "";
    if (f.isDate(p))
      return p.toISOString();
    if (!c && f.isBlob(p))
      throw new b("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(p) || f.isTypedArray(p) ? c && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function l(p, g, y) {
    let w = p;
    if (p && !y && typeof p == "object") {
      if (f.endsWith(g, "{}"))
        g = r ? g : g.slice(0, -2), p = JSON.stringify(p);
      else if (f.isArray(p) && h0(p) || (f.isFileList(p) || f.endsWith(g, "[]")) && (w = f.toArray(p)))
        return g = _r(g), w.forEach(function(A, I) {
          !(f.isUndefined(A) || A === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? An([g], I, i) : o === null ? g : g + "[]",
            u(A)
          );
        }), !1;
    }
    return Et(p) ? !0 : (e.append(An(y, g, i), u(p)), !1);
  }
  const h = [], m = Object.assign(d0, {
    defaultVisitor: l,
    convertValue: u,
    isVisitable: Et
  });
  function d(p, g) {
    if (!f.isUndefined(p)) {
      if (h.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + g.join("."));
      h.push(p), f.forEach(p, function(w, x) {
        (!(f.isUndefined(w) || w === null) && s.call(
          e,
          w,
          f.isString(x) ? x.trim() : x,
          g,
          m
        )) === !0 && d(w, g ? g.concat(x) : [x]);
      }), h.pop();
    }
  }
  if (!f.isObject(t))
    throw new TypeError("data must be an object");
  return d(t), e;
}
function On(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function Zt(t, e) {
  this._pairs = [], t && at(t, this, e);
}
const Tr = Zt.prototype;
Tr.append = function(e, n) {
  this._pairs.push([e, n]);
};
Tr.toString = function(e) {
  const n = e ? function(r) {
    return e.call(this, r, On);
  } : On;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function p0(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Er(t, e, n) {
  if (!e)
    return t;
  const r = n && n.encode || p0;
  f.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(e, n) : i = f.isURLSearchParams(e) ? e.toString() : new Zt(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class m0 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    f.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const vn = m0, kr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, g0 = typeof URLSearchParams < "u" ? URLSearchParams : Zt, y0 = typeof FormData < "u" ? FormData : null, w0 = typeof Blob < "u" ? Blob : null, b0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: g0,
    FormData: y0,
    Blob: w0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Kt = typeof window < "u" && typeof document < "u", kt = typeof navigator == "object" && navigator || void 0, S0 = Kt && (!kt || ["ReactNative", "NativeScript", "NS"].indexOf(kt.product) < 0), x0 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), A0 = Kt && window.location.href || "http://localhost", O0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Kt,
  hasStandardBrowserEnv: S0,
  hasStandardBrowserWebWorkerEnv: x0,
  navigator: kt,
  origin: A0
}, Symbol.toStringTag, { value: "Module" })), k = {
  ...O0,
  ...b0
};
function v0(t, e) {
  return at(t, new k.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, s, i) {
      return k.isNode && f.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function R0(t) {
  return f.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function _0(t) {
  const e = {}, n = Object.keys(t);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], e[i] = t[i];
  return e;
}
function Cr(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const a = Number.isFinite(+o), c = i >= n.length;
    return o = !o && f.isArray(s) ? s.length : o, c ? (f.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : ((!s[o] || !f.isObject(s[o])) && (s[o] = []), e(n, r, s[o], i) && f.isArray(s[o]) && (s[o] = _0(s[o])), !a);
  }
  if (f.isFormData(t) && f.isFunction(t.entries)) {
    const n = {};
    return f.forEachEntry(t, (r, s) => {
      e(R0(r), s, n, 0);
    }), n;
  }
  return null;
}
function T0(t, e, n) {
  if (f.isString(t))
    try {
      return (e || JSON.parse)(t), f.trim(t);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(t);
}
const Qt = {
  transitional: kr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = f.isObject(e);
    if (i && f.isHTMLForm(e) && (e = new FormData(e)), f.isFormData(e))
      return s ? JSON.stringify(Cr(e)) : e;
    if (f.isArrayBuffer(e) || f.isBuffer(e) || f.isStream(e) || f.isFile(e) || f.isBlob(e) || f.isReadableStream(e))
      return e;
    if (f.isArrayBufferView(e))
      return e.buffer;
    if (f.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let a;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return v0(e, this.formSerializer).toString();
      if ((a = f.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return at(
          a ? { "files[]": e } : e,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), T0(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || Qt.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (f.isResponse(e) || f.isReadableStream(e))
      return e;
    if (e && f.isString(e) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(e);
      } catch (a) {
        if (o)
          throw a.name === "SyntaxError" ? b.from(a, b.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: k.classes.FormData,
    Blob: k.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Qt.headers[t] = {};
});
const en = Qt, E0 = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), k0 = (t) => {
  const e = {};
  let n, r, s;
  return t && t.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || e[n] && E0[n]) && (n === "set-cookie" ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ", " + r : r);
  }), e;
}, Rn = Symbol("internals");
function me(t) {
  return t && String(t).trim().toLowerCase();
}
function $e(t) {
  return t === !1 || t == null ? t : f.isArray(t) ? t.map($e) : String(t);
}
function C0(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(t); )
    e[r[1]] = r[2];
  return e;
}
const P0 = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function pt(t, e, n, r, s) {
  if (f.isFunction(r))
    return r.call(this, e, n);
  if (s && (e = n), !!f.isString(e)) {
    if (f.isString(r))
      return e.indexOf(r) !== -1;
    if (f.isRegExp(r))
      return r.test(e);
  }
}
function D0(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, r) => n.toUpperCase() + r);
}
function M0(t, e) {
  const n = f.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(t, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, e, s, i, o);
      },
      configurable: !0
    });
  });
}
class ct {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, c, u) {
      const l = me(c);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const h = f.findKey(s, l);
      (!h || s[h] === void 0 || u === !0 || u === void 0 && s[h] !== !1) && (s[h || c] = $e(a));
    }
    const o = (a, c) => f.forEach(a, (u, l) => i(u, l, c));
    if (f.isPlainObject(e) || e instanceof this.constructor)
      o(e, n);
    else if (f.isString(e) && (e = e.trim()) && !P0(e))
      o(k0(e), n);
    else if (f.isHeaders(e))
      for (const [a, c] of e.entries())
        i(c, a, r);
    else
      e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = me(e), e) {
      const r = f.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return C0(s);
        if (f.isFunction(n))
          return n.call(this, s, r);
        if (f.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = me(e), e) {
      const r = f.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!n || pt(this, this[r], r, n)));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = me(o), o) {
        const a = f.findKey(r, o);
        a && (!n || pt(r, r[a], a, n)) && (delete r[a], s = !0);
      }
    }
    return f.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!e || pt(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return f.forEach(this, (s, i) => {
      const o = f.findKey(r, i);
      if (o) {
        n[o] = $e(s), delete n[i];
        return;
      }
      const a = e ? D0(i) : String(i).trim();
      a !== i && delete n[i], n[a] = $e(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && f.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const r = (this[Rn] = this[Rn] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const a = me(o);
      r[a] || (M0(s, o), r[a] = !0);
    }
    return f.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
ct.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
f.reduceDescriptors(ct.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(r) {
      this[n] = r;
    }
  };
});
f.freezeMethods(ct);
const U = ct;
function mt(t, e) {
  const n = this || en, r = e || n, s = U.from(r.headers);
  let i = r.data;
  return f.forEach(t, function(a) {
    i = a.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Pr(t) {
  return !!(t && t.__CANCEL__);
}
function de(t, e, n) {
  b.call(this, t ?? "canceled", b.ERR_CANCELED, e, n), this.name = "CanceledError";
}
f.inherits(de, b, {
  __CANCEL__: !0
});
function Dr(t, e, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? t(n) : e(new b(
    "Request failed with status code " + n.status,
    [b.ERR_BAD_REQUEST, b.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function I0(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function L0(t, e) {
  t = t || 10;
  const n = new Array(t), r = new Array(t);
  let s = 0, i = 0, o;
  return e = e !== void 0 ? e : 1e3, function(c) {
    const u = Date.now(), l = r[i];
    o || (o = u), n[s] = c, r[s] = u;
    let h = i, m = 0;
    for (; h !== s; )
      m += n[h++], h = h % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), u - o < e)
      return;
    const d = l && u - l;
    return d ? Math.round(m * 1e3 / d) : void 0;
  };
}
function $0(t, e) {
  let n = 0, r = 1e3 / e, s, i;
  const o = (u, l = Date.now()) => {
    n = l, s = null, i && (clearTimeout(i), i = null), t.apply(null, u);
  };
  return [(...u) => {
    const l = Date.now(), h = l - n;
    h >= r ? o(u, l) : (s = u, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - h)));
  }, () => s && o(s)];
}
const Ye = (t, e, n = 3) => {
  let r = 0;
  const s = L0(50, 250);
  return $0((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, c = o - r, u = s(c), l = o <= a;
    r = o;
    const h = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && a && l ? (a - o) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [e ? "download" : "upload"]: !0
    };
    t(h);
  }, n);
}, _n = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: r
  }), e[1]];
}, Tn = (t) => (...e) => f.asap(() => t(...e)), F0 = k.hasStandardBrowserEnv ? ((t, e) => (n) => (n = new URL(n, k.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(k.origin),
  k.navigator && /(msie|trident)/i.test(k.navigator.userAgent)
) : () => !0, N0 = k.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, r, s, i) {
      const o = [t + "=" + encodeURIComponent(e)];
      f.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), f.isString(r) && o.push("path=" + r), f.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function U0(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function B0(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Mr(t, e, n) {
  let r = !U0(e);
  return t && (r || n == !1) ? B0(t, e) : e;
}
const En = (t) => t instanceof U ? { ...t } : t;
function se(t, e) {
  e = e || {};
  const n = {};
  function r(u, l, h, m) {
    return f.isPlainObject(u) && f.isPlainObject(l) ? f.merge.call({ caseless: m }, u, l) : f.isPlainObject(l) ? f.merge({}, l) : f.isArray(l) ? l.slice() : l;
  }
  function s(u, l, h, m) {
    if (f.isUndefined(l)) {
      if (!f.isUndefined(u))
        return r(void 0, u, h, m);
    } else
      return r(u, l, h, m);
  }
  function i(u, l) {
    if (!f.isUndefined(l))
      return r(void 0, l);
  }
  function o(u, l) {
    if (f.isUndefined(l)) {
      if (!f.isUndefined(u))
        return r(void 0, u);
    } else
      return r(void 0, l);
  }
  function a(u, l, h) {
    if (h in e)
      return r(u, l);
    if (h in t)
      return r(void 0, u);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (u, l, h) => s(En(u), En(l), h, !0)
  };
  return f.forEach(Object.keys(Object.assign({}, t, e)), function(l) {
    const h = c[l] || s, m = h(t[l], e[l], l);
    f.isUndefined(m) && h !== a || (n[l] = m);
  }), n;
}
const Ir = (t) => {
  const e = se({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  e.headers = o = U.from(o), e.url = Er(Mr(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let c;
  if (f.isFormData(n)) {
    if (k.hasStandardBrowserEnv || k.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((c = o.getContentType()) !== !1) {
      const [u, ...l] = c ? c.split(";").map((h) => h.trim()).filter(Boolean) : [];
      o.setContentType([u || "multipart/form-data", ...l].join("; "));
    }
  }
  if (k.hasStandardBrowserEnv && (r && f.isFunction(r) && (r = r(e)), r || r !== !1 && F0(e.url))) {
    const u = s && i && N0.read(i);
    u && o.set(s, u);
  }
  return e;
}, j0 = typeof XMLHttpRequest < "u", q0 = j0 && function(t) {
  return new Promise(function(n, r) {
    const s = Ir(t);
    let i = s.data;
    const o = U.from(s.headers).normalize();
    let { responseType: a, onUploadProgress: c, onDownloadProgress: u } = s, l, h, m, d, p;
    function g() {
      d && d(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let y = new XMLHttpRequest();
    y.open(s.method.toUpperCase(), s.url, !0), y.timeout = s.timeout;
    function w() {
      if (!y)
        return;
      const A = U.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), T = {
        data: !a || a === "text" || a === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: A,
        config: t,
        request: y
      };
      Dr(function(S) {
        n(S), g();
      }, function(S) {
        r(S), g();
      }, T), y = null;
    }
    "onloadend" in y ? y.onloadend = w : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, y.onabort = function() {
      y && (r(new b("Request aborted", b.ECONNABORTED, t, y)), y = null);
    }, y.onerror = function() {
      r(new b("Network Error", b.ERR_NETWORK, t, y)), y = null;
    }, y.ontimeout = function() {
      let I = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const T = s.transitional || kr;
      s.timeoutErrorMessage && (I = s.timeoutErrorMessage), r(new b(
        I,
        T.clarifyTimeoutError ? b.ETIMEDOUT : b.ECONNABORTED,
        t,
        y
      )), y = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in y && f.forEach(o.toJSON(), function(I, T) {
      y.setRequestHeader(T, I);
    }), f.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials), a && a !== "json" && (y.responseType = s.responseType), u && ([m, p] = Ye(u, !0), y.addEventListener("progress", m)), c && y.upload && ([h, d] = Ye(c), y.upload.addEventListener("progress", h), y.upload.addEventListener("loadend", d)), (s.cancelToken || s.signal) && (l = (A) => {
      y && (r(!A || A.type ? new de(null, t, y) : A), y.abort(), y = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const x = I0(s.url);
    if (x && k.protocols.indexOf(x) === -1) {
      r(new b("Unsupported protocol " + x + ":", b.ERR_BAD_REQUEST, t));
      return;
    }
    y.send(i || null);
  });
}, z0 = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r = new AbortController(), s;
    const i = function(u) {
      if (!s) {
        s = !0, a();
        const l = u instanceof Error ? u : this.reason;
        r.abort(l instanceof b ? l : new de(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new b(`timeout ${e} of ms exceeded`, b.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", i));
    const { signal: c } = r;
    return c.unsubscribe = () => f.asap(a), c;
  }
}, H0 = z0, V0 = function* (t, e) {
  let n = t.byteLength;
  if (!e || n < e) {
    yield t;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + e, yield t.slice(r, s), r = s;
}, W0 = async function* (t, e) {
  for await (const n of G0(t))
    yield* V0(n, e);
}, G0 = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await e.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await e.cancel();
  }
}, kn = (t, e, n, r) => {
  const s = W0(t, e);
  let i = 0, o, a = (c) => {
    o || (o = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: l } = await s.next();
        if (u) {
          a(), c.close();
          return;
        }
        let h = l.byteLength;
        if (n) {
          let m = i += h;
          n(m);
        }
        c.enqueue(new Uint8Array(l));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(c) {
      return a(c), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, ut = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Lr = ut && typeof ReadableStream == "function", X0 = ut && (typeof TextEncoder == "function" ? ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), $r = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, J0 = Lr && $r(() => {
  let t = !1;
  const e = new Request(k.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Cn = 64 * 1024, Ct = Lr && $r(() => f.isReadableStream(new Response("").body)), Ze = {
  stream: Ct && ((t) => t.body)
};
ut && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Ze[e] && (Ze[e] = f.isFunction(t[e]) ? (n) => n[e]() : (n, r) => {
      throw new b(`Response type '${e}' is not supported`, b.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const Y0 = async (t) => {
  if (t == null)
    return 0;
  if (f.isBlob(t))
    return t.size;
  if (f.isSpecCompliantForm(t))
    return (await new Request(k.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (f.isArrayBufferView(t) || f.isArrayBuffer(t))
    return t.byteLength;
  if (f.isURLSearchParams(t) && (t = t + ""), f.isString(t))
    return (await X0(t)).byteLength;
}, Z0 = async (t, e) => {
  const n = f.toFiniteNumber(t.getContentLength());
  return n ?? Y0(e);
}, K0 = ut && (async (t) => {
  let {
    url: e,
    method: n,
    data: r,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: c,
    responseType: u,
    headers: l,
    withCredentials: h = "same-origin",
    fetchOptions: m
  } = Ir(t);
  u = u ? (u + "").toLowerCase() : "text";
  let d = H0([s, i && i.toAbortSignal()], o), p;
  const g = d && d.unsubscribe && (() => {
    d.unsubscribe();
  });
  let y;
  try {
    if (c && J0 && n !== "get" && n !== "head" && (y = await Z0(l, r)) !== 0) {
      let T = new Request(e, {
        method: "POST",
        body: r,
        duplex: "half"
      }), F;
      if (f.isFormData(r) && (F = T.headers.get("content-type")) && l.setContentType(F), T.body) {
        const [S, Te] = _n(
          y,
          Ye(Tn(c))
        );
        r = kn(T.body, Cn, S, Te);
      }
    }
    f.isString(h) || (h = h ? "include" : "omit");
    const w = "credentials" in Request.prototype;
    p = new Request(e, {
      ...m,
      signal: d,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: w ? h : void 0
    });
    let x = await fetch(p);
    const A = Ct && (u === "stream" || u === "response");
    if (Ct && (a || A && g)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((nn) => {
        T[nn] = x[nn];
      });
      const F = f.toFiniteNumber(x.headers.get("content-length")), [S, Te] = a && _n(
        F,
        Ye(Tn(a), !0)
      ) || [];
      x = new Response(
        kn(x.body, Cn, S, () => {
          Te && Te(), g && g();
        }),
        T
      );
    }
    u = u || "text";
    let I = await Ze[f.findKey(Ze, u) || "text"](x, t);
    return !A && g && g(), await new Promise((T, F) => {
      Dr(T, F, {
        data: I,
        headers: U.from(x.headers),
        status: x.status,
        statusText: x.statusText,
        config: t,
        request: p
      });
    });
  } catch (w) {
    throw g && g(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new b("Network Error", b.ERR_NETWORK, t, p),
      {
        cause: w.cause || w
      }
    ) : b.from(w, w && w.code, t, p);
  }
}), Pt = {
  http: f0,
  xhr: q0,
  fetch: K0
};
f.forEach(Pt, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Pn = (t) => `- ${t}`, Q0 = (t) => f.isFunction(t) || t === null || t === !1, Fr = {
  getAdapter: (t) => {
    t = f.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, r;
    const s = {};
    for (let i = 0; i < e; i++) {
      n = t[i];
      let o;
      if (r = n, !Q0(n) && (r = Pt[(o = String(n)).toLowerCase()], r === void 0))
        throw new b(`Unknown adapter '${o}'`);
      if (r)
        break;
      s[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(s).map(
        ([a, c]) => `adapter ${a} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = e ? i.length > 1 ? `since :
` + i.map(Pn).join(`
`) : " " + Pn(i[0]) : "as no adapter specified";
      throw new b(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Pt
};
function gt(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new de(null, t);
}
function Dn(t) {
  return gt(t), t.headers = U.from(t.headers), t.data = mt.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Fr.getAdapter(t.adapter || en.adapter)(t).then(function(r) {
    return gt(t), r.data = mt.call(
      t,
      t.transformResponse,
      r
    ), r.headers = U.from(r.headers), r;
  }, function(r) {
    return Pr(r) || (gt(t), r && r.response && (r.response.data = mt.call(
      t,
      t.transformResponse,
      r.response
    ), r.response.headers = U.from(r.response.headers))), Promise.reject(r);
  });
}
const Nr = "1.8.4", lt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  lt[t] = function(r) {
    return typeof r === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Mn = {};
lt.transitional = function(e, n, r) {
  function s(i, o) {
    return "[Axios v" + Nr + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, a) => {
    if (e === !1)
      throw new b(
        s(o, " has been removed" + (n ? " in " + n : "")),
        b.ERR_DEPRECATED
      );
    return n && !Mn[o] && (Mn[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(i, o, a) : !0;
  };
};
lt.spelling = function(e) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${e}`), !0);
};
function e1(t, e, n) {
  if (typeof t != "object")
    throw new b("options must be an object", b.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], c = a === void 0 || o(a, i, t);
      if (c !== !0)
        throw new b("option " + i + " must be " + c, b.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new b("Unknown option " + i, b.ERR_BAD_OPTION);
  }
}
const Fe = {
  assertOptions: e1,
  validators: lt
}, j = Fe.validators;
class Ke {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new vn(),
      response: new vn()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = se(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && Fe.assertOptions(r, {
      silentJSONParsing: j.transitional(j.boolean),
      forcedJSONParsing: j.transitional(j.boolean),
      clarifyTimeoutError: j.transitional(j.boolean)
    }, !1), s != null && (f.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : Fe.assertOptions(s, {
      encode: j.function,
      serialize: j.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Fe.assertOptions(n, {
      baseUrl: j.spelling("baseURL"),
      withXsrfToken: j.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && f.merge(
      i.common,
      i[n.method]
    );
    i && f.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), n.headers = U.concat(o, i);
    const a = [];
    let c = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(n) === !1 || (c = c && g.synchronous, a.unshift(g.fulfilled, g.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(g) {
      u.push(g.fulfilled, g.rejected);
    });
    let l, h = 0, m;
    if (!c) {
      const p = [Dn.bind(this), void 0];
      for (p.unshift.apply(p, a), p.push.apply(p, u), m = p.length, l = Promise.resolve(n); h < m; )
        l = l.then(p[h++], p[h++]);
      return l;
    }
    m = a.length;
    let d = n;
    for (h = 0; h < m; ) {
      const p = a[h++], g = a[h++];
      try {
        d = p(d);
      } catch (y) {
        g.call(this, y);
        break;
      }
    }
    try {
      l = Dn.call(this, d);
    } catch (p) {
      return Promise.reject(p);
    }
    for (h = 0, m = u.length; h < m; )
      l = l.then(u[h++], u[h++]);
    return l;
  }
  getUri(e) {
    e = se(this.defaults, e);
    const n = Mr(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Er(n, e.params, e.paramsSerializer);
  }
}
f.forEach(["delete", "get", "head", "options"], function(e) {
  Ke.prototype[e] = function(n, r) {
    return this.request(se(r || {}, {
      method: e,
      url: n,
      data: (r || {}).data
    }));
  };
});
f.forEach(["post", "put", "patch"], function(e) {
  function n(r) {
    return function(i, o, a) {
      return this.request(se(a || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  Ke.prototype[e] = n(), Ke.prototype[e + "Form"] = n(!0);
});
const Ne = Ke;
class tn {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(i, o, a) {
      r.reason || (r.reason = new de(i, o, a), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new tn(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
const t1 = tn;
function n1(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function r1(t) {
  return f.isObject(t) && t.isAxiosError === !0;
}
const Dt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Dt).forEach(([t, e]) => {
  Dt[e] = t;
});
const s1 = Dt;
function Ur(t) {
  const e = new Ne(t), n = yr(Ne.prototype.request, e);
  return f.extend(n, Ne.prototype, e, { allOwnKeys: !0 }), f.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(s) {
    return Ur(se(t, s));
  }, n;
}
const v = Ur(en);
v.Axios = Ne;
v.CanceledError = de;
v.CancelToken = t1;
v.isCancel = Pr;
v.VERSION = Nr;
v.toFormData = at;
v.AxiosError = b;
v.Cancel = v.CanceledError;
v.all = function(e) {
  return Promise.all(e);
};
v.spread = n1;
v.isAxiosError = r1;
v.mergeConfig = se;
v.AxiosHeaders = U;
v.formToJSON = (t) => Cr(f.isHTMLForm(t) ? new FormData(t) : t);
v.getAdapter = Fr.getAdapter;
v.HttpStatusCode = s1;
v.default = v;
const i1 = v;
class Zl {
  instance;
  canceler;
  retryCount = 0;
  cacheTime = 0;
  caches = new rt();
  constructor(e) {
    this.instance = i1.create(e), this.canceler = new o1(), this.retryCount = e?.retry || 0, this.cacheTime = e?.cache || 0, this.instance.interceptors.request.use(
      (n) => (e?.interceptor?.start?.(), this.canceler.pendingRequest(n), e?.interceptor?.request?.(n), n),
      (n) => (e?.interceptor?.end?.(), this.canceler.cancelRequest(n.config), e?.interceptor?.requestError?.(n), Promise.reject(n))
    ), this.instance.interceptors.response.use(
      (n) => (e?.interceptor?.end?.(), this.canceler.confirmRequest(n.config), e?.interceptor?.response?.(n), n.status == 200 ? Promise.resolve(n) : Promise.reject(n)),
      (n) => (e?.interceptor?.end?.(), this.canceler.cancelRequest(n.config), e?.interceptor?.responseError?.(n), Promise.reject(n.response))
    );
  }
  // @CacheDecorator(60)
  // @RetryDecorator(3)
  request(e) {
    let n = this.instance.request;
    const r = e.retry || this.retryCount;
    r && (n = Kn(n, r));
    const s = e.cache || this.cacheTime;
    return s && (n = Qn(n, s, this.caches)), n(e);
  }
  // this.request() 请求后未返回前，可取消请求
  cancel(e) {
    this.canceler.cancelRequest(e);
  }
  get(e, n) {
    return this.request({ ...n, method: "get", url: e });
  }
  delete(e, n) {
    return this.request({ ...n, method: "delete", url: e });
  }
  head(e, n) {
    return this.request({ ...n, method: "head", url: e });
  }
  options(e, n) {
    return this.request({ ...n, method: "options", url: e });
  }
  post(e, n, r) {
    return this.request({ ...r, method: "post", url: e, data: n });
  }
  postBlob(e, n, r) {
    return r = {
      ...r,
      headers: {
        ...r?.headers,
        "Content-Type": "multipart/form-data"
      }
    }, this.request({ ...r, method: "post", url: e, data: n });
  }
  // UNDO : application/octet-stream
  postForm(e, n, r) {
    return this.instance.postForm(e, n, { ...r });
  }
  put(e, n, r) {
    return this.request({ ...r, method: "put", url: e, data: n });
  }
  patch(e, n, r) {
    return this.request({ ...r, method: "patch", url: e, data: n });
  }
  getUri(e) {
    return this.instance.getUri(e);
  }
}
class o1 {
  pendingRequestMap;
  constructor() {
    this.pendingRequestMap = /* @__PURE__ */ new Map();
  }
  getRequestId(e) {
    const { method: n, url: r, params: s, data: i } = e;
    return $t({ method: n, url: r, params: s, data: i });
  }
  pendingRequest(e) {
    const n = this.getRequestId(e);
    if (this.pendingRequestMap.has(n))
      e.signal = this.pendingRequestMap.get(n)?.signal;
    else {
      const r = new AbortController();
      e.signal = r.signal, this.pendingRequestMap.set(n, r);
    }
  }
  confirmRequest(e) {
    if (this.pendingRequestMap.size === 0)
      return;
    const n = this.getRequestId(e);
    this.pendingRequestMap.has(n) && this.pendingRequestMap.delete(n);
  }
  cancelRequest(e) {
    if (this.pendingRequestMap.size === 0)
      return;
    const n = this.getRequestId(e);
    this.pendingRequestMap.has(n) && (this.pendingRequestMap.get(n)?.abort(), this.pendingRequestMap.delete(n));
  }
  cancelAllRequest() {
    const e = this.pendingRequestMap.values();
    for (const n of e)
      n.abort();
    this.pendingRequestMap.clear();
  }
}
export {
  Xr as AlgorithmEnum,
  zu as AuthenticatableDecorator,
  Hu as AuthorizeDecorator,
  nt as BasicHeap,
  a2 as BigIntSupported,
  ul as BinarySearch,
  Y2 as BinarySearchTree,
  ye as BinaryTreeNode,
  sl as BubbleSort,
  c1 as CSSAnimationNames,
  rt as Cache,
  Qu as CacheDecorator,
  Jr as CipherEnum,
  ro as CommandInvoker,
  nl as ConfigurableDecorator,
  N2 as CreateValidator,
  Zu as DebounceDecorator,
  Ji as Dep,
  Jl as DeriveWorker,
  Pl as DialogSchedule,
  pl as DiffArray,
  q as DomMatrix,
  O as DomPoint,
  Ia as EPSILON,
  Ue as EncodeEnum,
  on as EntryHashCache,
  St as EntryListCache,
  p2 as EntryMapCache,
  m2 as EntryStack,
  Jn as Enum,
  rl as EnumerableDecorator,
  Uu as EventBus,
  Zl as FetchWithAxios,
  Z2 as Graph,
  je as GraphEdge,
  qt as GraphNode,
  au as HashObject,
  ou as HashTable,
  un as HashTableOverflow,
  cl as HeapSort,
  Lu as HttpError,
  ol as InsertSort,
  hl as LRUCacheUseLinkedList,
  fl as LRUCacheUseMap,
  si as LinkedList,
  zt as ListNode,
  Gu as LogExecuteResultDecorator,
  Xu as LogExecuteTimeDecorator,
  Da as MAX_SAFE_INTEGER,
  W as MIMEEnum,
  Ma as MIN_SAFE_INTEGER,
  Q2 as MaxHeap,
  Wu as MaxLengthDecorator,
  gl as MementoCaretaker,
  ml as MementoOriginator,
  el as MemorizeDecorator,
  yn as MergeSort,
  gn as MergeSort2,
  eu as MinHeap,
  Vu as MinLengthDecorator,
  Bt as ONE_DAY_TIMESTAMP,
  dl as PrefixSumArray,
  K2 as PriorityQueue,
  Ju as ProfileDecorator,
  Cl as PromiseSchedule,
  Re as Queue,
  H as QueueOverflow,
  ll as QuickSearch,
  wn as QuickSort,
  bn as QuickSort2,
  no as QuickSort_partition,
  Gr as ReadInBrowserEnum,
  tl as ReadonlyDecorator,
  Ku as RetryDecorator,
  ae as SYMBOL_META,
  ge as SYMBOL_TIMESTAMP,
  yl as SaveCommand,
  bo as Schedule,
  pr as ScheduleDependOnResult,
  il as SelectSort,
  al as ShellSort,
  qu as SingletonDecorator,
  iu as Stack,
  Il as StreamUsedMessageChannel,
  jl as Subject,
  c2 as SymbolSupported,
  Sn as ThreeWayQuickSort,
  Yu as ThrottleDecorator,
  wl as UndoCommand,
  W1 as _instanceof,
  Ua as add,
  dc as addArrayItem,
  $s as addMapEntry,
  Fs as addSetEntry,
  Oo as appendURL,
  Vl as appendURLRecord,
  vc as appendUniqueArray,
  Fl as applyMiddleware,
  j1 as arrayBufferToDataView,
  q1 as arrayBufferToTypedArray,
  oc as arrayEach,
  Dc as arrayNeedsUint32,
  gu as assoc,
  ke as assocIndexOf,
  Xn as atob,
  Fa as average,
  Ws as base64URLDecode,
  Vs as base64URLEncode,
  to as bd09_to_gcj02,
  ju as bd09_to_wgs84,
  Oa as bind,
  va as bindObjectThis,
  Xs as btoa,
  Qn as cache,
  d2 as canUseBitmap,
  Ls as canUseWorker,
  Ol as cancelablePromise,
  R1 as capitalize,
  Rl as chainPromise,
  Mc as changeTimeZone,
  y1 as charAt,
  ce as clamp,
  ga as classMixin,
  hc as clearArray,
  Ea as clearObject,
  Nt as cloneArrayBuffer,
  Sa as cloneAsPrototype,
  H1 as cloneDataView,
  sc as cloneFill2DArray,
  y2 as cloneMap,
  Zr as cloneRegExp,
  b2 as cloneSet,
  ea as cloneSymbol,
  V1 as cloneTypedArray,
  uu as closeLog,
  $l as combineReducers,
  h2 as compareVersion,
  fi as compose,
  z1 as concateTypedArray,
  vu as conditional,
  Hc as copyTime,
  j2 as createCommonDateValidator,
  z2 as createCommonDatetimeValidator,
  U2 as createCommonEmailValidator,
  W2 as createCommonEnumValidator,
  V2 as createCommonLengthValidator,
  H2 as createCommonNumberValidator,
  B2 as createCommonPhoneValidator,
  q2 as createCommonTimeValidator,
  ru as createDroppingRingQueue,
  ec as createEmptyArray,
  ii as createExpandingRingQueue,
  nu as createFixedRingQueue,
  Za as createNextInt,
  tu as createNoneRingQueue,
  su as createSlidingRingQueue,
  So as createStore,
  Lt as createSymbol,
  dr as createTask,
  li as curry,
  Pu as customDelay,
  ei as dateValidate,
  ni as datetimeValidate,
  Qc as dayOfYear,
  ui as debounce,
  Wa as decimalNumber,
  zc as decreaseTime,
  te as deepClone,
  jn as deepDiff,
  gs as deepEqual,
  go as deferred,
  _l as delayAsync,
  Tl as delaySync,
  pc as deleteArrayItem,
  Qa as denormalize,
  sn as diffDays,
  Cu as discardOddDoubleEven,
  Ks as emailValidate,
  ri as enumValidate,
  ms as eq,
  fu as errorLog,
  ja as euclideanModulo,
  Ul as exceptionLoggerMiddleware,
  Bl as executeTimeLoggerMiddleware,
  xs as extractAllNumbers,
  Xa as extractNumber,
  Os as fill2DArray,
  rc as fillArray,
  nc as fillArrayIterate,
  _a as filterObject,
  uc as first,
  b1 as fixChineseCompanyName,
  w1 as fixChineseTaxNo,
  S1 as fixEmail,
  zn as fixedDotNumberString,
  Va as fixedNumberString,
  yc as flattenArray,
  Es as flattenArray2,
  ks as flattenArray3,
  wc as flattenArray4,
  bc as flattenArray5,
  Sc as flattenArray6,
  xc as flattenArray7,
  Ts as flushArray,
  Hl as flushURLRecord,
  Ao as flushURLSearch,
  Xl as formDataToSearch,
  ve as format,
  Xc as formatDate,
  Zc as formatDateTime,
  G2 as formatDistance,
  X2 as formatMoney,
  Ga as formatNumber,
  Gc as formatPreset,
  Jc as formatTime,
  Yc as formatTime2,
  $c as formatTimeOverflow,
  Fc as formatTimeOverflowChinese,
  ps as freeze,
  ma as functionMixin,
  bl as gb32100_2015,
  fo as gbt11714,
  eo as gcj02_to_bd09,
  Qi as gcj02_to_wgs84,
  x1 as generateUUID,
  Rs as get2DArrayColumn,
  vs as get2DArrayRow,
  ic as get2DArrayRowColumn,
  A2 as getArrayBufferFromByteArray,
  v2 as getArrayBufferFromHexString,
  O2 as getArrayBufferFromNumber,
  Hs as getArrayBufferFromString,
  Bs as getByteArrayFromArrayBuffer,
  qs as getByteArrayFromHexString,
  js as getByteArrayFromNumber,
  zs as getByteArrayFromString,
  s2 as getCalendarPageItems,
  x2 as getCodePointArrayFromString,
  vo as getCrossOriginWorkerURL,
  pe as getDateDetail,
  ie as getDefinedRegExpPattern,
  V as getDegree,
  Cc as getDifferenceArray,
  Pc as getDifferenceSet,
  M2 as getFileTypeFromArrayBuffer,
  Ms as getFirstTimestampOfMonth,
  e2 as getFirstTimestampOfNextMonth,
  jr as getGlobal,
  T2 as getHexNumber,
  E2 as getHexString,
  Tc as getIntersectArray,
  kc as getIntersectArrayUseMap,
  Ec as getIntersectSet,
  Ps as getLastDayOfMonth,
  Ds as getLastTimestampOfMonth,
  t2 as getLastTimestampOfPrevMonth,
  cc as getMiddleValue,
  Ca as getNestedValue,
  ws as getNextPrime,
  Ee as getNthDay,
  r2 as getNthMonth,
  n2 as getNthMonthNotGood,
  ha as getOwnPropertyDescriptors,
  Yr as getRegExpFlags,
  hi as getRetryDelay,
  Me as getSecondsFromTimeOverlow,
  ka as getSortedObjectString,
  Gs as getString,
  k2 as getStringFromArrayBuffer,
  C2 as getStringFromArrayBuffer2,
  P2 as getStringFromBase64,
  Y as getTag,
  G1 as getType,
  B1 as getTypedArrayType,
  mr as getURL,
  I2 as getUint64,
  L2 as getUint64BigInt,
  S2 as getUint8ArrayFromString,
  m1 as getUnicodeLengthES5,
  Rc as getUnionArray,
  _c as getUnionSet,
  Oc as getUniqueArray,
  ln as groupLog,
  u2 as hasDocument,
  f2 as hasHistory,
  da as hasProperty,
  zr as hasSymbol,
  l2 as hasWindow,
  hu as identity,
  fc as includes,
  qc as increaseTime,
  xa as inheritPrototype,
  $1 as is32BitString,
  $ as isArray,
  es as isArrayBufferView,
  gc as isArrayEqual,
  na as isArrayLike,
  mc as isArrayNotEmpty,
  Z1 as isBoolean,
  Is as isBrowser,
  ya as isCloneable,
  N as isDateValid,
  ia as isDescriptor,
  oa as isEmptyObject,
  Iu as isErrorType,
  $a as isEven,
  re as isFunction,
  ca as isGenerator,
  Cs as isInArray,
  Wc as isInDays,
  Vc as isInTime,
  ua as isIterable,
  hs as isIterator,
  D as isJustObject,
  fs as isKeyable,
  jt as isLittleEndian,
  qn as isNaN,
  ft as isNative,
  ls as isNativeFunction,
  tc as isNotEmptyArray,
  Y1 as isNotOK,
  J1 as isNull,
  K1 as isNumber,
  Q1 as isNumeric,
  as as isOK,
  Ae as isObject,
  J as isObjectLike,
  ra as isPlainObject,
  ys as isPrime,
  Ut as isPrimitive,
  aa as isPromise,
  sa as isPrototype,
  La as isReallyNaN,
  xo as isSameOriginURL,
  o2 as isServer,
  cs as isString,
  ta as isStringableFunction,
  us as isSymbol,
  Mt as isSymbolString,
  Vn as isTimestampInMilliSeconds,
  Lc as isTimestampInSeconds,
  ts as isTypedArray,
  ql as isURL,
  X1 as isUndefined,
  Kc as isWeekend,
  mu as kDone,
  pu as kFalse,
  du as kTrue,
  Yn as konst,
  lc as last,
  Zs as lengthValidate,
  Ss as lerp,
  za as lerpMap,
  qa as lerps,
  R as log,
  Kr as lowercaseFirst,
  Eu as map,
  an as mapToArray,
  K as maxDotNumber,
  F2 as maxLengthValidate,
  Ys as maxValidate,
  di as memorize,
  De as mergeObject,
  ds as mergeObjectDeep,
  Qe as meta,
  Ml as microTask,
  X as milliseconds,
  $2 as minLengthValidate,
  Js as minValidate,
  g2 as nativeMap,
  w2 as nativeSet,
  ba as newConstructor,
  Dl as nextTick,
  ai as noop,
  Ka as normalize,
  oe as notEmptyValidate,
  Be as now,
  Ns as numberToRadixString,
  fa as objectEntries,
  Oe as objectKeys,
  $t as objectSignature,
  la as objectValues,
  Au as once,
  cu as openLog,
  Ll as operationParser,
  cr as out_of_china,
  R2 as pack,
  P1 as padString,
  Vr as parse,
  tt as parseDate,
  G as parseNumber,
  a1 as parseObjectSignature,
  Na as parseRelativeNumber,
  Nc as parseTime,
  Bc as parseTimeFromArray,
  Uc as parseTimeFromDate,
  jc as parseTimeFromDateDiff,
  Du as pausable$,
  Qs as phoneValidate,
  Ta as pick,
  yu as pipe,
  wu as pipeCallback,
  Yl as polar,
  ac as popToTopInArray,
  fn as profileLog,
  Mu as prop$,
  Us as radixStringToNumber,
  Ja as randomDirection,
  As as randomFloat,
  Ya as randomInt,
  A1 as randomLetter,
  In as randomString,
  v1 as raw,
  Zi as reactive,
  We as reactiveVue2,
  ar as reactiveVue3,
  J2 as readStream,
  Ic as readableTimestamp,
  gr as recordToSearch,
  ku as reduce,
  Nu as ref,
  h1 as regExec,
  Ft as regMatch,
  f1 as regMatchAll,
  u1 as regSearchIndex,
  l1 as regSplit,
  xe as regTest,
  D1 as repeatString,
  wt as replaceSymbol,
  bt as restoreSymbol,
  Kn as retry,
  xu as reverseArgs,
  L1 as reverseString,
  E as root,
  Ba as round,
  kl as runAsyncChain,
  El as runAsyncWithTimeout,
  Sl as runGenerator,
  Z as runValidates,
  Wl as searchToRecord,
  Gl as searchToRecord2,
  lu as setLogUploadFn,
  Pa as setNestedValue,
  Aa as setProtoOf,
  cn as setToArray,
  wa as shallowClone,
  Ac as shuffleArray,
  pa as shuffleObject,
  g1 as sliceByCodePoints,
  _o as splitTransformString,
  Nl as stateLoggerMiddleware,
  Ha as stepMap,
  U1 as stringByteSize,
  Q as stringLength,
  d1 as stringLength2,
  p1 as stringLength3,
  O1 as stringReplace,
  Hr as stringify,
  Ra as subtractObject,
  _s as swapArrayValue,
  Su as tco,
  ci as throttle,
  Al as thunkToPromise,
  xl as thunkify,
  qe as timeLog,
  ti as timeValidate,
  vl as timeoutLimitPromise,
  et as toArrayBuffer,
  D2 as toBlob,
  T1 as toCamel,
  z as toDegree,
  Bn as toFunctionString,
  _1 as toKebab,
  L as toObjectString,
  Qr as toPascal,
  Ro as toRadian,
  Fu as toValue,
  _u as trace,
  bu as trampoline,
  Tu as transformUnaryArg,
  E1 as trim,
  zl as trimHash,
  C1 as trimScopedCSS,
  k1 as trimSpecial,
  M1 as truncateString,
  I1 as truncateStringInMiddle,
  Ru as tryCatch,
  Ou as tryEach,
  rn as tryToSymbol,
  _2 as unpack,
  i2 as useTimestampValue,
  F1 as utf16to8,
  N1 as utf8to16,
  oi as warnLog,
  $u as watchEffect,
  Bu as wgs84_to_bd09,
  Ki as wgs84_to_gcj02,
  bs as withinErrorMarginNumber
};
//# sourceMappingURL=zyzgroup_core_common.js.map
